import { resolveMediaUrl, resolveMediaCssUrl } from '../../../common/mediaUrl';
import React, { useState, useEffect, useLayoutEffect, useCallback, useMemo, useRef } from "react";
import { useParams, useNavigate, json } from "react-router-dom";
// ... other imports
import "./styles/style.css";
// import Config from './Config';
import Svg from "../../../common/Svg";
import { Link } from "react-router-dom";
import { FieldLabel, DropZone } from "@measured/puck";
import ReactEcharts from "echarts-for-react";
import Range from "./Range";
import { Render } from "@measured/puck";
import { ToastContainer, toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import logo_fallback from "../../../assets/images/logo-fallback.svg";
import { rewriteRoiAssetUrls } from "../../../utils/rewriteRoiAssetUrls";

/** US-style digit grouping (e.g. 1,234,567) for currency and totals */
const ROI_NUMBER_LOCALE = "en-US";

/** No .00 on whole amounts; up to 2 decimals when the value has a fractional part */
function roiAmountLocaleOptions(n) {
  if (!Number.isFinite(n)) {
    return { minimumFractionDigits: 0, maximumFractionDigits: 2 };
  }
  const whole =
    Number.isInteger(n) || Math.abs(n - Math.round(n)) < 1e-9;
  return {
    minimumFractionDigits: 0,
    maximumFractionDigits: whole ? 0 : 2,
  };
}

function roiFormatGroupedAmount(n) {
  if (!Number.isFinite(n)) return "";
  return n.toLocaleString(ROI_NUMBER_LOCALE, {
    ...roiAmountLocaleOptions(n),
    useGrouping: true,
  });
}

/** Strip thousands separators from numeric input (commas only; trim). */
function roiParseNumericInputString(raw) {
  if (raw == null) return "";
  return String(raw).replace(/,/g, "").trim();
}

/**
 * If the string is a plain number (optionally with grouping commas), return
 * ungrouped canonical digits; otherwise return the original string.
 */
function roiNormalizeCommaNumericInput(raw) {
  const s = String(raw);
  const stripped = roiParseNumericInputString(s);
  if (/^-?\d+(\.\d+)?$/.test(stripped)) return stripped;
  return s;
}

/**
 * Add US-style digit grouping for £ / $ / € amounts in a string.
 * Handles whole-string amounts, optional Unicode pound (U+00A3), and embedded
 * ungrouped runs (e.g. inside HTML). Skips values that already look US-grouped.
 */
function formatRoiCurrencyDescription(text) {
  if (text == null || typeof text !== "string") return text;
  const s = text
    .replace(/&#36;|&#[xX]24;|&dollar;/gi, "")
    .trim();
  if (!s) return text;

  const symClass = "[\u00A3£$€]";
  const usGroupedBody = /^-?\d{1,3}(?:,\d{3})*(?:\.\d+)?$/;

  const whole = s.match(
    new RegExp(`^(${symClass})\\s*([-]?\\d{1,3}(?:,\\d{3})*(?:\\.\\d+)?|-?\\d+(?:\\.\\d+)?)$`)
  );
  if (whole) {
    const body = whole[2].replace(/,/g, "");
    const n = parseFloat(body);
    if (!Number.isFinite(n)) return text;
    if (whole[2].includes(",") && !usGroupedBody.test(whole[2].replace(/\s/g, "")))
      return text;
    const formatted = n.toLocaleString(ROI_NUMBER_LOCALE, roiAmountLocaleOptions(n));
    const sym = whole[1];
    if (sym === "$" || sym === "\u0024") return formatted;
    return sym + formatted;
  }

  return s.replace(
    new RegExp(`(${symClass})\\s*(\\d{4,})(\\.\\d+)?(?!\\d)`, "g"),
    (match, sym, intPart, dec) => {
      const numStr = intPart + (dec || "");
      const n = parseFloat(numStr);
      if (!Number.isFinite(n)) return match;
      const formatted = n.toLocaleString(ROI_NUMBER_LOCALE, roiAmountLocaleOptions(n));
      if (sym === "$" || sym === "\u0024") return formatted;
      return sym + formatted;
    }
  );
}

const USER_DETAILS_FORM_ID = "userDetailsForm";

/** Read name + organisation from inputs inside #userDetailsForm (1st = name, 2nd = organisation). */
const readUserDetailsFormValuesFromDom = () => {
  const form = document.getElementById(USER_DETAILS_FORM_ID);
  if (!form) return { name: "", organisation: "" };

  const values = Array.from(
    form.querySelectorAll(
      'input:not([type="checkbox"]):not([type="radio"]):not([type="hidden"]), textarea, select'
    )
  )
    .map((input) => String(input.value || "").trim())
    .filter(Boolean);

  return {
    name: values[0] || "",
    organisation: values[1] || "",
  };
};

const ROIPage = () => {
  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_URL;
  const frntUrl = process.env.REACT_APP_FRONT_LINK;
  const { roiId } = useParams();
  const [isIdPresent, setIsIdPresent] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [renderData, setRenderData] = useState(null);
  const [renderModalData, setRenderModalData] = useState(null);
  const [roiPageData, setRoiPageData] = useState(null);
  const [condtionValues, setCondtionValues] = useState([]);
  const [actionId, setActionId] = useState([]);
  //all condtions and actions data
  // const [allCondtionalLogicData, setAllConditionalLogicData] = useState([]);
  const allCondtionalLogicData = useRef([]);
  const [allActionData, setAllActionData] = useState([]);
  // const [currentPageId, setCurrentPageId] = useState(null);
  const currentPageId = useRef(null);
  const [currentPopupPageId, setCurrentPopupPageId] = useState("");
  const [popupStatus, setPopupStatus] = useState(false);
  // const [roipages, setRoipages] = useState({});
  const roipages = useRef({});
  const [roiVariableData, setRoiVaiableData] = useState({});
  // const [roiActionArr, setRoiActionArr] = useState({});
  const roiActionArr_global = useRef({});
  const [roiFlag, setRoiFlag] = useState(false);
  const [language, setLanguage] = useState("");
  const [currency, setCurrency] = useState([]);
  const [defaultCurrency, setDefaultCurrency] = useState("");
  const [changedCurrency, setChangedCurrency] = useState("");
  const [currencySymbol, setCurrencySymbol] = useState("");
  const [exchangeRate, setExchangeRate] = useState("");
  const [locale, setLocale] = useState("");
  // const [globalRoiArr, setGlobalRoiArr] = useState([]);
  const globalRoiArr = useRef([]);
  const elements_by_page_id = useRef({});
  const [changedDropdown, setChangedDropdown] = useState({});
  const [isLoadingdownload, setIsLoadingdownload] = useState(false);
  const [handleModal, setHandleModal] = useState(false);
  const [acceptDecimals, setAcceptDecimals] = useState(false);
  const scrollAfterRender = useRef(false);
  const savedScrollY = useRef(0);

  // State to control which modal is open (by modalId)
  const [openModalId, setOpenModalId] = useState(null);
  /** Cached name/org from #userDetailsForm (used when modal is not in DOM on report download). */
  const userDetailsReportSnapshotRef = useRef({ name: "", organisation: "" });

  // Focus management for tab index
  const [focusedInputId, setFocusedInputId] = useState(null);
  const [pendingChanges, setPendingChanges] = useState({});
  const [isProcessingChanges, setIsProcessingChanges] = useState(false);

  const CurrencyFormatter = ({ amount }) => {
    const n = typeof amount === "number" ? amount : parseFloat(amount);
    if (!Number.isFinite(n)) return "";
    return roiFormatGroupedAmount(n);
  };

  /** Display value for Text dynamic spans: currency strings, plain numbers, or passthrough */
  const formatRoiFieldDisplayValue = (raw) => {
    if (raw === undefined || raw === null) return "";
    const formatPlainNumber = (n) => {
      if (!Number.isFinite(n)) return "";
      const moneyLike = n % 1 !== 0 || Math.abs(n) >= 10000;
      if (moneyLike) {
        return roiFormatGroupedAmount(n);
      }
      return n.toLocaleString(ROI_NUMBER_LOCALE, {
        maximumFractionDigits: n % 1 ? 2 : 0,
        minimumFractionDigits: 0,
      });
    };
    if (typeof raw === "number" && Number.isFinite(raw)) {
      return formatPlainNumber(raw);
    }
    const s = String(raw).trim();
    if (!s) return "";
    if (/%\s*$/.test(s)) return s;
    const asCurrencyStr = formatRoiCurrencyDescription(s);
    if (asCurrencyStr !== s) return asCurrencyStr;
    const stripped = s.replace(/,/g, "");
    if (/^-?\d+(\.\d+)?$/.test(stripped)) {
      const n = parseFloat(stripped);
      return formatPlainNumber(n) || s;
    }
    return s;
  };

  /*****Year and VBUC******/
  const [selectedCompany, setSelectedCompany] = useState("vbuc");
  const [selectedYear, setSelectedYear] = useState("year1");

  const handleCompanyChange = (e) => {
    setSelectedCompany(e.target.value);
  };

  const handleYearChange = (e) => {
    setSelectedYear(e.target.value);
  };

  // const getDataSection = () => {
  //     if (selectedCompany === 'vbuc' && selectedYear === 'year1') {
  //         return <ReactEcharts style={chartStyle} option={pieChart()} />;
  //     }
  //     if (selectedCompany === 'vbuc' && selectedYear === 'year3') {
  //         return <ReactEcharts style={chartStyle} option={VBUCYear3Options} />;
  //     }
  //     if (selectedCompany === 'microsoft' && selectedYear === 'year1') {
  //         return <ReactEcharts style={chartStyle} option={MicrosoftYear1Options} />;
  //     }
  //     if (selectedCompany === 'microsoft' && selectedYear === 'year3') {
  //         return <ReactEcharts style={chartStyle} option={MicrosoftYear3Options} />;
  //     }
  // };

  const pieChart = (items) => {

    // Transform items to match the required series data format
    const seriesData = items.map((item) => ({
      value: parseFloat(item.value), // Convert value to a number if it's a string
      name: item.Text,
      symbol: currencySymbol,
      formatted: CurrencyFormatter({ amount: parseFloat(item.value) }),
    }));

    // Extract colors from items
    const colors = items.map((item) => item.Color);

    return {
      tooltip: {
        trigger: "item",

        formatter: function (params) {
          return `${params.seriesName}<br />
                        ${params.data.name}:  ${params.data.formatted} `;
        },
      },
      grid: {
        left: "30%",
        right: "4%",
        bottom: "10%",
        containLabel: true,
      },
      series: [
        {
          name: "Cost savings over yearly vs average",
          type: "pie",
          radius: "80%",
          color: colors, // Use the extracted colors
          data: seriesData,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
        },
      ],
    };
  };

  const pieEChart = (items, title, subtext) => {
    // Special styling for roiId c51d1af0-0099-11ef-8e49-4bdeaebfbca1
    const isSpecialRoi = roiId === 'c51d1af0-0099-11ef-8e49-4bdeaebfbca1';

    let totalValue = 0;
    for (let i = 0; i < items.length; i++) {
      totalValue += parseFloat(items[i].value);
    }

    // Format the total value for display
    const formattedTotal =
      totalValue >= 1000000
        ? (totalValue / 1000000).toLocaleString(ROI_NUMBER_LOCALE, {
            ...roiAmountLocaleOptions(totalValue / 1000000),
          }) + "M"
        : totalValue >= 1000
          ? (totalValue / 1000).toLocaleString(ROI_NUMBER_LOCALE, {
              minimumFractionDigits: 0,
              maximumFractionDigits:
                Number.isInteger(totalValue / 1000) ||
                Math.abs(totalValue / 1000 - Math.round(totalValue / 1000)) < 1e-9
                  ? 0
                  : 1,
            }) + "K"
          : totalValue.toLocaleString(ROI_NUMBER_LOCALE, roiAmountLocaleOptions(totalValue));

    // Transform items to match the required series data format
    const seriesData = items.map((item) => ({
      value: parseFloat(item.value), // Convert value to a number if it's a string
      name: item.Text,
      symbol: currencySymbol,
      formatted: CurrencyFormatter({ amount: parseFloat(item.value) }),
    }));

    // Extract colors from items
    const colors = items.map((item) => item.Color);
    const legend = items.map((item) => item.Text);

    return {
      tooltip: {
        trigger: "item",
        formatter: "{b}: {c} ({d}%)", // Shows name, value, and percentage
      },
      legend: {
        orient: "horizontal",
        left: "center",
        bottom: isSpecialRoi ? "5%" : "0", // Adjust as needed for vertical position
        data: legend, // Matches the names in series.data
        itemGap: isSpecialRoi ? 15 : 20, // Reduced space between legend items
        itemWidth: 12,
        itemHeight: 12,
        textStyle: {
          fontSize: isSpecialRoi ? 10 : 11,
        },
      },
      // title is used for the text in the center of the donut
      title: {
        text: title, // The label text (e.g., "First Year")
        subtext: formattedTotal, // Formatted total value
        left: "center",
        top: isSpecialRoi ? "38%" : "35%", // Adjusted position

        textStyle: {
          fontSize: isSpecialRoi ? 11 : 12, // Smaller font for title
          fontWeight: "normal",
          color: "#666",
        },
        subtextStyle: {
          fontSize: isSpecialRoi ? 14 : 18, // Reduced font size for the value
          fontWeight: "bold",
          color: "#333",
        },
      },
      series: [
        {
          type: "pie",
          // To make it a donut chart, radius is an array: [innerRadius, outerRadius]
          radius: isSpecialRoi ? ["30%", "55%"] : ["35%", "65%"], // Adjusted for better spacing
          center: isSpecialRoi ? ["50%", "42%"] : ["50%", "45%"], // Moved up slightly to make room for legend
          avoidLabelOverlap: true, // Avoid label overlap
          color: colors,
          data: seriesData,
          label: {
            show: true,
            position: "outside",
            formatter: function (params) {
              // Format large numbers
              const val = params.value;
              if (val >= 1000000) return (val / 1000000).toFixed(1) + 'M';
              if (val >= 1000) return (val / 1000).toFixed(0) + 'K';
              return val.toFixed(0);
            },
            color: "#333",
            fontSize: isSpecialRoi ? 9 : 10,
            distanceToLabelLine: isSpecialRoi ? 1 : 2,
          },
          labelLine: {
            show: true,
            length: isSpecialRoi ? 5 : 8, // Shorter line
            length2: isSpecialRoi ? 3 : 5,
            smooth: false,
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.3)",
            },
            label: {
              show: true,
              fontSize: "12",
              fontWeight: "bold",
            },
          },
        },
      ],
      grid: {
        left: "5%",
        right: "5%",
        bottom: isSpecialRoi ? "25%" : "20%", // More space for legend
        top: "5%",
        containLabel: true,
      },
    };
  };


  const barEChart = (items, title, subtext) => {
    // Prepare series
    const series = items.map((item) => ({
      name: item.Text,
      type: "bar",
      barWidth: 40, // Match BarChartOptions
      data: [parseFloat(item.value)], // Single value per series
      itemStyle: {
        color: item.Color,
        borderRadius: [5, 5, 0, 0], // Match BarChartOptions
      },
      emphasis: { focus: "series" },
      label: {
        show: true,
        position: "top",
        formatter: "{c}",
        color: "#333",
        fontSize: 12,
      },
    }));

    const legend = items.map((item) => item.Text);

    return {
      tooltip: {
        trigger: "axis",
        axisPointer: { type: "shadow" },
        // Optionally, use the same formatter as BarChartOptions
      },
      legend: {
        show: true,
        data: legend,
        bottom: "0",
        left: "center",
        itemGap: 15,
        itemWidth: 12,
        itemHeight: 12,
        icon: "circle",
        textStyle: {
          color: "#595959",
          fontSize: 13,
        },
      },
      grid: {
        left: "3%",
        top: "10%",
        right: "4%",
        bottom: "35%",
        containLabel: true,
      },
      xAxis: [
        {
          type: "category",
          data: [""], // Single group
          axisTick: { show: false },
          axisLine: { show: false },
          axisLabel: { show: false },
        },
      ],
      yAxis: [
        {
          type: "value",
          min: 0,
          // Optionally set max and interval as in BarChartOptions
          axisLabel: {
            color: "#595959",
            fontSize: 14,
          },
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
              color: "#E0E0E0",
            },
          },
        },
      ],
      series,
    };
  };

  // For Download Report

  const OneYearChartOptions = {
    tooltip: {
      trigger: "item",
    },
    legend: {
      orient: "vertical",
      left: "left",
    },
    grid: {
      left: "30%",
      right: "4%",
      bottom: "3%",
      containLabel: true,
    },
    series: [
      {
        name: "Actual Benefits with Vodafone",
        type: "pie",
        radius: "50%",
        color: ["#9C2AA0", "#EB9700", "#00B0CA"], // Specify colors for the pie slices here
        data: [
          { value: 1048, name: "Lower Costs" },
          { value: 735, name: "Increase Productivity" },
          { value: 580, name: "Enable Business" },
        ],
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
      },
    ],
  };

  const ThreeYearChartOptions = {
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
    },
    legend: {
      orient: "vertical",
      left: "left",
    },
    grid: {
      left: "0%",
      top: "30%",
      right: "4%",
      bottom: "3%",
      containLabel: true,
    },
    xAxis: [
      {
        type: "category",
        data: ["2022", "2023", "2024"],
      },
    ],
    yAxis: [
      {
        type: "value",
      },
    ],
    series: [
      {
        name: "Lower Costs",
        type: "bar",
        stack: "Ad",
        barWidth: "60",
        emphasis: {
          focus: "series",
        },
        itemStyle: {
          color: "#9C2AA0", // Apply purple color here
        },
        data: [120, 132, 101, 134, 90, 230, 210],
      },
      {
        name: "Increase Productivity",
        type: "bar",
        stack: "Ad",
        barWidth: "60",
        emphasis: {
          focus: "series",
        },
        itemStyle: {
          color: "#EB9700", // Apply orange color here
        },
        data: [220, 182, 191, 234, 290, 330, 310],
      },
      {
        name: "Enable Business",
        type: "bar",
        stack: "Ad",
        barWidth: "60",
        emphasis: {
          focus: "series",
        },
        itemStyle: {
          color: "#00B0CA", // Apply cyan color here
        },
        data: [150, 232, 201, 154, 190, 330, 410],
      },
    ],
  };

  const chartStyle = {
    height: "200px",
    width: "100%",
  };

  const PieChartOptions = {
    tooltip: {
      trigger: "item",
      formatter: "{b}: {c} ({d}%)", // Shows name, value, and percentage
    },
    legend: {
      orient: "horizontal",
      left: "center",
      bottom: "0", // Adjust as needed for vertical position
      data: ["Basic", "Standard", "Premium"], // Matches the names in series.data
      itemGap: 50, // Space between legend items
      itemWidth: 15, // <--- ADD THIS: Width of the colored box (e.g., 15 pixels)
      itemHeight: 15, // <--- ADD THIS: Height of the colored box (e.g., 15 pixels)
    },
    // title is used for the text in the center of the donut
    title: {
      text: "Total Licence", // The main number
      subtext: "450", // The text below the number
      left: "center",
      top: "42%", // Position in the middle of the chart

      textStyle: {
        fontSize: 14, // Adjust font size for "Total Licenses"
        fontWeight: "normal",
        color: "#666", // Adjust color as needed
      },
      subtextStyle: {
        fontSize: 36, // Adjust font size for "450"
        fontWeight: "bold",
        color: "#333", // Adjust color as needed
      },
    },
    series: [
      {
        name: "Licence", // A name for the series, appears in tooltips
        type: "pie",
        // To make it a donut chart, radius is an array: [innerRadius, outerRadius]
        // Adjust these percentages for the desired thickness of the donut
        radius: ["40%", "75%"],
        center: ["50%", "50%"], // Ensure chart is centered if title is also centered
        avoidLabelOverlap: false, // Important for custom label positioning
        color: ["#9C2AA0", "#EB9700", "#00B0CA"], // Purple, Orange, Teal
        data: [
          { value: 250, name: "Premium" }, // Corresponds to #9C2AA0 (Purple)
          { value: 100, name: "Standard" }, // Corresponds to #EB9700 (Orange)
          { value: 100, name: "Basic" }, // Corresponds to #00B0CA (Teal)
        ],
        label: {
          show: true,
          position: "outside",
          formatter: "{c}", // Show the value (count) on the label
          color: "#333", // Label text color
          fontSize: 12,
          // distanceToLabelLine: 5, // Optional: adjust space between label and line start
        },
        labelLine: {
          show: true,
          length: 15, // Length of the first part of the line
          length2: 10, // Length of the second part of the line (after the jog)
          smooth: false, // Use straight lines
        },
        emphasis: {
          // Style when hovering over a slice
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.3)",
          },
          label: {
            // Optional: make label more prominent on hover
            show: true,
            fontSize: "14",
            fontWeight: "bold",
          },
        },
        // The `top` property from your original series is removed as `center` and `title` positioning handles it.
      },
    ],
    // The `grid` option is generally not needed for pie charts, but keeping it won't harm.
    // You can remove it if you prefer.
    grid: {
      left: "5%", // Adjusted to give more space if labels are long
      right: "5%",
      bottom: "15%", // Ensure space for the legend
      containLabel: true,
    },
  };

  const BarChartOptions = {
    tooltip: {
      axisPointer: {
        type: "shadow",
      },
      // The default tooltip formatter for 'axis' trigger will list all series.
    },
    legend: {
      show: true,
      data: [
        "Remote Workers",
        "Office Workers",
        "On the Road Workers",
        "Hybrid Workers",
      ], // Derived from series names
      bottom: "0", // Or '5%' or adjust as needed
      left: "center",
      itemGap: 15,
      itemWidth: 12,
      itemHeight: 12,
      icon: "circle", // Make all legend icons circles
      textStyle: {
        color: "#595959", // Matching image text color
        fontSize: 13,
      },
    },
    grid: {
      left: "3%", // Adjust if y-axis labels need more or less space
      top: "5%", // Space from the top
      right: "4%", // Space from the right
      bottom: "35%", // Ample space for the legend below the x-axis area
      containLabel: true, // Ensures labels (like y-axis) fit
    },
    xAxis: [
      {
        type: "category",
        // Using an empty string or a non-displaying character for a single grouping point
        // if you don't want any visible x-axis label below the bars.
        // Or, if each bar IS a category, then it should be:
        // data: ['Remote Workers', 'Office Workers', 'On the Road Workers', 'Hybrid Workers'],
        // However, to match the *visual* of a single group of 4 bars,
        // and have the legend define what each bar is:
        data: [""], // A single, empty category to group the bars
        axisTick: { show: false },
        axisLine: { show: false },
        axisLabel: { show: false }, // No visible x-axis labels
      },
    ],
    yAxis: [
      {
        type: "value",
        min: 0,
        max: 100,
        interval: 25,
        axisLabel: {
          margin: 10,
          color: "#595959", // Matching image text color
          fontSize: 14,
        },
        axisLine: { show: false },
        axisTick: { show: false },
        splitLine: {
          show: true,
          lineStyle: {
            type: "dashed",
            color: "#E0E0E0", // Lighter dashed lines
          },
        },
      },
    ],
    series: [
      {
        name: "Remote Workers",
        type: "bar",
        barWidth: 40, // Fixed width for each bar
        // barGap: '30%', // Optional: space between bars of different series (within same category)
        itemStyle: {
          color: "#A5B83C", // Olive Green
          borderRadius: [5, 5, 0, 0],
        },
        emphasis: { focus: "series" },
        data: [68], // Value for the single x-axis category ''
      },
      {
        name: "Office Workers",
        type: "bar",
        barWidth: 40,
        itemStyle: {
          color: "#00B0CA", // Teal
          borderRadius: [5, 5, 0, 0],
        },
        emphasis: { focus: "series" },
        data: [88],
      },
      {
        name: "On the Road Workers",
        type: "bar",
        barWidth: 40,
        itemStyle: {
          color: "#9C2AA0", // Purple
          borderRadius: [5, 5, 0, 0],
        },
        emphasis: { focus: "series" },
        data: [43],
      },
      {
        name: "Hybrid Workers",
        type: "bar",
        barWidth: 40,
        itemStyle: {
          color: "#EB9700", // Orange
          borderRadius: [5, 5, 0, 0],
        },
        emphasis: { focus: "series" },
        data: [76],
      },
    ],
  };

  // Create Puck component config
  const config = {
    categories: {
      Banner: {
        components: ["BannerLeftTextRightImage", "BannerCenterText"],
      },

      Cards: {
        components: ["CardLayout1", "CardLayout2"],
      },
    },

    components: {
      //Header Components
      PageHeader: {
        render: ({
          logo,
          items,
          hide,
          showCurrencyDropdown,
          showRecalculateButton,
          showLanguageDropdown,
          transparentHeader,
          contactSpecialistButton,
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          const csb = contactSpecialistButton && typeof contactSpecialistButton === "object" ? contactSpecialistButton : null;
          const showContactSpecialist = Boolean(csb && csb.show !== false);
          const contactSpecialistTitle = csb && csb.title != null ? csb.title : "Contact our specialist sales team";
          const contactSpecialistLink = csb && csb.link != null ? csb.link : "";



          return (
            <div
              className={`roi-header-main ${transparentHeader && "header-transparent"
                }`}
              style={{ opacity: inputOpacity }}
            >
              <div className="container">
                <div className="header-wrapper">
                  {/* <a href="" className="logo">
                                        <img src={resolveMediaUrl(logo)} alt="" onClick={homeRedirect} />
                                    </a> */}
                  <a
                    href="#"
                    className="logo"
                    data-bs-toggle="modal"
                    data-bs-target="#logoPrompt"
                  >
                    {logo ? (
                      <img src={resolveMediaUrl(logo)} alt="" fetchpriority="high" />
                    ) : (
                      <img src={logo_fallback} alt="" fetchpriority="high" />
                    )}
                  </a>
                  <div className="nav-menu">
                    <ul>
                      {items?.map((item, i) => (
                        <li
                          key={i}
                          onClick={() => jumpToPage(item.buttonValue)}
                        >
                          <Link
                            to=""
                            className={item.activeStatus == 1 ? "active" : ""}
                          >
                            {item.Text}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="space">
                    {showCurrencyDropdown || showLanguageDropdown || showRecalculateButton || showContactSpecialist ? (
                      <div className="d-flex currency-language">
                        {showRecalculateButton && <>
                          <button className="d-inline-flex align-items-center btn roi-btn-outline-primary gap-3 px-3"
                            type="button"
                            //onClick={handleRecalculateClick}
                            data-bs-toggle="modal"
                            data-bs-target="#logoPrompt">

                            <Svg name="roi-recalculate-icon" /> Start Over

                          </button>
                        </>}
                        {showLanguageDropdown && (
                          <div className="lang-wrap">
                            <Svg name="language-globe" />
                            <select className="language">
                              <option value="1">English</option>
                              {/* <option value="2">Spanish</option> */}
                            </select>
                          </div>
                        )}
                        {showCurrencyDropdown && (
                          <select
                            className="currency"
                            onChange={(e) => currencyChange(e)}
                          >
                            <option
                              value={defaultCurrency}
                              selected={
                                changedCurrency == "" ||
                                  changedCurrency == defaultCurrency
                                  ? "selected"
                                  : ""
                              }
                            >
                              {defaultCurrency}
                            </option>
                            {currency.map((item, i) => (
                              <option
                                value={item}
                                selected={
                                  changedCurrency == item ? "selected" : ""
                                }
                                key={i}
                              >
                                {item}
                              </option>
                            ))}
                          </select>
                        )}
                        {showContactSpecialist && (contactSpecialistLink ? (
                          <a
                            target="_blank"
                            rel="noreferrer"
                            href={contactSpecialistLink}
                            className="d-inline-flex align-items-center btn roi-btn-primary gap-3 page-header-contact-specialist"
                          >
                            {contactSpecialistTitle}
                            <div className="icon">
                              <Svg name="arrow-right-icn-roi" />
                            </div>
                          </a>
                        ) : (
                          <button type="button" className="d-inline-flex align-items-center btn roi-btn-primary gap-3 page-header-contact-specialist">
                            {contactSpecialistTitle}
                            <div className="icon">
                              <Svg name="arrow-right-icn-roi" />
                            </div>
                          </button>
                        ))}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
          );
        },
      },
      PageHeaderTransparent: {
        render: ({ logo, hide }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <div
              className="roi-header-transparent"
              style={{ opacity: inputOpacity }}
            >
              <div className="container">
                <div className="header-wrapper">
                  <a className="logo">
                    <img src={resolveMediaUrl(logo)} alt="" />
                  </a>
                </div>
              </div>
            </div>
          );
        },
      },

      // Banner Layouts
      BannerLeftTextRightImage: {
        render: ({
          Heading,
          Description,
          Button,
          Padding,
          Style,
          image,
          hide,
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }
          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          // Get popup ID for OpenPopup action
          const popupId = Button.popupTargetId ? Button.popupTargetId.trim().replace(/^#/, '') : '';

          // Handle button click - check for popup action
          const handleButtonClick = () => {
            if (Button.buttonAction === "OpenPopup" && popupId) {
              // Use React state to open the modal
              setOpenModalId(popupId);
            } else {
              // Default button action
              onButtonClick(Button.uuid);
            }
          };

          return (
            <>
              <div
                className={`roi-banner-section position-relative ${Padding.bottom
                  } ${Padding.top} ${Style} ${Padding.fullHeight && "full-height"
                  }`}
                style={{ opacity: inputOpacity }}
              >
                <div className="container position-relative">
                  <div className="row align-items-center ">
                    <div className="col-lg-6">
                      <div className="banner-text">
                        <h1
                          className={`heading ${Heading.fontWeight} ${Heading.titleFont} mb-3`}
                        >
                          {Heading.title}
                        </h1>

                        <div className="text-part">
                          <div
                            className={Description.descriptionFont}
                            dangerouslySetInnerHTML={{
                              __html: Description.text,
                            }}
                          ></div>
                        </div>

                        <div className="button-wrap">
                          {Button.buttonicon === "yes" ? (
                            <button
                              onClick={handleButtonClick}
                              className={`d-inline-flex align-items-center btn roi-btn-${Button.buttonStyle}`}
                              type="button"
                            >
                              <span className="with-icon">
                                {Button.buttonText}
                              </span>
                              <div className="icon">
                                <Svg name="roi-button-icon" />
                              </div>
                            </button>
                          ) : (
                            <button
                              onClick={handleButtonClick}
                              className={`btn roi-btn-${Button.buttonStyle}`}
                              type="button"
                            >
                              {Button.buttonText}
                            </button>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="img-wrapper">
                        <img src={resolveMediaUrl(image)} className="img-fluid" alt="" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      BannerCenterText: {
        render: ({
          Heading,
          Description,
          Button,
          Padding,
          image,
          Style,
          hide,
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-banner-section position-relative banner-center-text ${Style} ${Padding.bottom
                  } ${Padding.top} ${Padding.fullHeight && "full-height"}`}
                style={{
                  backgroundImage: resolveMediaCssUrl(image),
                  backgroundPosition: "center",
                  backgroundSize: "cover",
                  backgroundRepeat: "no-repeat",
                  opacity: inputOpacity,
                }}
              >
                <div className="overlay"></div>
                <div className="container position-relative">
                  <div className="row align-items-center justify-content-center">
                    <div className="col-lg-8">
                      <div className="banner-text text-center">
                        <h1
                          className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}
                        >
                          {Heading.title}
                        </h1>

                        <div className="text-part">
                          <div
                            className={Description.descriptionFont}
                            dangerouslySetInnerHTML={{
                              __html: Description.text,
                            }}
                          ></div>
                        </div>

                        <div className="button-wrap">
                          {Button.buttonicon === "yes" ? (
                            <button
                              className={`d-inline-flex align-items-center btn roi-btn-${Button.buttonStyle}`}
                              type="submit"
                            >
                              <span className="with-icon">
                                {Button.buttonText}
                              </span>
                              <div className="icon">
                                <Svg name="roi-button-icon" />
                              </div>
                            </button>
                          ) : (
                            <button
                              className={`btn roi-btn-${Button.buttonStyle}`}
                              type="submit"
                            >
                              {Button.buttonText}
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      //Cards Layouts
      CardLayout1: {
        render: ({
          Heading,
          Description,
          Padding,
          Card1,
          Card2,
          Card3,
          Card4,
          hide,
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-cards-section card-layout-1 position-relative ${Padding.bottom
                  } ${Padding.top} ${Padding.fullHeight && "full-height"}`}
                style={{ opacity: inputOpacity }}
              >
                <div className="card-nav-outer">
                  <div className="container">
                    <div className="card-nav d-flex align-items-center justify-content-between">
                      {/* <div className="card-prev text-start">
                                                <button className='prev-btn card-btn'>Back</button>
                                            </div> */}

                      <div className="card-next text-end">
                        {/**Only Hide button in case not to be shown**/}
                        {/* <button className='next-btn card-btn'>Next</button> */}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="container position-relative">
                  <div className="section-heading mb-3 mb-md-5 text-center">
                    <h2
                      dangerouslySetInnerHTML={{ __html: Heading.title }}
                      className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}
                    />
                    <p dangerouslySetInnerHTML={{ __html: Description.text }} className={Description.descriptionFont} />

                  </div>

                  <div className="cards-wrapper">
                    <div className="row justify-content-center">
                      <div className="col-lg-4 col-md-6 mb-3">
                        <div
                          className="card-outer"
                          onClick={() => onButtonClick(Card1.uuid, null, Card1.title, [Card2.uuid, Card3.uuid, Card4.uuid])}
                        >
                          <div className="card-inner">
                            <div className="text-wrapper">
                              <h4 dangerouslySetInnerHTML={{ __html: Card1.title }} />
                              <p dangerouslySetInnerHTML={{ __html: Card1.text }} />
                            </div>
                            <div className="button-wrapper">
                              <button className="btn btn-action">
                                <Svg name="roi-card-button" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 mb-3">
                        <div
                          className="card-outer"
                          onClick={() => onButtonClick(Card2.uuid, null, Card2.title, [Card1.uuid, Card3.uuid, Card4.uuid])}
                        >
                          <div className="card-inner">
                            <div className="text-wrapper">
                              <h4 dangerouslySetInnerHTML={{ __html: Card2.title }} />
                              <p dangerouslySetInnerHTML={{ __html: Card2.text }} />
                            </div>
                            <div className="button-wrapper">
                              <button className="btn btn-action">
                                <Svg name="roi-card-button" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      {Card3?.title && (
                        <div className="col-lg-4 col-md-6 mb-3">
                          <div
                            className="card-outer"
                            onClick={() => onButtonClick(Card3.uuid, null, Card3.title, [Card1.uuid, Card2.uuid, Card4.uuid])}
                          >
                            <div className="card-inner">
                              <div className="text-wrapper">
                                <h4 dangerouslySetInnerHTML={{ __html: Card3.title }} />
                                <p dangerouslySetInnerHTML={{ __html: Card3.text }} />
                              </div>
                              <div className="button-wrapper">
                                <button className="btn btn-action">
                                  <Svg name="roi-card-button" />
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {Card4?.title && (
                        <div className="col-lg-4 col-md-6 mb-3">
                          <div
                            className="card-outer"
                            onClick={() => onButtonClick(Card4.uuid, null, Card4.title, [Card1.uuid, Card2.uuid, Card3.uuid])}
                          >
                            <div className="card-inner">
                              <div className="text-wrapper">
                                <h4 dangerouslySetInnerHTML={{ __html: Card4.title }} />
                                <p dangerouslySetInnerHTML={{ __html: Card4.text }} />
                              </div>
                              <div className="button-wrapper">
                                <button className="btn btn-action">
                                  <Svg name="roi-card-button" />
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      CardLayout2: {
        render: ({
          Heading,
          Description,
          Padding,
          Card1,
          Card2,
          Card3,
          hide,
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-cards-section card-layout-2 position-relative ${Padding.bottom
                  } ${Padding.top} ${Padding.fullHeight && "full-height"}`}
                style={{ opacity: inputOpacity }}
              >
                <div className="container position-relative">
                  <div className="section-heading mb-3 mb-md-5 text-center">
                    <h2
                      className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}
                    >
                      {Heading.title}
                    </h2>
                    <p className={Description.descriptionFont}>
                      {Description.text}
                    </p>
                  </div>
                  <div className="cards-wrapper">
                    <div className="row justify-content-center">
                      <div className="col-lg-4 col-md-6 mb-3">
                        <div className="card-outer">
                          <div className="card-inner">
                            <div className="icon-wrapper">
                              <Svg name="roi-card-icon" />
                            </div>
                            <div className="text-wrapper">
                              <h4>{Card1.title}</h4>
                              <p>{Card1.text}</p>
                            </div>
                            <div className="button-wrapper">
                              <button className="btn btn-action">
                                <Svg name="roi-card-button" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 mb-3">
                        <div className="card-outer">
                          <div className="card-inner">
                            <div className="icon-wrapper">
                              <Svg name="roi-card-icon" />
                            </div>
                            <div className="text-wrapper">
                              <h4>{Card2.title}</h4>
                              <p>{Card2.text}</p>
                            </div>
                            <div className="button-wrapper">
                              <button className="btn btn-action">
                                <Svg name="roi-card-button" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 mb-3">
                        <div className="card-outer">
                          <div className="card-inner">
                            <div className="icon-wrapper">
                              <Svg name="roi-card-icon" />
                            </div>
                            <div className="text-wrapper">
                              <h4>{Card3.title}</h4>
                              <p>{Card3.text}</p>
                            </div>
                            <div className="button-wrapper">
                              <button className="btn btn-action">
                                <Svg name="roi-card-button" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      //Form Layouts
      SinglePage: {
        render: ({ Heading, Description, Padding, hide }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-forms-section position-relative ${Padding.bottom} ${Padding.top}`}
                style={{ opacity: inputOpacity }}
              >
                <div className="container position-relative">
                  <DropZone zone="nav-wrapper" allow={["FormNav"]} />
                  <div className="form-wrapper">
                    <div className="section-heading mb-3 mb-md-4">
                      <h2
                        className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}
                      >
                        {Heading.title}
                      </h2>
                      <p className={Description.descriptionFont}>
                        {Description.text}
                      </p>
                    </div>
                    <div className="form-inner">
                      <DropZone
                        zone="form-wrapper"
                        disallow={["SinglePage", "WizardForm"]}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      FormNav: {
        render: ({ items, hide }) => {
          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <ul className="nav nav-tabs nav-tabs-single">
                {items.map((item, i) => (
                  <li className="nav-item" role="presentation" key={i}>
                    {/** Add Class 'filled' and active class will move to next <li> button once form is filled, this will add gray backround**/}
                    <button
                      onClick={() => onButtonClick(item.uuid, null, item.Title)}
                      className={
                        item.isActive == true ? "nav-link active" : "nav-link"
                      }
                    >
                      {item.Title}
                    </button>
                  </li>
                ))}
              </ul>
            </>
          );
        },
      },
      FormNav2: {

        render: ({ items, hide }) => {
          const inputOpacity = hide ? 0.5 : 1;

          // Calculate progress percentage
          const totalSteps = items.length;
          const completedSteps = items.filter(item => item.isDone).length;
          const progressPercentage = totalSteps > 0 ? (completedSteps / totalSteps) * 100 : 0;

          return (
            <>
              {/* Wizard Progress Steps */}
              <div className="wizard-progress" style={{ opacity: inputOpacity }}>
                <div className="wizard-steps">
                  {items.map((item, i) => (
                    <div key={i} className={`wizard-step ${item.isDone ? 'completed' : ''} ${item.isActive ? 'active' : ''}`}>
                      <div className="step-circle">
                        {item.isDone ? (
                          <svg xmlns="http://www.w3.org/2000/svg" width={16} height={12} viewBox="0 0 16 12" fill="none">
                            <path d="M1.37207 4.63043L6.18052 9.43888L14.532 1.08736" stroke="white" strokeWidth={3} />
                          </svg>

                        ) : (
                          <span>{i + 1}</span>
                        )}
                      </div>
                      <div className="step-label">{item.Title}</div>
                      {i < items.length - 1 && (
                        <div className={`step-connector ${item.isDone ? 'completed' : ''}`}></div>
                      )}
                    </div>
                  ))}
                </div>


              </div>


            </>
          )
        },
      },


      WizardForm: {
        render: ({ Padding, items, hide }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-forms-section position-relative ${Padding.bottom} ${Padding.top}`}
                style={{ opacity: inputOpacity }}
              >
                <div className="container position-relative">
                  <ul className="nav nav-tabs" id="myTab" role="tablist">
                    {items.map((item, i) => (
                      <li className="nav-item" role="presentation" key={i}>
                        {/** Add Class 'filled' and active class will move to next <li> button once form is filled, this will add gray backround**/}
                        <button
                          className={i === 0 ? "nav-link active" : "nav-link"}
                          id={`tab-${i}`}
                          data-bs-toggle="tab"
                          data-bs-target={`#tab-${i}-pane`}
                          type="button"
                          role="tab"
                          aria-controls={`tab-${i}-pane`}
                          aria-selected="false"
                        >
                          {item.Title}
                        </button>
                      </li>
                    ))}
                  </ul>
                  <div className="form-wrapper">
                    <div className="tab-content" id="myTabContent">
                      {items.map((item, i) => (
                        <div
                          key={i}
                          className={
                            i === 0
                              ? "tab-pane fade show active"
                              : "tab-pane fade"
                          }
                          id={`tab-${i}-pane`}
                          role="tabpanel"
                          aria-labelledby={`tab-${i}`}
                          tabIndex={0}
                        >
                          <div className="section-heading mb-3 mb-md-4">
                            <h2 className={`heading fw-700 fs-40`}>
                              {item.Title}
                            </h2>
                            <p className="fs-22">{item.Description}</p>
                          </div>
                          <div className="form-inner">
                            <DropZone
                              zone={`wizard-form-wrapper-${i}`}
                              disallow={["SinglePage", "WizardForm"]}
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      //Form Elements

      InputTextField: {
        render: ({
          label,
          showLabel,
          disableEditing,
          value,
          placeholder,
          required,
          errorMessage,
          hint,
          hintStyle,
          hide,
          Prefix,
          uuid,
          tabIndex,
          Style,
          Font,
          Border,
          Padding,
          Margin,
        }) => {
          // Render nothing if hide is true
          if (hide == true || hide == 'true') {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-form-group ${Style?.customMargin ? "" : "mb-3"
                  } position-relative`}
                style={{
                  opacity: inputOpacity,
                  margin: `${Margin?.top}px ${Margin?.right}px ${Margin?.bottom}px ${Margin?.left}px`,
                }}
              >
                {showLabel && (
                  <label className="field-label" for={uuid}>
                    <span dangerouslySetInnerHTML={{ __html: label }} />{" "}{required && <span className="required">*</span>}
                    {hint && (
                      <div className={`hint ${hintStyle}`}>
                        <button type="button" className="info" tabIndex={0}>
                          <Svg name="hint-button" />
                        </button>
                        <div
                          className="popover"
                          dangerouslySetInnerHTML={{ __html: hint }}
                        ></div>
                      </div>
                    )}
                  </label>
                )}
                <div className="position-relative">
                  {(() => {
                    if (Prefix === "currency") {
                      return (
                        <input

                          {...(disableEditing ? { disabled: true } : {})}
                          type={"text"}
                          className={`form-control ${Font?.fontWeight} ${Font?.fontSize ? `${Font?.fontSize}` : "fs-18"
                            } ${errorMessage ? "error" : ""}`}
                          placeholder={placeholder}
                          // value={roiActionArr[uuid] ? ((roiActionArr[uuid]?.value!='') ? roiActionArr[uuid]?.value : value) : value}
                          defaultValue={CurrencyFormatter({
                            amount: parseFloat(value),
                          }).normalize()}
                          id={uuid}
                          tabIndex={Number.isInteger(tabIndex) ? tabIndex : undefined}
                          // value={ (roiActionArr[uuid]?.value!='') ? roiActionArr[uuid]?.value : roiActionArr[uuid]?.default_value}
                          required={required}
                          onFocus={handleInputFocus}
                          onBlur={(e) => handleInputBlur(uuid, e, required)}
                          style={{
                            backgroundColor: `${Style?.BackgroundColor}`,
                            color: `${Style?.Color}`,

                            padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,

                            borderStyle: `${Border?.BorderStyle}`,
                            borderColor: `${Border?.BorderColor}`,
                            borderWidth: `${Border?.BorderWidth}px`,
                            borderRadius: `${Border?.BorderRadius}px`,
                            height: `${Style?.Height}px`,
                            textAlign: Font?.Align,
                          }}
                        />
                      );
                    } else {
                      return (
                        <input
                          {...(disableEditing ? { disabled: true } : {})}
                          type={"text"}
                          className={`form-control ${Font?.fontWeight} ${Font?.fontSize ? `${Font?.fontSize}` : "fs-18"
                            } ${errorMessage ? "error" : ""}`}
                          placeholder={placeholder}
                          // value={ (roiActionArr[uuid]?.value!='') ? roiActionArr[uuid]?.value : roiActionArr[uuid]?.default_value}
                          defaultValue={value}
                          id={uuid}
                          tabIndex={Number.isInteger(tabIndex) ? tabIndex : undefined}
                          // value={ (roiActionArr[uuid]?.value!='') ? roiActionArr[uuid]?.value : roiActionArr[uuid]?.default_value}
                          required={required}
                          onFocus={handleInputFocus}
                          onBlur={(e) => handleInputBlur(uuid, e, required)}
                          style={{
                            backgroundColor: `${Style?.BackgroundColor}`,
                            color: `${Style?.Color}`,

                            padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,

                            borderStyle: `${Border?.BorderStyle}`,
                            borderColor: `${Border?.BorderColor}`,
                            borderWidth: `${Border?.BorderWidth}px`,
                            borderRadius: `${Border?.BorderRadius}px`,
                            height: `${Style?.Height}px`,
                            textAlign: Font?.Align,
                            display: `${Style?.Display}`,
                          }}
                        />
                      );
                    }
                  })()}

                  {!showLabel && hint && (
                    <div className={`hint ${hintStyle}`}>
                      <button type="button" className="info" tabIndex={0}>
                        <Svg name="hint-button" />
                      </button>
                      <div
                        className="popover"
                        dangerouslySetInnerHTML={{ __html: hint }}
                      ></div>
                    </div>
                  )}
                </div>

                {errorMessage && (
                  <div className="input-error">{errorMessage}</div>
                )}
              </div>
            </>
          );
        },
      },

      InputNumberField: {
        render: ({
          label,
          showLabel,
          disableEditing,
          value,
          placeholder,
          required,
          errorMessage,
          hint,
          hintStyle,
          hide,
          Prefix,
          Style,
          Font,
          Border,
          Padding,
          Margin,
          uuid,
          tabIndex,
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-form-group ${Style?.customMargin ? "" : "mb-3"
                  } position-relative`}
                style={{
                  opacity: inputOpacity,
                  margin: `${Margin?.top}px ${Margin?.right}px ${Margin?.bottom}px ${Margin?.left}px`,
                }}
              >
                {showLabel && (
                  <label className="field-label">
                    <span dangerouslySetInnerHTML={{ __html: label }} />{" "}{required && <span className="required">*</span>}
                    {hint && (
                      <div className={`hint ${hintStyle}`}>
                        <button type="button" className="info" tabIndex={0}>
                          <Svg name="hint-button" />
                        </button>
                        <div
                          className="popover"
                          dangerouslySetInnerHTML={{ __html: hint }}
                        ></div>
                      </div>
                    )}
                  </label>
                )}
                <div className="position-relative">
                  {Prefix == "none" && (
                    <input
                      {...(disableEditing ? { disabled: true } : {})}
                      type="text"
                      inputMode="decimal"
                      className={`form-control ${Font?.fontWeight} ${Font?.fontSize ? `${Font?.fontSize}` : "fs-18"
                        } ${errorMessage ? "error" : ""}`}
                      placeholder={placeholder}
                      defaultValue={
                        value === undefined || value === null || value === ""
                          ? ""
                          : formatRoiFieldDisplayValue(String(value))
                      }
                      id={uuid}
                      tabIndex={tabIndex ?? ""}
                      required={required}
                      onFocus={handleInputFocus}
                      onBlur={(e) => handleInputBlur(uuid, e, required)}
                      onWheel={handleWheelPrevention}
                      onMouseWheel={handleWheelPrevention}
                      onKeyDown={preventScrollAndArrowKeys}
                      style={{
                        backgroundColor: `${Style?.BackgroundColor}`,
                        color: `${Style?.Color}`,
                        padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,
                        borderStyle: `${Border?.BorderStyle}`,
                        borderColor: `${Border?.BorderColor}`,
                        borderWidth: `${Border?.BorderWidth}px`,
                        borderRadius: `${Border?.BorderRadius}px`,
                        height: `${Style?.Height}px`,
                        textAlign: Font?.Align,
                        pointerEvents: 'auto',
                      }}
                    />
                  )}

                  {Prefix == "%" && (
                    <div className="input-group percent">
                      <input
                        {...(disableEditing ? { disabled: true } : {})}
                        type="text"
                        inputMode="decimal"
                        className={`form-control ${Font?.fontWeight} ${Font?.fontSize ? `${Font?.fontSize}` : "fs-18"
                          } ${errorMessage ? "error" : ""}`}
                        placeholder={placeholder}
                        defaultValue={
                          value === undefined || value === null || value === ""
                            ? ""
                            : formatRoiFieldDisplayValue(String(value))
                        }
                        id={uuid}
                        tabIndex={Number.isInteger(tabIndex) ? tabIndex : undefined}
                        required={required}
                        onFocus={handleInputFocus}
                        onBlur={(e) => handleInputBlur(uuid, e)}
                        onWheel={handleWheelPrevention}
                        onMouseWheel={handleWheelPrevention}
                        onKeyDown={preventScrollAndArrowKeys}
                        style={{
                          backgroundColor: `${Style?.BackgroundColor}`,
                          color: `${Style?.Color}`,
                          padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,

                          borderStyle: `${Border?.BorderStyle}`,
                          borderColor: `${Border?.BorderColor}`,
                          borderWidth: `${Border?.BorderWidth}px`,
                          borderRadius: `${Border?.BorderRadius}px`,
                          height: `${Style?.Height}px`,
                          textAlign: Font?.Align,
                          pointerEvents: 'auto',
                        }}
                      />
                      <span
                        className={`input-group-text ${Font?.fontWeight} ${Font?.fontSize}`}
                        style={{
                          color: `${Style?.Color}`,
                        }}
                      >
                        %
                      </span>
                    </div>
                  )}

                  {Prefix == "currency" && (
                    <div className="input-group currency">
                      <span
                        className={`input-group-text ${Font?.fontWeight} ${Font?.fontSize}`}
                        style={{
                          color: `${Style?.Color}`,
                        }}
                        dangerouslySetInnerHTML={{ __html: currencySymbol }}
                      ></span>
                      {/**Change this currency depending upon default currency**/}
                      <input
                        {...(disableEditing ? { disabled: true } : {})}
                        type="text"
                        inputMode="decimal"
                        className={`form-control ${Font?.fontWeight} ${Font?.fontSize ? `${Font?.fontSize}` : "fs-18"
                          } ${errorMessage ? "error" : ""}`}
                        placeholder={placeholder}
                        defaultValue={
                          value === undefined || value === null || value === ""
                            ? ""
                            : formatRoiFieldDisplayValue(String(value))
                        }
                        id={uuid}
                        tabIndex={Number.isInteger(tabIndex) ? tabIndex : undefined}
                        required={required}
                        onFocus={handleInputFocus}
                        onBlur={(e) => handleInputBlur(uuid, e)}
                        onWheel={handleWheelPrevention}
                        onMouseWheel={handleWheelPrevention}
                        onKeyDown={preventScrollAndArrowKeys}
                        style={{
                          backgroundColor: `${Style?.BackgroundColor}`,
                          color: `${Style?.Color}`,
                          padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,

                          borderStyle: `${Border?.BorderStyle}`,
                          borderColor: `${Border?.BorderColor}`,
                          borderWidth: `${Border?.BorderWidth}px`,
                          borderRadius: `${Border?.BorderRadius}px`,
                          height: `${Style?.Height}px`,
                          textAlign: Font?.Align,
                          pointerEvents: 'auto',
                        }}
                      />
                    </div>
                  )}

                  {!showLabel && hint && (
                    <div className={`hint ${hintStyle}`}>
                      <button type="button" className="info" tabIndex={0}>
                        <Svg name="hint-button" />
                      </button>
                      <div
                        className="popover"
                        dangerouslySetInnerHTML={{ __html: hint }}
                      ></div>
                    </div>
                  )}
                </div>

                {errorMessage && (
                  <div className="input-error">{errorMessage}</div>
                )}
              </div>
            </>
          );
        },
      },

      TextareaField: {
        render: ({
          label,
          value,
          placeholder,
          required,
          errorMessage,
          hide,
          Style,
          Font,
          Border,
          Padding,
          Margin,
          showLabel,
          uuid
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-form-group ${Style?.customMargin ? "" : "mb-3"
                  } position-relative`}
                style={{
                  opacity: inputOpacity,
                  margin: `${Margin?.top}px ${Margin?.right}px ${Margin?.bottom}px ${Margin?.left}px`,
                }}
              >
                {showLabel && (
                  <label className="field-label">
                    {label}{required && <span className="required">*</span>}                  </label>
                )}
                <textarea
                  className={`form-control ${Font?.fontWeight} ${Font?.fontSize ? `${Font?.fontSize}` : "fs-18"
                    } ${errorMessage ? "error" : ""}`}
                  placeholder={placeholder}
                  required={required}
                  value={value}
                  id={uuid}
                  style={{
                    backgroundColor: `${Style?.BackgroundColor}`,
                    color: `${Style?.Color}`,

                    padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,

                    borderStyle: `${Border?.BorderStyle}`,
                    borderColor: `${Border?.BorderColor}`,
                    borderWidth: `${Border?.BorderWidth}px`,
                    borderRadius: `${Border?.BorderRadius}px`,
                    height: `${Style?.Height}px`,
                    textAlign: Font?.Align,
                  }}
                />

                {errorMessage && (
                  <div className="input-error">{errorMessage}</div>
                )}
              </div>
            </>
          );
        },
      },

      Dropdown: {
        render: ({
          label,
          showLabel,
          required,
          errorMessage,
          items,
          hide,
          Style,
          Font,
          Border,
          Padding,
          Margin,
          uuid,
        }) => {
          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-form-group ${Style?.customMargin ? "" : "mb-3"
                  } position-relative`}
                style={{
                  opacity: inputOpacity,
                  margin: `${Margin?.top}px ${Margin?.right}px ${Margin?.bottom}px ${Margin?.left}px`,
                }}
              >
                {showLabel && (
                  <label className="field-label">
                    {label}{required && <span className="required">*</span>}                  </label>
                )}
                <select
                  className={`form-control ${Font?.fontWeight} ${Font?.fontSize
                    } ${errorMessage ? "error" : ""}`}
                  onChange={(e) => handleDropdownChange(uuid, e)}
                  style={{
                    backgroundColor: `${Style?.BackgroundColor}`,
                    backgroundSize: `${Style?.DropdownSize}px`,
                    padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,

                    borderStyle: `${Border?.BorderStyle}`,
                    borderColor: `${Border?.BorderColor}`,
                    borderWidth: `${Border?.BorderWidth}px`,
                    borderRadius: `${Border?.BorderRadius}px`,
                    height: `${Style?.Height}px`,
                  }}
                  defaultValue={changedDropdown[uuid]}
                >
                  <option value>--Select--</option>
                  {items.map((item, i) => (
                    <option key={i} value={item.Option}>
                      {item.Option}
                    </option>
                  ))}
                </select>

                {errorMessage && (
                  <div className="input-error">{errorMessage}</div>
                )}
              </div>
            </>
          );
        },
      },

      Checkbox: {
        render: ({
          label,
          required,
          errorMessage,
          items,
          ID,
          hide,
          Margin,
          Style,
          uuid
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;
          let main_value = 0;

          items.map((item, i) => {
            if (item.value == 1) {
              main_value = item.value;
            }
          })
          return (
            <>
              <div
                className={`roi-form-group ${Style?.customMargin ? "" : "mb-3"
                  } position-relative`}
                style={{
                  opacity: inputOpacity,
                  margin: `${Margin?.top}px ${Margin?.right}px ${Margin?.bottom}px ${Margin?.left}px`,
                }}
              >
                {label && (
                  <label className="field-label">
                    {label}{required && <span className="required">*</span>}                  </label>
                )}

                <div className="roi-check-wrap">
                  {items.map((item, i) => (
                    <div key={i}>
                      <label className="form-check" htmlFor={`${ID}-${i}`} >
                        <input
                          id={`${ID}-${i}`}
                          className="form-check-input"
                          name={ID}
                          type="checkbox"
                          checked={item.value == 1 ? true : false}
                          onChange={() => {
                            console.log('Checkbox clicked - Item UUID:', item.uuid, 'Item:', item);
                            onCheckBoxClick(item.uuid);
                          }}
                        />
                        <span className="form-check-label" dangerouslySetInnerHTML={{ __html: item.Option }} />

                      </label>
                      {
                        (items.length == 1 && required && item.value != 1) && (
                          <div className="input-error">{errorMessage}</div>
                        )
                      }

                    </div>
                  ))}
                </div>
                {items.length > 1 && required && main_value != 1 && (
                  <div className="input-error">{errorMessage}</div>
                )}
              </div>
            </>
          );
        },
      },

      //  Radio component
      Radio: {
        render: ({
          label,
          required,
          errorMessage,
          items,
          ID,
          hide,
          uuid,
          value,
          radioStyle,
          showInfoTooltip,
          defaultCheckedIndex,
          infoText,
          iconWidth,
          iconHeight,
          cardAlignment,
          cardsPerRow,
        }) => {
          // Added initialValue
          if (hide) {
            return null;
          }
          const inputOpacity = hide ? 0.5 : 1;

          // Get item value - use item.value if defined, otherwise use RadioOption as fallback
          const getItemValue = (item, index) => {
            if (item.value !== undefined && item.value !== null && item.value !== '') {
              return item.value;
            }
            return item.RadioOption || `option${index}`;
          };

          // Determine current value - use actual value if set, otherwise use default.
          // blank (""), null, undefined, or -1 all mean no option is pre-selected.
          const _dci = defaultCheckedIndex;
          const defaultIndex = (_dci !== undefined && _dci !== null && _dci !== "" && parseInt(_dci) >= 0)
            ? parseInt(_dci)
            : -1;
          const defaultItem = defaultIndex >= 0 ? items[defaultIndex] : null;
          const defaultValue = defaultItem ? getItemValue(defaultItem, defaultIndex) : '';
          const currentValue = value !== undefined && value !== null && value !== ''
            ? value
            : defaultValue;


          const resolvedIconWidth = iconWidth || 24;
          const resolvedIconHeight = iconHeight || 24;

          const getIconSrc = (imgValue) => {
            if (typeof imgValue === 'string' && imgValue.trim().startsWith('<svg')) {
              return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(imgValue)}`;
            }
            return imgValue;
          };

          const renderUploadedIcon = (iconValue, isSelected) => {
            if (!iconValue) return null;
            if (typeof iconValue === 'string' && iconValue.trim().startsWith('<svg')) {
              const svgStr = iconValue
                .replace(/\bwidth="[^"]*"/, `width="${resolvedIconWidth}"`)
                .replace(/\bheight="[^"]*"/, `height="${resolvedIconHeight}"`)
                // Named colors, hex, rgb, etc. — keep none / currentColor / url() paints
                .replace(/stroke="(?!currentColor|none|url\()[^"]*"/gi, 'stroke="currentColor"')
                .replace(/stroke='(?!currentColor|none|url\()[^']*'/gi, "stroke='currentColor'");
              return (
                <span
                  className="radio-card-icon"
                  style={{ color: isSelected ? '#e60000' : '#25282B' }}
                  dangerouslySetInnerHTML={{ __html: svgStr }}
                />
              );
            }
            return (
              <img
                className="radio-card-img"
                src={iconValue}
                alt=""
                style={{ width: resolvedIconWidth, height: resolvedIconHeight }}
              />
            );
          };

          return (
            <>
              <div
                className="roi-form-group position-relative"
                style={{ opacity: inputOpacity }}
              >
                {label && (
                  <label className='field-label'>
                    {label}{required && <span className="required">*</span>}                    {showInfoTooltip && infoText && (
                      <div className="hint dark">
                        <button type="button" className="info" tabIndex={0}>
                          <Svg name="hint-button" />
                        </button>
                        <div className="popover" dangerouslySetInnerHTML={{ __html: infoText }} />
                      </div>
                    )}
                  </label>
                )}

                {radioStyle === 'card' ? (
                  <div
                    className="radio-card-wrapper"
                    style={{ gridTemplateColumns: `repeat(${cardsPerRow || 3}, 1fr)` }}
                  >
                    {items.map((item, i) => {
                      const radioId = `${ID}-${i}`;
                      const itemValue = getItemValue(item, i);
                      const isSelected = itemValue == currentValue;

                      return (
                        <label
                          key={i}
                          htmlFor={radioId}
                          className={`radio-card-option${isSelected ? ' selected' : ''}${cardAlignment === 'center' ? ' align-center' : cardAlignment === 'right' ? ' align-right' : ''}`}
                          onClick={(e) => {
                            if (isSelected) {
                              e.preventDefault();
                              onRadioClick(uuid, '');
                            }
                          }}
                        >
                          <input
                            type="radio"
                            value={itemValue}
                            id={radioId}
                            name={ID}
                            checked={isSelected}
                            onChange={() => onRadioClick(uuid, itemValue)}
                          />
                          <div className="radio-card-heading">
                            {item.iconUpload ? renderUploadedIcon(item.iconUpload, isSelected) : null}
                            <span className="radio-card-title">{item.RadioOption}</span>
                          </div>
                          {item.description && (
                            <p className="radio-card-desc">{item.description}</p>
                          )}
                        </label>
                      );
                    })}
                  </div>
                ) : (
                  <div className="roi-check-wrap">
                    {items.map((item, i) => {
                      const radioId = `${ID}-${i}`;
                      const itemValue = getItemValue(item, i);

                      return (
                        <label className="form-check" key={i} htmlFor={radioId}>
                          <input
                            className="form-check-input"
                            type="radio"
                            value={itemValue}
                            id={radioId}
                            name={ID}
                            checked={itemValue == currentValue}
                            onChange={() => onRadioClick(uuid, itemValue)}
                          />
                          <span className="form-check-label" >
                            {item.RadioOption}
                          </span>
                        </label>
                      );
                    })}
                  </div>
                )}
                {errorMessage && (
                  <div className="input-error">{errorMessage}</div>
                )}
              </div>

            </>
          );
        },
      },

      PhoneNumber: {
        render: ({
          label,
          showLabel,
          placeholder,
          required,
          errorMessage,
          value,
          hide,
          Style,
          Font,
          Border,
          Padding,
          Margin,
          uuid
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }
          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-form-group ${Style?.customMargin ? "" : "mb-3"
                  } position-relative`}
                style={{
                  opacity: inputOpacity,
                  margin: `${Margin?.top}px ${Margin?.right}px ${Margin?.bottom}px ${Margin?.left}px`,
                }}
              >
                {showLabel && (
                  <label className="field-label">
                    {label}{required && <span className="required">*</span>}                  </label>
                )}
                <input
                  type="text"
                  className={`form-control ${Font?.fontWeight} ${Font?.fontSize ? `${Font?.fontSize}` : "fs-18"
                    } ${errorMessage ? "error" : ""}`}
                  placeholder={placeholder}
                  value={value}
                  id={uuid}
                  required={required}
                  style={{
                    backgroundColor: `${Style?.BackgroundColor}`,
                    color: `${Style?.Color}`,

                    padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,

                    borderStyle: `${Border?.BorderStyle}`,
                    borderColor: `${Border?.BorderColor}`,
                    borderWidth: `${Border?.BorderWidth}px`,
                    borderRadius: `${Border?.BorderRadius}px`,
                    height: `${Style?.Height}px`,
                    textAlign: Font?.Align,
                  }}
                />
                {errorMessage && (
                  <div className="input-error">{errorMessage}</div>
                )}
              </div>
            </>
          );
        },
      },

      Email: {
        render: ({
          label,
          placeholder,
          required,
          errorMessage,
          value,
          hide,
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className="roi-form-group mb-3 position-relative"
                style={{ opacity: inputOpacity }}
              >
                {label && (
                  <label className="field-label">
                    {label}{required && <span className="required">*</span>}                  </label>
                )}
                <input
                  type="text"
                  className={`form-control ${errorMessage ? "error" : ""}`}
                  placeholder={placeholder}
                  value={value}
                  required={required}
                />
                {errorMessage && (
                  <div className="input-error">{errorMessage}</div>
                )}
              </div>
            </>
          );
        },
      },

      Date: {
        render: ({
          label,
          required,
          errorMessage,
          hide,
          onChange,
          placeholder,
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }
          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className="roi-form-group mb-3 position-relative"
                style={{ opacity: inputOpacity }}
              >
                {label && (
                  <label className="field-label">
                    {label}{required && <span className="required">*</span>}                  </label>
                )}
                <input
                  type="text"
                  className={`form-control ${errorMessage ? "error" : ""}`}
                  placeholder={placeholder}
                  required={required}
                  onChange={onChange}
                />

                {/* <input type="text" className={`form-control ${errorMessage ? 'error' : ''}`} placeholder={placeholder} value={value} required={required} /> */}
                {/* <DateField /> */}
                {errorMessage && (
                  <div className="input-error">{errorMessage}</div>
                )}
              </div>
            </>
          );
        },
      },

      Range: {
        render: ({
          label,
          required,
          errorMessage,
          hide,
          uuid,
          value,
          minValue,
          maxValue,
          stepValue,
          defaultValue,
          showInputBox,
          showInfoTooltip,
          infoText
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          const min = minValue || 0;
          const max = maxValue || 5000;
          const step = stepValue || 100;
          const parseRangeInt = (v) => {
            if (v === undefined || v === null || v === "") return NaN;
            const n = parseInt(roiParseNumericInputString(String(v)), 10);
            return Number.isFinite(n) ? n : NaN;
          };
          let initialValue = min;
          const pv = parseRangeInt(value);
          if (Number.isFinite(pv)) {
            initialValue = pv;
          } else {
            const pd = parseRangeInt(defaultValue);
            if (Number.isFinite(pd)) initialValue = pd;
          }
          if (initialValue > max) initialValue = max;
          if (initialValue <= 0) initialValue = step;

          // Create a unique ID for the range elements
          const rangeId = `range-${uuid || Math.random().toString(36).substr(2, 9)}`;
          const sliderId = `slider-${rangeId}`;
          const inputId = `input-${rangeId}`;

          // Clamp handler: values <= 0 snap to the configured step (e.g. 100)
          // keeping slider positions on the correct grid (0,100,200…)
          const clampRangeValue = (val) => {
            const n = parseInt(roiParseNumericInputString(String(val)), 10);
            if (isNaN(n) || n <= 0) return step; // snap to first step, not 1
            if (n > max) return max;
            return n;
          };

          // React maps onChange for type="range" to fire during drag (like input),
          // which triggered onRangeChange → setRenderData every frame and broke dragging.
          const handleSliderInput = (e) => {
            const newValue = clampRangeValue(e.target.value);
            e.target.value = newValue;
            const inputBox = document.getElementById(inputId);
            if (inputBox) inputBox.value = formatRoiFieldDisplayValue(String(newValue));
          };

          const commitSliderToServer = (e) => {
            const newValue = clampRangeValue(e.target.value);
            e.target.value = newValue;
            const inputBox = document.getElementById(inputId);
            if (inputBox) inputBox.value = formatRoiFieldDisplayValue(String(newValue));
            if (uuid) {
              onRangeChange(uuid, newValue);
            }
          };

          const handleRangeKeyUp = (e) => {
            if (!uuid) return;
            const k = e.key;
            if (
              k === "ArrowLeft" ||
              k === "ArrowRight" ||
              k === "Home" ||
              k === "End" ||
              k === "PageUp" ||
              k === "PageDown"
            ) {
              commitSliderToServer(e);
            }
          };

          const handleInputChange = (e) => {
            const newValue = clampRangeValue(e.target.value);
            const slider = document.getElementById(sliderId);
            if (slider) slider.value = newValue;
            e.target.value = formatRoiFieldDisplayValue(String(newValue));
            if (uuid) {
              onRangeChange(uuid, newValue);
            }
          };

          const handleRangeNumberFocus = (e) => {
            const stripped = roiParseNumericInputString(String(e.target.value));
            if (/^-?\d+(\.\d+)?$/.test(stripped)) {
              e.target.value = stripped;
            }
          };

          return (
            <>
              <div className="roi-form-group mb-3 position-relative">

                <div className="range-control-wrap">
                  <div className="flex-grow-1">
                    {label && (
                      <label className='field-label'>
                        {label}{required && <span className="required">*</span>}                        {showInfoTooltip && infoText && (
                          <div className="hint dark">
                            <button type="button" className="info" tabIndex={0}>
                              <Svg name="hint-button" />
                            </button>
                            <div className="popover" dangerouslySetInnerHTML={{ __html: infoText }} />
                          </div>
                        )}
                      </label>
                    )}
                    <input
                      type="range"
                      id={sliderId}
                      min={min}
                      max={max}
                      step={step}
                      defaultValue={initialValue}
                      className={`roi-native-range-slider ${errorMessage ? "error" : ""}`}
                      onInput={handleSliderInput}
                      onPointerUp={commitSliderToServer}
                      onPointerCancel={commitSliderToServer}
                      onBlur={commitSliderToServer}
                      onKeyUp={handleRangeKeyUp}
                    />
                  </div>
                  {showInputBox !== false && (
                    <input
                      type="text"
                      inputMode="numeric"
                      id={inputId}
                      defaultValue={formatRoiFieldDisplayValue(String(initialValue))}
                      onBlur={handleInputChange}
                      onFocus={handleRangeNumberFocus}
                      onWheel={handleWheelPrevention}
                      onMouseWheel={handleWheelPrevention}
                      onKeyDown={(e) => {
                        if (e.key === '-' || e.key === 'e' || e.key === 'E' || e.key === '+') {
                          e.preventDefault();
                          return;
                        }
                        if (e.key === 'Enter') handleInputChange(e);
                      }}
                      className={`range-input-box form-control ${errorMessage ? "error" : ""}`}
                    />
                  )}
                </div>
                {errorMessage && (
                  <div className="input-error">{errorMessage}</div>
                )}
              </div>
            </>
          );
        },
      },

      OptionSelector: {
        render: ({
          label,
          required,
          errorMessage,
          hide,
          uuid,
          value,
          options,
          customInputLabel,
          prefix,
          suffix,
          showInfoTooltip,
          infoText
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Create unique IDs for this instance
          const selectorId = `option-selector-${uuid || Math.random().toString(36).substr(2, 9)}`;
          const inputId = `custom-input-${selectorId}`;

          // Get current value
          const currentValue = value || '';

          const handleOptionClick = (optionValue) => {
            const input = document.getElementById(inputId);
            if (input) {
              input.value = formatRoiFieldDisplayValue(String(optionValue));
            }
            // Update all option buttons
            const buttons = document.querySelectorAll(`[data-selector-id="${selectorId}"]`);
            buttons.forEach(btn => {
              if (btn.dataset.value === optionValue) {
                btn.style.borderColor = '#E60000';
                btn.style.color = '#E60000';
                btn.style.backgroundColor = '#fff5f5';
              } else {
                btn.style.borderColor = '#e0e0e0';
                btn.style.color = '#333';
                btn.style.backgroundColor = '#fff';
              }
            });
            // Clear dropdown selection
            const dropdown = document.getElementById(`dropdown-${selectorId}`);
            if (dropdown) {
              dropdown.value = '';
            }
            // Trigger change handler
            if (uuid) {
              onOptionSelectorChange(uuid, optionValue);
            }
          };

          const handleDropdownChange = (e) => {
            const selectedValue = e.target.value;
            if (selectedValue) {
              const input = document.getElementById(inputId);
              if (input) {
                input.value = formatRoiFieldDisplayValue(String(selectedValue));
              }
              // Clear all button selections
              const buttons = document.querySelectorAll(`[data-selector-id="${selectorId}"]`);
              buttons.forEach(btn => {
                btn.style.borderColor = '#e0e0e0';
                btn.style.color = '#333';
                btn.style.backgroundColor = '#fff';
              });
              // Trigger change handler
              if (uuid) {
                onOptionSelectorChange(uuid, selectedValue);
              }
            }
          };

          const handleInputChange = (e) => {
            let stripped = roiParseNumericInputString(String(e.target.value));
            let inputValue = stripped;
            if (inputValue !== '') {
              const numericValue = parseFloat(inputValue);
              if (!isNaN(numericValue) && numericValue <= 0) {
                inputValue = '1';
              }
            }
            // Clear all button selections when typing custom value
            const buttons = document.querySelectorAll(`[data-selector-id="${selectorId}"]`);
            buttons.forEach(btn => {
              btn.style.borderColor = '#e0e0e0';
              btn.style.color = '#333';
              btn.style.backgroundColor = '#fff';
            });
            // Clear dropdown
            const dropdown = document.getElementById(`dropdown-${selectorId}`);
            if (dropdown) {
              dropdown.value = '';
            }
            if (uuid && inputValue !== '') {
              onOptionSelectorChange(uuid, inputValue);
            }
            e.target.value =
              inputValue === '' ? '' : formatRoiFieldDisplayValue(inputValue);
          };

          const handleOptionCustomFocus = (ev) => {
            const stripped = roiParseNumericInputString(String(ev.target.value));
            if (/^-?\d+(\.\d+)?$/.test(stripped)) {
              ev.target.value = stripped;
            }
          };

          return (
            <>
              <div className="roi-form-group mb-3 position-relative">
                {label && (
                  <label className='field-label'>
                    {label}{required && <span className="required">*</span>}                    {showInfoTooltip && infoText && (
                      <div className="hint dark">
                        <button type="button" className="info" tabIndex={0}>
                          <Svg name="hint-button" />
                        </button>
                        <div className="popover" dangerouslySetInnerHTML={{ __html: infoText }} />
                      </div>
                    )}
                  </label>
                )}
                <div className="option-selector-options">
                  {options?.map((option, i) => {
                    const isSelected = currentValue === option.value;
                    return (
                      <button
                        key={i}
                        type="button"
                        data-selector-id={selectorId}
                        data-value={option.value}
                        onClick={() => handleOptionClick(option.value)}
                        className={`option-selector-btn${isSelected ? ' selected' : ''}`}
                      >
                        {formatRoiCurrencyDescription(String(option.label ?? ''))}
                      </button>
                    );
                  })}
                  <div className="option-selector-custom-wrap">
                    <select
                      id={`dropdown-${selectorId}`}
                      onChange={handleDropdownChange}
                      className="option-selector-select form-control"
                    >
                      <option value="">{customInputLabel || 'Enter value'}</option>
                    </select>
                    <input
                      type="text"
                      inputMode="decimal"
                      id={inputId}
                      defaultValue={
                        !currentValue || currentValue === ''
                          ? ''
                          : formatRoiFieldDisplayValue(String(currentValue))
                      }
                      placeholder={customInputLabel || 'Enter value'}
                      onBlur={handleInputChange}
                      onFocus={handleOptionCustomFocus}
                      onWheel={handleWheelPrevention}
                      onMouseWheel={handleWheelPrevention}
                      onKeyDown={(e) => {
                        if (e.key === '-' || e.key === 'e' || e.key === 'E' || e.key === '+') {
                          e.preventDefault();
                          return;
                        }
                        if (e.key === 'Enter') handleInputChange(e);
                      }}
                      className="option-selector-input form-control"
                    />

                  </div>
                </div>
                {errorMessage && (
                  <div className="input-error">{errorMessage}</div>
                )}
              </div>
            </>
          );
        },
      },

      Toggle: {
        render: ({ label, required, hide }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className="roi-form-group mb-3 position-relative"
                style={{ opacity: inputOpacity }}
              >
                {label && (
                  <label className="field-label">
                    {label}{required && <span className="required">*</span>}                  </label>
                )}
                <div className="check-switch">
                  <label>No</label>
                  <input id="agree-check" type="checkbox" defaultChecked />
                  <label>Yes</label>
                </div>
              </div>
            </>
          );
        },
      },

      Button: {
        render: ({
          buttonText,
          buttonAction,
          conditionalLogic,
          buttonLink,
          buttonStyle,
          buttonicon,
          hide,
          uuid,
          customStyle,
          Style,
          spacing,
          iconPosition,
          popupTargetId,
          buttonAlignment,
        }) => {
          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          const handleOpenPopupClick = () => {
            const cleanId = popupTargetId ? popupTargetId.trim().replace(/^#/, '') : '';
            if (cleanId) {
              setOpenModalId(cleanId);
            }
            onButtonClick(uuid);
          };

          return (
            <>
              <div
                className={`button-wrap text-${buttonAlignment}`}
                style={{ opacity: inputOpacity }}
              >
                {(() => {
                  if (buttonAction === "OpenPopup") {
                    return buttonicon === "yes" ? (
                      <button
                        onClick={handleOpenPopupClick}
                        className={`d-inline-flex align-items-center btn roi-btn-${buttonStyle} ${customStyle
                          ? `custom-style ${Style?.Font?.fontWeight} ${Style?.Font?.fontSize}`
                          : ""
                          }`}
                        type="button"
                        style={
                          customStyle
                            ? {
                              backgroundColor: Style?.BackgroundColor,
                              color: Style?.Font?.Color,
                              padding: `${Style?.Padding?.top}px ${Style?.Padding?.right}px ${Style?.Padding?.bottom}px ${Style?.Padding?.left}px`,
                              margin: `${Style?.Margin?.top}px ${Style?.Margin?.right}px ${Style?.Margin?.bottom}px ${Style?.Margin?.left}px`,
                              borderStyle: Style?.Border?.BorderStyle,
                              borderColor: Style?.Border?.BorderColor,
                              borderWidth: `${Style?.Border?.BorderWidth?.top}px ${Style?.Border?.BorderWidth?.right}px ${Style?.Border?.BorderWidth?.bottom}px ${Style?.Border?.BorderWidth?.left}px`,
                              borderRadius: `${Style?.Border.BorderRadius}px`,
                              gap: `${spacing ? `${spacing}px` : "20px"}`,
                            }
                            : { gap: `${spacing ? `${spacing}px` : "20px"}` }
                        }
                      >
                        {iconPosition === "left" ? (
                          customStyle ? (
                            <>
                              <Svg name="arrow-right-icn-roi" />
                              {buttonText}
                            </>
                          ) : (
                            <>
                              <Svg name="arrow-right-icn-roi" />
                              {buttonText}
                            </>
                          )
                        ) : iconPosition === "right" ? (
                          customStyle ? (
                            <>
                              {buttonText}
                              <Svg name="arrow-right-icn-roi" />
                            </>
                          ) : (
                            <>
                              {buttonText}
                              <Svg name="arrow-right-icn-roi" />
                            </>
                          )
                        ) : (
                          <>
                            {buttonText}
                            <Svg name="arrow-right-icn-roi" />
                          </>
                        )}
                      </button>
                    ) : (
                      <button
                        onClick={handleOpenPopupClick}
                        className={`btn roi-btn-${buttonStyle} ${customStyle
                          ? `custom-style ${Style?.Font?.fontWeight} ${Style?.Font?.fontSize}`
                          : ""
                          }`}
                        type="button"
                        style={
                          customStyle
                            ? {
                              backgroundColor: Style?.BackgroundColor,
                              color: Style?.Font?.Color,
                              padding: `${Style?.Padding?.top}px ${Style?.Padding?.right}px ${Style?.Padding?.bottom}px ${Style?.Padding?.left}px`,
                              margin: `${Style?.Margin?.top}px ${Style?.Margin?.right}px ${Style?.Margin?.bottom}px ${Style?.Margin?.left}px`,
                              borderStyle: Style?.Border?.BorderStyle,
                              borderColor: Style?.Border?.BorderColor,
                              borderWidth: `${Style?.Border?.BorderWidth?.top}px ${Style?.Border?.BorderWidth?.right}px ${Style?.Border?.BorderWidth?.bottom}px ${Style?.Border?.BorderWidth?.left}px`,
                              borderRadius: `${Style?.Border.BorderRadius}px`,
                            }
                            : {}
                        }
                      >
                        {buttonText}
                      </button>
                    );
                  } else if (buttonAction === "ClosePopup") {
                    return buttonicon === "yes" ? (
                      <button
                        data-bs-dismiss="modal"
                        onClick={() => onButtonClick(uuid, "ClosePopup")}
                        className={`d-inline-flex align-items-center btn roi-btn-${buttonStyle} ${customStyle
                          ? `custom-style ${Style?.Font?.fontWeight} ${Style?.Font?.fontSize}`
                          : ""
                          }`}
                        type="submit"
                        style={
                          customStyle
                            ? {
                              backgroundColor: Style?.BackgroundColor,
                              color: Style?.Font?.Color,
                              padding: `${Style?.Padding?.top}px ${Style?.Padding?.right}px ${Style?.Padding?.bottom}px ${Style?.Padding?.left}px`,
                              margin: `${Style?.Margin?.top}px ${Style?.Margin?.right}px ${Style?.Margin?.bottom}px ${Style?.Margin?.left}px`,
                              borderStyle: Style?.Border?.BorderStyle,
                              borderColor: Style?.Border?.BorderColor,
                              borderWidth: `${Style?.Border?.BorderWidth?.top}px ${Style?.Border?.BorderWidth?.right}px ${Style?.Border?.BorderWidth?.bottom}px ${Style?.Border?.BorderWidth?.left}px`,
                              borderRadius: `${Style?.Border.BorderRadius}px`,
                              gap: `${spacing ? `${spacing}px` : "20px"}`,
                            }
                            : { gap: `${spacing ? `${spacing}px` : "20px"}` }
                        }
                      >
                        {iconPosition === "left" ? (
                          customStyle ? (
                            <>
                              <Svg name="arrow-right-icn-roi" />
                              {buttonText}
                            </>
                          ) : (
                            <>
                              <Svg name="arrow-right-icn-roi" />
                              {buttonText}
                            </>
                          )
                        ) : iconPosition === "right" ? (
                          customStyle ? (
                            <>
                              {buttonText}
                              <Svg name="arrow-right-icn-roi" />
                            </>
                          ) : (
                            <>
                              {buttonText}
                              <Svg name="arrow-right-icn-roi" />
                            </>
                          )
                        ) : (
                          <>
                            {buttonText}
                            <Svg name="arrow-right-icn-roi" />
                          </>
                        )}
                      </button>
                    ) : (
                      <button
                        data-bs-dismiss="modal"
                        onClick={() => onButtonClick(uuid, "ClosePopup 2")}
                        className={`btn roi-btn-${buttonStyle} ${customStyle
                          ? `custom-style ${Style?.Font?.fontWeight} ${Style?.Font?.fontSize}`
                          : ""
                          }`}
                        type="submit"
                        style={
                          customStyle
                            ? {
                              backgroundColor: Style?.BackgroundColor,
                              color: Style?.Font?.Color,
                              padding: `${Style?.Padding?.top}px ${Style?.Padding?.right}px ${Style?.Padding?.bottom}px ${Style?.Padding?.left}px`,
                              margin: `${Style?.Margin?.top}px ${Style?.Margin?.right}px ${Style?.Margin?.bottom}px ${Style?.Margin?.left}px`,
                              borderStyle: Style?.Border?.BorderStyle,
                              borderColor: Style?.Border?.BorderColor,
                              borderWidth: `${Style?.Border?.BorderWidth?.top}px ${Style?.Border?.BorderWidth?.right}px ${Style?.Border?.BorderWidth?.bottom}px ${Style?.Border?.BorderWidth?.left}px`,
                              borderRadius: `${Style?.Border.BorderRadius}px`,
                            }
                            : {}
                        }
                      >
                        {buttonText}
                      </button>
                    );
                  } else if (buttonAction === "ResetForm") {

                    return buttonicon === "yes" ? (
                      <button
                        // onMouseDown={(e) => {
                        //   // Handle button logic here before blur/render happens
                        //   // e.preventDefault(); // optional: prevent focus loss
                        //   onButtonClick(uuid, "nothing");
                        // }}
                        //onClick={handleRecalculateClick} // Added onClick
                        data-bs-toggle="modal"
                        data-bs-target="#logoPrompt"

                        // onClick={() => onButtonClick(uuid, "nothing")}
                        className={`d-inline-flex align-items-center btn roi-btn-${buttonStyle} ${customStyle
                          ? `custom-style ${Style?.Font?.fontWeight} ${Style?.Font?.fontSize}`
                          : ""
                          }`}
                        type="submit"
                        style={
                          customStyle
                            ? {
                              backgroundColor: Style?.BackgroundColor,
                              color: Style?.Font?.Color,
                              padding: `${Style?.Padding?.top}px ${Style?.Padding?.right}px ${Style?.Padding?.bottom}px ${Style?.Padding?.left}px`,
                              margin: `${Style?.Margin?.top}px ${Style?.Margin?.right}px ${Style?.Margin?.bottom}px ${Style?.Margin?.left}px`,
                              borderStyle: Style?.Border?.BorderStyle,
                              borderColor: Style?.Border?.BorderColor,
                              borderWidth: `${Style?.Border?.BorderWidth?.top}px ${Style?.Border?.BorderWidth?.right}px ${Style?.Border?.BorderWidth?.bottom}px ${Style?.Border?.BorderWidth?.left}px`,
                              borderRadius: `${Style?.Border.BorderRadius}px`,
                              gap: `${spacing ? `${spacing}px` : "20px"}`,
                            }
                            : { gap: `${spacing ? `${spacing}px` : "20px"}` }
                        }
                      >
                        {iconPosition === "left" ? (
                          customStyle ? (
                            <>
                              <Svg name="roi-button-icon-2" /> {buttonText}
                            </>
                          ) : (
                            <>
                              <div className="icon">
                                <Svg name="roi-button-icon" />
                              </div>
                              {buttonText}
                            </>
                          )
                        ) : iconPosition === "right" ? (
                          customStyle ? (
                            <>
                              {buttonText} <Svg name="roi-button-icon-2" />
                            </>
                          ) : (
                            <>
                              {buttonText}
                              <div className="icon">
                                <Svg name="roi-button-icon" />
                              </div>
                            </>
                          )
                        ) : (
                          <>
                            {buttonText}
                            <div className="icon">
                              <Svg name="roi-button-icon" />
                            </div>
                          </>
                        )}
                      </button>
                    ) : (
                      <button // Added onClick
                        data-bs-toggle="modal"
                        data-bs-target="#logoPrompt"
                        className={`btn roi-btn-${buttonStyle} ${customStyle
                          ? `custom-style ${Style?.Font?.fontWeight} ${Style?.Font?.fontSize}`
                          : ""
                          }`}
                        type="submit"
                        style={
                          customStyle
                            ? {
                              backgroundColor: Style?.BackgroundColor,
                              color: Style?.Font?.Color,
                              padding: `${Style?.Padding?.top}px ${Style?.Padding?.right}px ${Style?.Padding?.bottom}px ${Style?.Padding?.left}px`,
                              margin: `${Style?.Margin?.top}px ${Style?.Margin?.right}px ${Style?.Margin?.bottom}px ${Style?.Margin?.left}px`,
                              borderStyle: Style?.Border?.BorderStyle,
                              borderColor: Style?.Border?.BorderColor,
                              borderWidth: `${Style?.Border?.BorderWidth?.top}px ${Style?.Border?.BorderWidth?.right}px ${Style?.Border?.BorderWidth?.bottom}px ${Style?.Border?.BorderWidth?.left}px`,
                              borderRadius: `${Style?.Border.BorderRadius}px`,
                            }
                            : {}
                        }
                      >
                        {buttonText}
                      </button>
                    );

                  } else {
                    const isJumpBtn = buttonAction === "JumpToPage";
                    return buttonicon === "yes" ? (
                      <button
                        onMouseDown={(e) => {
                          // Handle button logic here before blur/render happens
                          // e.preventDefault(); // optional: prevent focus loss
                          onButtonClick(uuid, "nothing");
                        }}
                        // onClick={() => onButtonClick(uuid, "nothing")}
                        className={`d-inline-flex align-items-center btn roi-btn-${buttonStyle} ${customStyle
                          ? `custom-style ${Style?.Font?.fontWeight} ${Style?.Font?.fontSize}`
                          : ""
                          }`}
                        type="submit"
                        style={
                          customStyle
                            ? {
                              backgroundColor: Style?.BackgroundColor,
                              color: Style?.Font?.Color,
                              padding: `${Style?.Padding?.top}px ${Style?.Padding?.right}px ${Style?.Padding?.bottom}px ${Style?.Padding?.left}px`,
                              margin: `${Style?.Margin?.top}px ${Style?.Margin?.right}px ${Style?.Margin?.bottom}px ${Style?.Margin?.left}px`,
                              borderStyle: Style?.Border?.BorderStyle,
                              borderColor: Style?.Border?.BorderColor,
                              borderWidth: `${Style?.Border?.BorderWidth?.top}px ${Style?.Border?.BorderWidth?.right}px ${Style?.Border?.BorderWidth?.bottom}px ${Style?.Border?.BorderWidth?.left}px`,
                              borderRadius: `${Style?.Border.BorderRadius}px`,
                              gap: `${spacing ? `${spacing}px` : "20px"}`,
                            }
                            : { gap: `${spacing ? `${spacing}px` : "20px"}` }
                        }
                      >
                        {iconPosition === "left" ? (
                          customStyle ? (
                            <>
                              <Svg name="roi-button-icon-2" /> {buttonText}
                            </>
                          ) : (
                            <>
                              <div className="icon">
                                <Svg name="roi-button-icon" />
                              </div>
                              {buttonText}
                            </>
                          )
                        ) : iconPosition === "right" ? (
                          customStyle ? (
                            <>
                              {buttonText} <Svg name="roi-button-icon-2" />
                            </>
                          ) : (
                            <>
                              {buttonText}
                              <div className="icon">
                                <Svg name="roi-button-icon" />
                              </div>
                            </>
                          )
                        ) : (
                          <>
                            {buttonText}
                            <div className="icon">
                              <Svg name="roi-button-icon" />
                            </div>
                          </>
                        )}
                      </button>
                    ) : (
                      <button
                        onClick={() => onButtonClick(uuid, "nothing 2")}
                        className={`btn roi-btn-${buttonStyle} ${customStyle
                          ? `custom-style ${Style?.Font?.fontWeight} ${Style?.Font?.fontSize}`
                          : ""
                          }`}
                        type="submit"
                        style={
                          customStyle
                            ? {
                              backgroundColor: Style?.BackgroundColor,
                              color: Style?.Font?.Color,
                              padding: `${Style?.Padding?.top}px ${Style?.Padding?.right}px ${Style?.Padding?.bottom}px ${Style?.Padding?.left}px`,
                              margin: `${Style?.Margin?.top}px ${Style?.Margin?.right}px ${Style?.Margin?.bottom}px ${Style?.Margin?.left}px`,
                              borderStyle: Style?.Border?.BorderStyle,
                              borderColor: Style?.Border?.BorderColor,
                              borderWidth: `${Style?.Border?.BorderWidth?.top}px ${Style?.Border?.BorderWidth?.right}px ${Style?.Border?.BorderWidth?.bottom}px ${Style?.Border?.BorderWidth?.left}px`,
                              borderRadius: `${Style?.Border.BorderRadius}px`,
                            }
                            : {}
                        }
                      >
                        {buttonText}
                      </button>
                    );
                  }
                })()}
              </div>
            </>
          );
        },
      },

      //Bootstrap modal component - controlled by React state
      BootstrapModal: {
        render: ({ modalId, _editorPreviewContent, children, modalSize }) => {
          // Check if this modal should be open
          const isOpen = openModalId === modalId;

          // Close modal handler
          const closeModal = (e) => {
            e.stopPropagation();
            setOpenModalId(null);
          };

          // Prevent clicks inside modal from closing it
          const handleModalContentClick = (e) => {
            e.stopPropagation();
          };

          return (
            <>
              {/* Modal */}
              <div
                className={`modal fade ${isOpen ? 'show' : ''}`}
                id={modalId}
                tabIndex="-1"
                aria-labelledby={`${modalId}Label`}
                aria-hidden={!isOpen}
                style={{ display: isOpen ? 'block' : 'none' }}
                onClick={closeModal}
              >
                <div
                  className={`modal-dialog modal-dialog-centered p-0 ${modalSize || ''}`}
                  onClick={handleModalContentClick}
                >
                  <div className="modal-content" onClick={handleModalContentClick}>
                    <div className="modal-header">
                      <button
                        type="button"
                        className="btn-close"
                        aria-label="Close"
                        onClick={closeModal}
                      ></button>
                    </div>
                    <div className="modal-body modal-body-roi-landing-form" onClick={handleModalContentClick}>
                      <DropZone zone="wrapper" />
                    </div>
                  </div>
                </div>
              </div>
              {/* Backdrop */}
              {isOpen && <div className="modal-backdrop fade show" onClick={closeModal}></div>}
            </>
          );
        },
      },
      ProgressBar: {
        render: ({
          value,
          minValue,
          maxValue,
          barColor,
          height,
          ariaLabel,
          puck,
        }) => {
          const percentage = ((value - minValue) / (maxValue - minValue)) * 100;
          const clampedPercentage = Math.min(Math.max(percentage, 0), 100);

          const progressBarStyle = {
            width: `${clampedPercentage}%`,
          };
          if (barColor) {
            progressBarStyle.backgroundColor = barColor;
          }

          const progressContainerStyle = {};
          if (typeof height === "number") {
            // Check if height is a number
            progressContainerStyle.height = `${height}px`; // Append 'px'
          }

          return (
            <div
              className="progress"
              role="progressbar"
              aria-label={ariaLabel || "Progress bar"}
              aria-valuenow={value}
              aria-valuemin={minValue}
              aria-valuemax={maxValue}
              style={progressContainerStyle}
            >
              <div
                className="roi-progress-bar progress-bar"
                style={progressBarStyle}
              >
                {/* Label is removed */}
              </div>
            </div>
          );
        },
      },

      // CheckList Component - List with checkmark icons or bullet points
      CheckList: {
        render: ({ listStyle, listIconType, Heading, Items, ItemStyle, backgroundColor, Padding, hide }) => {
          const { iconColor, iconMarkColor, iconSize: listIconSize, titleColor, titleFontSize, titleFontWeight, descriptionColor, descriptionFontSize, descriptionFontWeight } = ItemStyle || {};
          const markColor = iconMarkColor || '#ffffff';
          if (hide) {
            return null;
          }

          const getChecklistDisplaySrc = (imgValue) => {
            if (typeof imgValue === 'string' && imgValue.trim().startsWith('<svg')) {
              return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(imgValue)}`;
            }
            return imgValue;
          };

          const HeaderIcon = ({ customIcon, strokeColor, size }) => {
            const px = Number(size) || 48;
            if (customIcon) {
              return <img src={getChecklistDisplaySrc(customIcon)} alt="Custom Icon" className="cl-header-icon__img" style={{ width: px, height: px, display: 'block' }} />;
            }

            const s = strokeColor || '#e60000';
            return (
              <svg width={px} height={px} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 5H7C5.89543 5 5 5.89543 5 7V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V7C19 5.89543 18.1046 5 17 5H15" stroke={s} strokeWidth="2" />
                <path d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z" stroke={s} strokeWidth="2" />
                <path d="M9 12L11 14L15 10" stroke={s} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            );
          };

          const resolveItemIconSrc = (imgValue) => {
            if (typeof imgValue === 'string' && imgValue.trim().startsWith('<svg')) {
              return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(imgValue)}`;
            }
            return imgValue;
          };

          const ListIcon = ({ type, color, index, itemIcon, size }) => {
            const px = Number(size) || 24;
            // Per-item uploaded icon takes priority
            if (itemIcon) {
              return <img src={resolveItemIconSrc(itemIcon)} alt="icon" className="cl-list-icon__custom" style={{ width: px, height: px, display: 'block' }} />;
            }

            if (type === 'none' || type === 'custom') return null;

            if (type === 'dot') {
              return <span className="cl-list-icon cl-list-icon--bullet" style={{ backgroundColor: color, width: 5, height: 5 }}></span>;
            }

            if (type === 'number') {
              return (
                <span className="cl-list-icon cl-list-icon--numbered" style={{ backgroundColor: color, color: markColor, width: px, height: px, fontSize: Math.round(px * 0.5) }}>
                  {index}
                </span>
              );
            }

            if (type === 'arrow') {
              return (
                <svg width={px} height={px} viewBox="0 0 24 24" fill="none" className="cl-list-icon__svg">
                  <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              );
            }

            // Default: checkmark
            return (
              <svg width={px} height={px} viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="12" fill={color} />
                <path d="M7 12L10.5 15.5L17 9" stroke={markColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            );
          };

          const ListItem = ({ title, description, index, itemIcon }) => {
            if (!title) return null;

            const isBanner = listStyle === 'banner';
            const resolvedType = listIconType || 'checkmark';
            const showIconWrapper = itemIcon || (resolvedType !== 'none' && resolvedType !== 'custom');
            const listIconTypeClass = `checklist-item--type-${resolvedType}`;

            return (
              <div className={`checklist-item d-flex mb-3 ${listIconTypeClass}`}>
                {showIconWrapper && (
                  <div className={`checklist-icon me-3 ${isBanner ? 'checklist-icon--banner' : ''}`}>
                    <ListIcon type={resolvedType} color={iconColor || '#e60000'} index={index} itemIcon={itemIcon} size={listIconSize} />
                  </div>
                )}
                <div className="checklist-content">
                  <h4 className={`checklist-title ${titleFontSize || 'fs-16'} ${titleFontWeight || 'fw-700'}`} style={{ color: titleColor || '#333333' }}>{title}</h4>
                  {description && <p className={`checklist-description ${descriptionFontSize || 'fs-14'} ${descriptionFontWeight || 'fw-400'}`} style={{ color: descriptionColor || '#666666' }}>{description}</p>}
                </div>
              </div>
            );
          };

          const isBanner = listStyle === 'banner';

          return (
            <div className={`checklist-section ${Padding?.top || ''} ${Padding?.bottom || ''}`} style={{ backgroundColor: backgroundColor || 'transparent' }}>
              <div className="cl-container">
                {Heading?.title && (
                  <div className={`checklist-header ${isBanner && Heading?.showIcon ? 'd-flex align-items-center gap-3' : ''}`}>
                    {isBanner && Heading?.showIcon && (
                      <HeaderIcon customIcon={Heading.customHeaderIcon} strokeColor={iconColor} size={Heading?.iconSize} />
                    )}
                    <h3 className={`checklist-heading mb-0 ${Heading.fontWeight || ''} ${Heading.titleFont || ''}`} style={{ color: Heading.Color || '#333333' }}>
                      {Heading.title}
                    </h3>
                  </div>
                )}
                <div className="checklist-items">
                  {(Items || []).map((item, idx) => (
                    <ListItem key={idx} title={item?.title} description={item?.description} index={idx + 1} itemIcon={item?.iconUpload} />
                  ))}
                </div>
              </div>
            </div>
          );
        },
      },

      // Stacked Bar Chart Component
      StackedBarChart: {
        render: ({ uuid, ChartTitle, Bar1, Bar2, Segment1, Segment2, Segment3, SavingsBadge, ChartSettings, Padding, backgroundColor, hide }) => {
          // Helper function to decode HTML entities
          const decodeHtmlEntities = (str) => {
            if (!str) return str;
            const textarea = document.createElement('textarea');
            textarea.innerHTML = str;
            return textarea.value;
          };

          // Get initial values from roiActionArr_global if UUIDs exist, otherwise use default values
          const getValue = (segmentUuid, defaultValue) => {
            if (segmentUuid && roiActionArr_global.current && roiActionArr_global.current[segmentUuid]) {
              return parseFloat(roiActionArr_global.current[segmentUuid].value) || parseFloat(defaultValue) || 0;
            }
            return parseFloat(defaultValue) || 0;
          };

          // Parse initial values
          const bar1Seg1Init = getValue(Segment1?.bar1Uuid, Segment1?.bar1Value);
          const bar1Seg2Init = getValue(Segment2?.bar1Uuid, Segment2?.bar1Value);
          const bar1Seg3Init = getValue(Segment3?.bar1Uuid, Segment3?.bar1Value);
          const bar2Seg1Init = getValue(Segment1?.bar2Uuid, Segment1?.bar2Value);
          const bar2Seg2Init = getValue(Segment2?.bar2Uuid, Segment2?.bar2Value);
          const bar2Seg3Init = getValue(Segment3?.bar2Uuid, Segment3?.bar2Value);

          const chartHeightVal = parseInt(ChartSettings?.chartHeight) || 350;
          const barWidthVal = parseInt(ChartSettings?.barWidth) || 60;

          // Use the global currency symbol if available - decode HTML entities
          const rawCurrencySymbol = currencySymbol || ChartSettings?.currencySymbol || "£";
          const currencySymbolVal = decodeHtmlEntities(rawCurrencySymbol);

          const paddingTopClass = Padding?.top || '';
          const paddingBottomClass = Padding?.bottom || '';
          const chartTitleFontSize = ChartTitle?.fontSize || '';
          const chartTitleFontWeight = ChartTitle?.fontWeight || '';

          // Function to format currency for display
          const formatCurrencyDisplay = (value, symbol) => {
            const numVal = parseFloat(value) || 0;
            if (numVal >= 1000000) {
              return (
                symbol +
                (numVal / 1000000).toLocaleString(ROI_NUMBER_LOCALE, {
                  maximumFractionDigits: 1,
                  minimumFractionDigits: 0,
                }) +
                "M"
              );
            }
            if (numVal >= 1000) {
              return (
                symbol +
                (numVal / 1000).toLocaleString(ROI_NUMBER_LOCALE, {
                  maximumFractionDigits: 0,
                  minimumFractionDigits: 0,
                }) +
                "k"
              );
            }
            return symbol + numVal.toLocaleString(ROI_NUMBER_LOCALE);
          };

          const formatLegendDisplay = (value, symbol) => {
            const numVal = parseFloat(value) || 0;
            return symbol + numVal.toLocaleString(ROI_NUMBER_LOCALE);
          };

          // Register segment UUIDs for calculation logic updates
          if (Segment1?.bar1Uuid && roiActionArr_global.current) {
            roiActionArr_global.current[Segment1.bar1Uuid] = roiActionArr_global.current[Segment1.bar1Uuid] || { value: bar1Seg1Init };
          }
          if (Segment1?.bar2Uuid && roiActionArr_global.current) {
            roiActionArr_global.current[Segment1.bar2Uuid] = roiActionArr_global.current[Segment1.bar2Uuid] || { value: bar2Seg1Init };
          }
          if (Segment2?.bar1Uuid && roiActionArr_global.current) {
            roiActionArr_global.current[Segment2.bar1Uuid] = roiActionArr_global.current[Segment2.bar1Uuid] || { value: bar1Seg2Init };
          }
          if (Segment2?.bar2Uuid && roiActionArr_global.current) {
            roiActionArr_global.current[Segment2.bar2Uuid] = roiActionArr_global.current[Segment2.bar2Uuid] || { value: bar2Seg2Init };
          }
          if (Segment3?.bar1Uuid && roiActionArr_global.current) {
            roiActionArr_global.current[Segment3.bar1Uuid] = roiActionArr_global.current[Segment3.bar1Uuid] || { value: bar1Seg3Init };
          }
          if (Segment3?.bar2Uuid && roiActionArr_global.current) {
            roiActionArr_global.current[Segment3.bar2Uuid] = roiActionArr_global.current[Segment3.bar2Uuid] || { value: bar2Seg3Init };
          }

          // Update chart function - will be called when values change
          const updateChart = () => {
            const chartContainer = document.querySelector('[data-chart-uuid="' + uuid + '"]');
            if (!chartContainer) return;

            // Get current values
            const bar1Seg1 = getValue(Segment1?.bar1Uuid, Segment1?.bar1Value);
            const bar1Seg2 = getValue(Segment2?.bar1Uuid, Segment2?.bar1Value);
            const bar1Seg3 = getValue(Segment3?.bar1Uuid, Segment3?.bar1Value);
            const bar2Seg1 = getValue(Segment1?.bar2Uuid, Segment1?.bar2Value);
            const bar2Seg2 = getValue(Segment2?.bar2Uuid, Segment2?.bar2Value);
            const bar2Seg3 = getValue(Segment3?.bar2Uuid, Segment3?.bar2Value);

            const bar1Total = bar1Seg1 + bar1Seg2 + bar1Seg3;
            const bar2Total = bar2Seg1 + bar2Seg2 + bar2Seg3;

            // Get Y-axis max - auto-calculate based on data
            const yAxisMaxFromConfig = ChartSettings?.yAxisMaxUuid && roiActionArr_global.current && roiActionArr_global.current[ChartSettings.yAxisMaxUuid]
              ? parseFloat(roiActionArr_global.current[ChartSettings.yAxisMaxUuid].value)
              : parseFloat(ChartSettings?.yAxisMax);
            const calculatedMax = Math.max(bar1Total, bar2Total) * 1.2;
            const yAxisMax = (yAxisMaxFromConfig && yAxisMaxFromConfig >= calculatedMax) ? yAxisMaxFromConfig : calculatedMax || 100;

            // Calculate bar heights in PIXELS
            const bar1Seg1Height = (bar1Seg1 / yAxisMax) * chartHeightVal;
            const bar1Seg2Height = (bar1Seg2 / yAxisMax) * chartHeightVal;
            const bar1Seg3Height = (bar1Seg3 / yAxisMax) * chartHeightVal;
            const bar2Seg1Height = (bar2Seg1 / yAxisMax) * chartHeightVal;
            const bar2Seg2Height = (bar2Seg2 / yAxisMax) * chartHeightVal;
            const bar2Seg3Height = (bar2Seg3 / yAxisMax) * chartHeightVal;

            // Update bar heights using pixels
            const bar1Segments = chartContainer.querySelectorAll('.bar1-segment');
            const bar2Segments = chartContainer.querySelectorAll('.bar2-segment');

            if (bar1Segments[0]) bar1Segments[0].style.height = bar1Seg1Height + "px";
            if (bar1Segments[1]) bar1Segments[1].style.height = bar1Seg2Height + "px";
            if (bar1Segments[2]) bar1Segments[2].style.height = bar1Seg3Height + "px";
            if (bar2Segments[0]) bar2Segments[0].style.height = bar2Seg1Height + "px";
            if (bar2Segments[1]) bar2Segments[1].style.height = bar2Seg2Height + "px";
            if (bar2Segments[2]) bar2Segments[2].style.height = bar2Seg3Height + "px";

            // Update Y-axis labels
            const yAxisLabels = chartContainer.querySelectorAll('.y-axis-label');
            const steps = 5;
            yAxisLabels.forEach((label, index) => {
              const value = (yAxisMax / steps) * (steps - index);
              label.textContent = formatCurrencyDisplay(value, currencySymbolVal);
            });

            // Update legend values
            const legendBar1Values = chartContainer.querySelectorAll('.legend-bar1-value');
            const legendBar2Values = chartContainer.querySelectorAll('.legend-bar2-value');
            if (legendBar1Values[0]) legendBar1Values[0].textContent = Segment1?.name + ": " + formatLegendDisplay(bar1Seg1, currencySymbolVal);
            if (legendBar1Values[1]) legendBar1Values[1].textContent = Segment2?.name + ": " + formatLegendDisplay(bar1Seg2, currencySymbolVal);
            if (legendBar1Values[2]) legendBar1Values[2].textContent = Segment3?.name + ": " + formatLegendDisplay(bar1Seg3, currencySymbolVal);
            if (legendBar2Values[0]) legendBar2Values[0].textContent = Segment1?.name + ": " + formatLegendDisplay(bar2Seg1, currencySymbolVal);
            if (legendBar2Values[1]) legendBar2Values[1].textContent = Segment2?.name + ": " + formatLegendDisplay(bar2Seg2, currencySymbolVal);
            if (legendBar2Values[2]) legendBar2Values[2].textContent = Segment3?.name + ": " + formatLegendDisplay(bar2Seg3, currencySymbolVal);

            // Update savings badge
            const savingsBadge = chartContainer.querySelector('.savings-badge-text');
            if (savingsBadge && SavingsBadge?.textUuid && roiActionArr_global.current[SavingsBadge.textUuid]) {
              savingsBadge.textContent = roiActionArr_global.current[SavingsBadge.textUuid].value;
            }
          };

          // Store update function globally for calculation logic to call
          if (uuid) {
            window.updateStackedBarChart = window.updateStackedBarChart || {};
            window.updateStackedBarChart[uuid] = updateChart;
          }

          // Initial values for rendering
          const bar1Total = bar1Seg1Init + bar1Seg2Init + bar1Seg3Init;
          const bar2Total = bar2Seg1Init + bar2Seg2Init + bar2Seg3Init;

          // Calculate Y-axis max - auto-calculate based on data if not specified
          const yAxisMaxFromConfig = ChartSettings?.yAxisMaxUuid && roiActionArr_global.current && roiActionArr_global.current[ChartSettings.yAxisMaxUuid]
            ? parseFloat(roiActionArr_global.current[ChartSettings.yAxisMaxUuid].value)
            : parseFloat(ChartSettings?.yAxisMax);
          // Use auto-calculated max if config value is 0, NaN, or less than the actual max
          const calculatedMax = Math.max(bar1Total, bar2Total) * 1.2;
          const yAxisMax = (yAxisMaxFromConfig && yAxisMaxFromConfig >= calculatedMax) ? yAxisMaxFromConfig : calculatedMax || 100;

          // Calculate bar heights in PIXELS (not percentages) for proper rendering
          const bar1Seg1Height = (bar1Seg1Init / yAxisMax) * chartHeightVal;
          const bar1Seg2Height = (bar1Seg2Init / yAxisMax) * chartHeightVal;
          const bar1Seg3Height = (bar1Seg3Init / yAxisMax) * chartHeightVal;
          const bar2Seg1Height = (bar2Seg1Init / yAxisMax) * chartHeightVal;
          const bar2Seg2Height = (bar2Seg2Init / yAxisMax) * chartHeightVal;
          const bar2Seg3Height = (bar2Seg3Init / yAxisMax) * chartHeightVal;

          // Get savings text
          const savingsText = SavingsBadge?.textUuid && roiActionArr_global.current && roiActionArr_global.current[SavingsBadge.textUuid]
            ? roiActionArr_global.current[SavingsBadge.textUuid].value
            : (SavingsBadge?.text || "");

          // Generate Y-axis labels
          const yAxisLabels = [];
          const steps = 5;
          for (let i = steps; i >= 0; i--) {
            yAxisLabels.push(formatCurrencyDisplay((yAxisMax / steps) * i, currencySymbolVal));
          }

          return (
            <div
              className={"stacked-bar-chart-section " + paddingTopClass + " " + paddingBottomClass}
              style={{ backgroundColor: backgroundColor || '#ffffff', padding: '20px', display: hide ? 'none' : 'block' }}
              data-chart-uuid={uuid}
            >
              <div className="container">
                {/* Chart Title */}
                {ChartTitle?.title && (
                  <h3 className={"chart-title mb-4 " + chartTitleFontSize + " " + chartTitleFontWeight} style={{ color: ChartTitle.color || '#333333' }}>
                    {ChartTitle.title}
                  </h3>
                )}

                {/* Chart Container */}
                <div className="chart-container" style={{ display: 'flex', alignItems: 'stretch' }}>
                  {/* Y-Axis */}
                  <div className="y-axis" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: chartHeightVal + "px", paddingRight: '10px', fontSize: '12px', color: '#666', textAlign: 'right', minWidth: '60px' }}>
                    {yAxisLabels.map((label, index) => (
                      <span key={index} className="y-axis-label">{label}</span>
                    ))}
                  </div>

                  {/* Bars Container */}
                  <div className="bars-container" style={{ display: 'flex', justifyContent: 'space-around', flex: 1, alignItems: 'flex-end', height: chartHeightVal + "px", borderLeft: '1px solid #ddd', borderBottom: '1px solid #ddd', position: 'relative', paddingTop: '60px' }}>
                    {/* Bar 1 */}
                    <div className="bar-group" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '40%', height: '100%', justifyContent: 'flex-end' }}>
                      <div className="stacked-bar stacked-bar-1" style={{ width: barWidthVal + "%", display: 'flex', flexDirection: 'column-reverse' }}>
                        {Segment1?.name && bar1Seg1Init > 0 && (
                          <div className="bar-segment bar1-segment" style={{ height: bar1Seg1Height + "px", backgroundColor: Segment1.bar1Color || '#1a1a1a' }}></div>
                        )}
                        {Segment2?.name && bar1Seg2Init > 0 && (
                          <div className="bar-segment bar1-segment" style={{ height: bar1Seg2Height + "px", backgroundColor: Segment2.bar1Color || '#4d4d4d' }}></div>
                        )}
                        {Segment3?.name && bar1Seg3Init > 0 && (
                          <div className="bar-segment bar1-segment" style={{ height: bar1Seg3Height + "px", backgroundColor: Segment3.bar1Color || '#808080' }}></div>
                        )}
                      </div>
                      <span className="bar-label" style={{ marginTop: '10px', fontSize: '14px', color: '#333', position: 'absolute', bottom: '-30px' }}>{Bar1?.label}</span>
                    </div>

                    {/* Bar 2 with Savings Badge */}
                    <div className="bar-group" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '40%', height: '100%', justifyContent: 'flex-end', position: 'relative' }}>
                      {/* Savings Badge - positioned above the bar */}
                      {SavingsBadge?.show === "yes" && (
                        <div className="savings-badge" style={{
                          position: 'absolute',
                          bottom: (bar2Seg1Height + bar2Seg2Height + bar2Seg3Height + 20) + 'px',
                          left: '50%',
                          transform: 'translateX(-50%)',
                          backgroundColor: SavingsBadge.backgroundColor || '#b8d935',
                          color: SavingsBadge.textColor || '#ffffff',
                          padding: '8px 16px',
                          borderRadius: '5px',
                          fontWeight: 'bold',
                          fontSize: '18px',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '5px',
                          whiteSpace: 'nowrap',
                          zIndex: 10
                        }}>
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 12L11 14L15 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                          <span className="savings-badge-text">{savingsText}</span>
                        </div>
                      )}
                      <div className="stacked-bar stacked-bar-2" style={{ width: barWidthVal + "%", display: 'flex', flexDirection: 'column-reverse' }}>
                        {Segment1?.name && bar2Seg1Init > 0 && (
                          <div className="bar-segment bar2-segment" style={{ height: bar2Seg1Height + "px", backgroundColor: Segment1.bar2Color || '#e60000' }}></div>
                        )}
                        {Segment2?.name && bar2Seg2Init > 0 && (
                          <div className="bar-segment bar2-segment" style={{ height: bar2Seg2Height + "px", backgroundColor: Segment2.bar2Color || '#ff6666' }}></div>
                        )}
                        {Segment3?.name && bar2Seg3Init > 0 && (
                          <div className="bar-segment bar2-segment" style={{ height: bar2Seg3Height + "px", backgroundColor: Segment3.bar2Color || '#ffb3b3' }}></div>
                        )}
                      </div>
                      <span className="bar-label" style={{ marginTop: '10px', fontSize: '14px', color: '#333', position: 'absolute', bottom: '-30px' }}>{Bar2?.label}</span>
                    </div>
                  </div>
                </div>

                {/* Legend - Interactive with toggle visibility */}
                {ChartSettings?.showLegend === "yes" && (
                  <div className="chart-legend" style={{ display: 'flex', justifyContent: 'center', gap: '40px', marginTop: '30px', flexWrap: 'wrap' }}>
                    {/* Bar 1 Legend */}
                    <div className="legend-group" style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                      {Segment1?.name && (
                        <div
                          className="legend-item legend-item-bar1-seg1"
                          style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', padding: '4px 8px', borderRadius: '4px', transition: 'all 0.2s ease' }}
                          onClick={(e) => {
                            const chartContainer = document.querySelector('[data-chart-uuid="' + uuid + '"]');
                            if (!chartContainer) return;
                            const segElement = chartContainer.querySelector('.stacked-bar-1 .bar1-segment:first-child');
                            const legendItem = e.currentTarget;
                            const isHidden = legendItem.classList.toggle('legend-hidden');
                            if (segElement) segElement.style.display = isHidden ? 'none' : 'block';
                            legendItem.style.opacity = isHidden ? '0.4' : '1';
                            legendItem.style.textDecoration = isHidden ? 'line-through' : 'none';
                          }}
                          onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#f0f0f0'; }}
                          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
                        >
                          <span style={{ width: '12px', height: '12px', borderRadius: '50%', backgroundColor: Segment1.bar1Color || '#1a1a1a', flexShrink: 0 }}></span>
                          <span className="legend-bar1-value" style={{ fontSize: '14px', color: '#333' }}>{Segment1.name}: {formatLegendDisplay(bar1Seg1Init, currencySymbolVal)}</span>
                        </div>
                      )}
                      {Segment2?.name && (
                        <div
                          className="legend-item legend-item-bar1-seg2"
                          style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', padding: '4px 8px', borderRadius: '4px', transition: 'all 0.2s ease' }}
                          onClick={(e) => {
                            const chartContainer = document.querySelector('[data-chart-uuid="' + uuid + '"]');
                            if (!chartContainer) return;
                            const segElement = chartContainer.querySelector('.stacked-bar-1 .bar1-segment:nth-child(2)');
                            const legendItem = e.currentTarget;
                            const isHidden = legendItem.classList.toggle('legend-hidden');
                            if (segElement) segElement.style.display = isHidden ? 'none' : 'block';
                            legendItem.style.opacity = isHidden ? '0.4' : '1';
                            legendItem.style.textDecoration = isHidden ? 'line-through' : 'none';
                          }}
                          onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#f0f0f0'; }}
                          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
                        >
                          <span style={{ width: '12px', height: '12px', borderRadius: '50%', backgroundColor: Segment2.bar1Color || '#4d4d4d', flexShrink: 0 }}></span>
                          <span className="legend-bar1-value" style={{ fontSize: '14px', color: '#333' }}>{Segment2.name}: {formatLegendDisplay(bar1Seg2Init, currencySymbolVal)}</span>
                        </div>
                      )}
                      {Segment3?.name && (
                        <div
                          className="legend-item legend-item-bar1-seg3"
                          style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', padding: '4px 8px', borderRadius: '4px', transition: 'all 0.2s ease' }}
                          onClick={(e) => {
                            const chartContainer = document.querySelector('[data-chart-uuid="' + uuid + '"]');
                            if (!chartContainer) return;
                            const segElement = chartContainer.querySelector('.stacked-bar-1 .bar1-segment:nth-child(3)');
                            const legendItem = e.currentTarget;
                            const isHidden = legendItem.classList.toggle('legend-hidden');
                            if (segElement) segElement.style.display = isHidden ? 'none' : 'block';
                            legendItem.style.opacity = isHidden ? '0.4' : '1';
                            legendItem.style.textDecoration = isHidden ? 'line-through' : 'none';
                          }}
                          onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#f0f0f0'; }}
                          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
                        >
                          <span style={{ width: '12px', height: '12px', borderRadius: '50%', backgroundColor: Segment3.bar1Color || '#808080', flexShrink: 0 }}></span>
                          <span className="legend-bar1-value" style={{ fontSize: '14px', color: '#333' }}>{Segment3.name}: {formatLegendDisplay(bar1Seg3Init, currencySymbolVal)}</span>
                        </div>
                      )}
                    </div>
                    {/* Bar 2 Legend */}
                    <div className="legend-group" style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                      {Segment1?.name && (
                        <div
                          className="legend-item legend-item-bar2-seg1"
                          style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', padding: '4px 8px', borderRadius: '4px', transition: 'all 0.2s ease' }}
                          onClick={(e) => {
                            const chartContainer = document.querySelector('[data-chart-uuid="' + uuid + '"]');
                            if (!chartContainer) return;
                            const segElement = chartContainer.querySelector('.stacked-bar-2 .bar2-segment:first-child');
                            const legendItem = e.currentTarget;
                            const isHidden = legendItem.classList.toggle('legend-hidden');
                            if (segElement) segElement.style.display = isHidden ? 'none' : 'block';
                            legendItem.style.opacity = isHidden ? '0.4' : '1';
                            legendItem.style.textDecoration = isHidden ? 'line-through' : 'none';
                          }}
                          onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#f0f0f0'; }}
                          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
                        >
                          <span style={{ width: '12px', height: '12px', borderRadius: '50%', backgroundColor: Segment1.bar2Color || '#e60000', flexShrink: 0 }}></span>
                          <span className="legend-bar2-value" style={{ fontSize: '14px', color: '#333' }}>{Segment1.name}: {formatLegendDisplay(bar2Seg1Init, currencySymbolVal)}</span>
                        </div>
                      )}
                      {Segment2?.name && (
                        <div
                          className="legend-item legend-item-bar2-seg2"
                          style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', padding: '4px 8px', borderRadius: '4px', transition: 'all 0.2s ease' }}
                          onClick={(e) => {
                            const chartContainer = document.querySelector('[data-chart-uuid="' + uuid + '"]');
                            if (!chartContainer) return;
                            const segElement = chartContainer.querySelector('.stacked-bar-2 .bar2-segment:nth-child(2)');
                            const legendItem = e.currentTarget;
                            const isHidden = legendItem.classList.toggle('legend-hidden');
                            if (segElement) segElement.style.display = isHidden ? 'none' : 'block';
                            legendItem.style.opacity = isHidden ? '0.4' : '1';
                            legendItem.style.textDecoration = isHidden ? 'line-through' : 'none';
                          }}
                          onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#f0f0f0'; }}
                          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
                        >
                          <span style={{ width: '12px', height: '12px', borderRadius: '50%', backgroundColor: Segment2.bar2Color || '#ff6666', flexShrink: 0 }}></span>
                          <span className="legend-bar2-value" style={{ fontSize: '14px', color: '#333' }}>{Segment2.name}: {formatLegendDisplay(bar2Seg2Init, currencySymbolVal)}</span>
                        </div>
                      )}
                      {Segment3?.name && (
                        <div
                          className="legend-item legend-item-bar2-seg3"
                          style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', padding: '4px 8px', borderRadius: '4px', transition: 'all 0.2s ease' }}
                          onClick={(e) => {
                            const chartContainer = document.querySelector('[data-chart-uuid="' + uuid + '"]');
                            if (!chartContainer) return;
                            const segElement = chartContainer.querySelector('.stacked-bar-2 .bar2-segment:nth-child(3)');
                            const legendItem = e.currentTarget;
                            const isHidden = legendItem.classList.toggle('legend-hidden');
                            if (segElement) segElement.style.display = isHidden ? 'none' : 'block';
                            legendItem.style.opacity = isHidden ? '0.4' : '1';
                            legendItem.style.textDecoration = isHidden ? 'line-through' : 'none';
                          }}
                          onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#f0f0f0'; }}
                          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
                        >
                          <span style={{ width: '12px', height: '12px', borderRadius: '50%', backgroundColor: Segment3.bar2Color || '#ffb3b3', flexShrink: 0 }}></span>
                          <span className="legend-bar2-value" style={{ fontSize: '14px', color: '#333' }}>{Segment3.name}: {formatLegendDisplay(bar2Seg3Init, currencySymbolVal)}</span>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          );
        },
      },

      // Button: {
      //     render: ({ Button, hide }) => {
      //         // Render nothing if hide is true
      //         if (hide) {
      //             return null;
      //         }

      //         // Calculate opacity based on hide value
      //         const inputOpacity = hide ? 0.5 : 1;

      //         return (
      //             <>
      //                 <div className="button-wrap" style={{ opacity: inputOpacity }}>
      //                     {Button.buttonicon === "yes" ?

      //                         <button className={`d-inline-flex align-items-center btn roi-btn-${Button.buttonStyle}`} type="submit"><span className='with-icon'>{Button.buttonText}</span>
      //                             <div className="icon">
      //                                 <Svg name="roi-button-icon" />
      //                             </div>
      //                         </button>
      //                         :
      //                         <button className={`btn roi-btn-${Button.buttonStyle}`} type="submit">{Button.buttonText}</button>
      //                     }

      //                 </div>
      //             </>
      //         )

      //     },
      // },

      //Report
      ReportPage: {
        render: ({ Heading, Description, Padding, hide }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-reports-section position-relative ${Padding.bottom} ${Padding.top}`}
                style={{ opacity: inputOpacity }}
              >
                <div className="container position-relative">
                  <div className="heading-currency-wrapper d-lg-flex mb-3 mb-lg-4 align-items-center">
                    <div className="curecny-dropdown mb-3 mb-lg-0 order-2">
                      <select
                        className="form-control form-select"
                        onChange={(e) => currencyChange(e)}
                      >
                        <option
                          value={defaultCurrency}
                          selected={
                            changedCurrency == "" ||
                              changedCurrency == defaultCurrency
                              ? "selected"
                              : ""
                          }
                        >
                          {defaultCurrency}
                        </option>
                        {currency.map((item, i) => (
                          <option
                            value={item}
                            selected={changedCurrency == item ? "selected" : ""}
                            key={i}
                          >
                            {item}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="section-heading flex-grow-1 order-1">
                      <h2
                        className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}
                      >
                        {Heading.title}
                      </h2>
                      <p className={Description.Font}>{Description.text}</p>
                    </div>
                  </div>
                  <div className="stats-section stats-section-custom">
                    <div className="row">
                      <div className="col-lg-8 mb-3 mb-lg-0">
                        <div className="total-wrapper-custom mb-3 mb-lg-4">
                          <DropZone zone="total-wrapper" />
                        </div>
                        <div className="chart-wrapper-custom mb-3 mb-lg-4">
                          <DropZone zone="chart-wrapper" />
                        </div>
                        <div className="custom-table-wrapper report-accordion-wrapper report-pg-table mb-3 mb-lg-4">
                          <DropZone zone="table-wrapper" />
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="download-wrapper-custom mb-3 mb-lg-4">
                          <DropZone zone="download-wrapper" />
                        </div>
                        <div className="card-wrapper-custom">
                          <DropZone zone="card-wrapper" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      CardSection: {
        render: ({ items, hide, Text }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div className="row" style={{ opacity: inputOpacity }}>
                {items.map((item, i) => (
                  <div className="col-lg-4 col-md-4 mb-3" key={i}>
                    <div className="stat-wrap">
                      <div className="stat-heading">
                        <div className="icon">
                          <img src={resolveMediaUrl(item.icon)} alt="" />
                        </div>
                        <div
                          className={`text ${Text.titleFont} ${Text.fontWeight}`}
                        >
                          {item.Title}
                        </div>
                      </div>
                      <div className="stat-content-wrapper d-flex flex-column">
                        <div className="d-flex flex-column flex-grow-1">
                          <div className="value-section value-section-1 d-flex align-items-center">
                            <div
                              className={`title ${Text.ValueTitleFont} ${Text.ValueTitleWeight}`}
                            >
                              {item.ValueTitle1}
                            </div>
                            <div
                              className={`flex-grow-1 value ${Text.ValueFont} ${Text.ValueWeight}`}
                            >
                              {CurrencyFormatter({
                                amount: parseFloat(item.Value1),
                              })}
                            </div>
                          </div>
                          <div className="value-section value-section-2 d-flex align-items-center">
                            <div
                              className={`title ${Text.ValueTitleFont} ${Text.ValueTitleWeight}`}
                            >
                              {item.ValueTitle2}
                            </div>
                            <div
                              className={`flex-grow-1 value ${Text.ValueFont} ${Text.ValueWeight}`}
                            >
                              {CurrencyFormatter({
                                amount: parseFloat(item.Value2),
                              })}
                            </div>
                          </div>
                          <div className="value-section value-section-2 d-none align-items-center">
                            <div
                              className={`title ${Text.ValueTitleFont} ${Text.ValueTitleWeight}`}
                            >
                              {item.ValueTitle3}
                            </div>
                            <div
                              className={`flex-grow-1 value ${Text.ValueFont} ${Text.ValueWeight}`}
                            >
                              {item.Value3}
                            </div>
                          </div>
                          <div className="value-section value-section-2 d-none align-items-center">
                            <div
                              className={`title ${Text.ValueTitleFont} ${Text.ValueTitleWeight}`}
                            >
                              {item.ValueTitle4}
                            </div>
                            <div
                              className={`flex-grow-1 value ${Text.ValueFont} ${Text.ValueWeight}`}
                            >
                              {item.Value4}
                            </div>
                          </div>
                        </div>
                        <div className="action">
                          <a
                            data-bs-toggle="modal"
                            data-bs-target="#reportModal"
                            onClick={() => onButtonClick(item.uuid)}
                            className="fs-16 fw-700"
                          >
                            {item.ActionText}{" "}
                            <span className="icon">
                              <svg
                                width={20}
                                height={20}
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <circle cx={10} cy={10} r={10} fill="#E60000" />
                                <path
                                  d="M8.18213 14.5453L12.7276 9.99983L8.18213 5.45438"
                                  stroke="white"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          );
        },
      },

      ResultCard: {
        render: ({ Card1, Card2, hide }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div className="total-wrapper" style={{ opacity: inputOpacity }}>
                <div className="total-inner bg-1">
                  <h5 className="fs-16 fw-700">{Card1.title}</h5>
                  <p className="fs-36 fw-300">
                    {CurrencyFormatter({ amount: parseFloat(Card1.value) })}
                  </p>
                </div>
                <div className="total-inner bg-2">
                  <h5 className="fs-16 fw-700">{Card2.title}</h5>
                  <p className="fs-36 fw-300">
                    {CurrencyFormatter({ amount: parseFloat(Card2.value) })}
                  </p>
                </div>
              </div>
            </>
          );
        },
      },

      ChartCard: {
        render: ({ Heading, hide, Chart1, Chart2, Chart3, Chart4 }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div className="stat-wrap" style={{ opacity: inputOpacity }}>
                <div className="stat-heading">
                  <div className="icon d-none">
                    <img src={resolveMediaUrl(Heading.icon)} alt="" />
                  </div>
                  <div
                    className={`text ${Heading.fontWeight} ${Heading.titleFont}`}
                  >
                    {Heading.title}
                  </div>

                  <div className="switch-btn">
                    <div className="switch-nav">
                      <input
                        id="microsoft"
                        type="radio"
                        name="company"
                        value="microsoft"
                        checked={selectedCompany === "microsoft"}
                        onChange={handleCompanyChange}
                      />
                      <label htmlFor="microsoft">Microsoft</label>

                      <input
                        id="vbuc"
                        type="radio"
                        name="company"
                        value="vbuc"
                        checked={selectedCompany === "vbuc"}
                        onChange={handleCompanyChange}
                      />
                      <label htmlFor="vbuc">VBUC</label>
                    </div>

                    <div className="switch-nav">
                      <input
                        id="year1"
                        type="radio"
                        name="year"
                        value="year1"
                        checked={selectedYear === "year1"}
                        onChange={handleYearChange}
                      />
                      <label htmlFor="year1"> First Year</label>

                      <input
                        id="year3"
                        type="radio"
                        name="year"
                        value="year3"
                        checked={selectedYear === "year3"}
                        onChange={handleYearChange}
                      />
                      <label htmlFor="year3">Three Years </label>
                    </div>
                  </div>
                </div>

                <div className="stat-content-wrapper pt-4">
                  {selectedCompany === "vbuc" && selectedYear === "year1" && (
                    <ReactEcharts
                      style={chartStyle}
                      option={pieChart(Chart1.items)}
                    />
                  )}
                  {selectedCompany === "vbuc" && selectedYear === "year3" && (
                    <ReactEcharts
                      style={chartStyle}
                      option={pieChart(Chart2.items)}
                    />
                  )}

                  {selectedCompany === "microsoft" &&
                    selectedYear === "year1" && (
                      <ReactEcharts
                        style={chartStyle}
                        option={pieChart(Chart3.items)}
                      />
                    )}

                  {selectedCompany === "microsoft" &&
                    selectedYear === "year3" && (
                      <ReactEcharts
                        style={chartStyle}
                        option={pieChart(Chart4.items)}
                      />
                    )}
                </div>
              </div>
            </>
          );
        },
      },

      DownloadCard: {
        render: ({ Heading, Padding, Button, image, hide }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          // const jumpToReport = async () => {
          //     try {
          //         let newuuid =  uuidv4();
          //         let generateUrl = `/roi/${roiId}/report/${newuuid}`
          //         window.open(generateUrl, '_blank');

          //     } catch (error) {
          //     }
          // }

          // const jumpToReport = async () => {
          //     try{
          //     let data = JSON.stringify({
          //         "roi_submitted_master_data_id": roiId,
          //         "structure": JSON.stringify(roiActionArr), // Assuming roiActionArr contains some structure data
          //         "add_date_time": new Date().toISOString().slice(0, 19).replace('T', ' ')
          //       });

          //       // Axios request configuration
          //       let config = {
          //         method: 'post',
          //         maxBodyLength: Infinity,
          //         url: `${apiUrl}/roi-submit-data/create`,
          //         headers: {
          //           'Content-Type': 'application/json'
          //         },
          //         data: data
          //       };

          //       // Perform the Axios request
          //      axios.request(config)
          //         .then((response) => {
          //           try {
          //             let newuuid = uuidv4();
          //             let generateUrl = `/roi/${roiId}/report/${newuuid}`;

          //             // Call API to download PDF
          //             let data = JSON.stringify({
          //                 "url": `${frntUrl}${generateUrl}`,
          //                 "reportname": "sample_pdf"
          //             });

          //             let config = {
          //                 method: 'post',
          //                 maxBodyLength: Infinity,
          //                 // url: 'http://localhost:3005/frnt/downloadreportpdf',
          //                 url: `${apiUrl}/roi-pages/reportPageDownload`,
          //                 headers: {
          //                     'Content-Type': 'application/json'
          //                 },
          //                 data: data,
          //                 responseType: 'blob' // This ensures that the response is treated as a file (binary data)
          //             };

          //             // Make API request to download PDF
          //             const response = axios.request(config);

          //             // Create a link element, set URL to response, and trigger download
          //             const url = window.URL.createObjectURL(new Blob([response.data]));
          //             const link = document.createElement('a');
          //             link.href = url;
          //             link.setAttribute('download', 'report.pdf');
          //             document.body.appendChild(link);
          //             link.click();
          //             document.body.removeChild(link);

          //         } catch (error) {
          //         }
          //         })
          //         .catch((error) => {
          //           console.error('Error:', error);
          //         });}
          //         catch(error){
          //             console.error('Error with create:', error);
          //         }
          // };

          return (
            <>
              <div
                className={`save-report-section h-100 d-flex align-items-end`}
                style={{
                  backgroundImage: resolveMediaCssUrl(image),
                  backgroundPosition: "center",
                  backgroundSize: "cover",
                  opacity: inputOpacity,
                  padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,
                }}
              >
                <div className="text-wrapper">
                  <h4
                    className={`${Heading?.fontWeight} ${Heading?.titleFont}`}
                    style={{
                      color: Heading?.Color,
                    }}
                  >
                    {Heading.title}
                  </h4>

                  {/* <div className="button-wrap">

                                        {Button.buttonicon === "yes" ?
                                            <button className={`d-inline-flex align-items-center btn roi-btn-${Button.buttonStyle}`} onClick={jumpToReport}><span className='with-icon'>{Button.buttonText}</span>
                                                <div className="icon">
                                                    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M12.0465 9.62L7.99979 13.6667L3.95312 9.62" stroke="#25282B" strokeWidth="1.5" strokeMiterlimit={10} strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M8 2.33334V13.5533" stroke="#25282B" strokeWidth="1.5" strokeMiterlimit={10} strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                </div>
                                            </button>
                                            :
                                            <button className={`btn roi-btn-${Button.buttonStyle}`} onClick={jumpToReport}>{Button.buttonText}</button>
                                        }
                                    </div> */}
                  <div className="button-wrap">
                    {Button.buttonicon === "yes" ? (
                      <button
                        className={`d-inline-flex align-items-center btn roi-btn-${Button.buttonStyle}`}
                        onClick={jumpToReport}
                        disabled={isLoadingdownload} // Disable button while loading
                      >
                        {isLoadingdownload ? (
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        ) : (
                          <span className="with-icon">{Button.buttonText}</span>
                        )}
                        {!isLoadingdownload && (
                          <div className="icon">
                            <svg
                              width={16}
                              height={16}
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M12.0465 9.62L7.99979 13.6667L3.95312 9.62"
                                stroke="#25282B"
                                strokeWidth="1.5"
                                strokeMiterlimit={10}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M8 2.33334V13.5533"
                                stroke="#25282B"
                                strokeWidth="1.5"
                                strokeMiterlimit={10}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </div>
                        )}
                      </button>
                    ) : (
                      <button
                        className={`btn roi-btn-${Button.buttonStyle}`}
                        onClick={jumpToReport}
                        disabled={isLoadingdownload} // Disable button while loading
                      >
                        {isLoading ? (
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        ) : (
                          Button.buttonText
                        )}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      //Report Single page

      ReportSection: {
        render: ({ Heading, Description, Padding, items, hide }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-reports-section position-relative ${Padding.bottom} ${Padding.top}`}
                style={{ opacity: inputOpacity }}
              >
                <div className="container position-relative">
                  <DropZone zone={`summary-heading`} />
                  <div className="row">
                    <div className="col-xl-3 col-lg-4">
                      <DropZone zone={`summary-details`} />
                    </div>
                    <div className="col-xl-9 col-lg-8">
                      <div className="report-accordion-wrapper">
                        <ul className="nav nav-tabs" id="myTab" role="tablist">
                          {items.map((item, i) => (
                            <li
                              className="nav-item"
                              role="presentation"
                              key={i}
                            >
                              {/** Add Class 'filled' and active class will move to next <li> button once form is filled, this will add gray backround**/}
                              <button
                                className={
                                  item.isActive === true
                                    ? "nav-link active"
                                    : "nav-link"
                                }
                                onClick={() => openPopup(item.buttonValue)}
                              >
                                {item.Title}
                              </button>
                            </li>
                          ))}
                        </ul>
                        <div className="form-wrapper">
                          {/* <div className="tab-content" id="myTabContent"> */}
                          {/* {items.map((item, i) => ( */}
                          {/* <div className={i === 0 ? 'tab-pane fade show active' : 'tab-pane fade'} id={`tab-${i}-pane`} role="tabpanel" aria-labelledby={`tab-${i}`} tabIndex={0}> */}

                          <div className="form-inner">
                            <DropZone
                              zone={`wizard-form-wrapper`}
                              disallow={["SinglePage", "WizardForm"]}
                            />
                          </div>
                          {/* </div> */}
                          {/* ))} */}
                          {/* </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      ReportTable: {
        render: ({
          Heading,
          Table,
          Headings,
          ColumnSettings,
          items,
          Calculations,
          Test,
          hide,
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div className="accordion-item" style={{ opacity: inputOpacity }}>
                {Heading?.title && (
                  <h2 className="fs-20 fw-700 accordion-button">
                    {Heading.title}
                  </h2>
                )}

                <div className="accordion-body report-accordion-wrapper">
                  <div className="table-wrapper">
                    <div className="table-responsive">
                      <table className="table">
                        {Table.FirstRow && (
                          <thead>
                            <tr>
                              <th
                                scope="col"
                                style={{
                                  width: `${ColumnSettings.FirstColSpan}'px'`,
                                }}
                                className={`${ColumnSettings.HighlightCol === "1st"
                                  ? "highlighted"
                                  : ""
                                  }`}
                              >
                                {Headings.Cell1}
                              </th>
                              <th
                                scope="col"
                                style={{
                                  width: `${ColumnSettings.SecondColSpan}px`,
                                }}
                                className={`${ColumnSettings.HighlightCol === "2nd"
                                  ? "highlighted"
                                  : ""
                                  } text-end`}
                              >
                                {Headings.Cell2}
                              </th>
                              <th
                                scope="col"
                                style={{
                                  width: `${ColumnSettings.ThirdColSpan}px`,
                                }}
                                className={`${ColumnSettings.HighlightCol === "3rd"
                                  ? "highlighted"
                                  : ""
                                  } text-end`}
                              >
                                {Headings.Cell3}
                              </th>
                              <th
                                scope="col"
                                style={{
                                  width: `${ColumnSettings.FourthColSpan}px`,
                                }}
                                className={`${ColumnSettings.HighlightCol === "4th"
                                  ? "highlighted"
                                  : ""
                                  } text-end`}
                              >
                                {Headings.Cell4}
                              </th>
                            </tr>
                          </thead>
                        )}

                        <tbody>
                          {items.map((item, i) => (
                            <tr
                              key={i}
                              className={`${Table.LastRow && `table-last-row`}`}
                            >
                              <td
                                className={`${ColumnSettings.HighlightCol === "1st"
                                  ? "highlighted"
                                  : ""
                                  }`}
                              >
                                {item.Cell1isEditable ? (
                                  <input
                                    type="text"
                                    className="form-control first-column"
                                    defaultValue={item.Cell1Data}
                                    onFocus={handleInputFocus}
                                    onBlur={(e) =>
                                      handleInputBlur(item.Cell1uuid, e)
                                    }
                                  />
                                ) : (
                                  item.Cell1Data
                                )}
                              </td>

                              <td
                                className={`${ColumnSettings.HighlightCol === "2nd"
                                  ? "highlighted"
                                  : ""
                                  } text-end`}
                              >
                                {(() => {
                                  if (
                                    item.Cell2isEditable &&
                                    item.Cell2EditStyle === "percentage"
                                  ) {
                                    return (
                                      <div className="input-group">
                                        <input
                                          type="text"
                                          className="form-control"
                                          aria-describedby="basic-addon2"
                                          defaultValue={item.Cell2Data}
                                          onFocus={handleInputFocus}
                                          onBlur={(e) =>
                                            handleInputBlur(item.Cell2uuid, e)
                                          }
                                        />
                                        <span
                                          className="input-group-text"
                                          id="basic-addon2"
                                        >
                                          %
                                        </span>
                                      </div>
                                    );
                                  } else if (
                                    !item.Cell2isEditable &&
                                    item.Cell2EditStyle === "percentage"
                                  ) {
                                    return item.Cell2Data + "%";
                                  } else if (
                                    !item.Cell2isEditable &&
                                    item.Cell2EditStyle === "currency"
                                  ) {
                                    return (
                                      <>
                                        {CurrencyFormatter({
                                          amount: parseFloat(item.Cell2Data),
                                        })}
                                      </>
                                    );
                                  } else if (
                                    item.Cell2isEditable &&
                                    item.Cell2EditStyle === "currency"
                                  ) {
                                    return (
                                      <div className="input-group">
                                        <input
                                          type="text"
                                          className="form-control"
                                          aria-describedby="basic-addon2"
                                          defaultValue={item.Cell2Data}
                                          onFocus={handleInputFocus}
                                          onBlur={(e) =>
                                            handleInputBlur(item.Cell2uuid, e)
                                          }
                                        />
                                        <span
                                          className="input-group-text"
                                          id="basic-addon2"
                                          dangerouslySetInnerHTML={{
                                            __html: currencySymbol,
                                          }}
                                        ></span>
                                      </div>
                                    );
                                  } else if (
                                    item.Cell2isEditable &&
                                    item.Cell2EditStyle === "number"
                                  ) {
                                    return (
                                      <input
                                        type="text"
                                        className="form-control"
                                        aria-describedby="basic-addon2"
                                        defaultValue={item.Cell2Data}
                                        onFocus={handleInputFocus}
                                        onBlur={(e) =>
                                          handleInputBlur(item.Cell2uuid, e)
                                        }
                                      />
                                    );
                                  } else {
                                    return item.Cell2Data;
                                  }
                                })()}
                              </td>
                              <td
                                className={`${ColumnSettings.HighlightCol === "3rd"
                                  ? "highlighted"
                                  : ""
                                  } text-end`}
                              >
                                {(() => {
                                  if (
                                    item.Cell3isEditable &&
                                    item.Cell3EditStyle === "percentage"
                                  ) {
                                    return (
                                      <div className="input-group">
                                        <input
                                          type="text"
                                          className="form-control"
                                          aria-describedby="basic-addon2"
                                          defaultValue={item.Cell3Data}
                                          onFocus={handleInputFocus}
                                          onBlur={(e) =>
                                            handleChange(item.Cell3uuid, e)
                                          }
                                        />
                                        <span
                                          className="input-group-text"
                                          id="basic-addon2"
                                        >
                                          %
                                        </span>
                                      </div>
                                    );
                                  } else if (
                                    !item.Cell3isEditable &&
                                    item.Cell3EditStyle === "percentage"
                                  ) {
                                    return item.Cell3Data + "%";
                                  } else if (
                                    !item.Cell3isEditable &&
                                    item.Cell3EditStyle === "currency"
                                  ) {
                                    return (
                                      <>
                                        {CurrencyFormatter({
                                          amount: parseFloat(item.Cell3Data),
                                        })}
                                      </>
                                    );
                                  } else if (
                                    item.Cell3isEditable &&
                                    item.Cell3EditStyle === "currency"
                                  ) {
                                    return (
                                      <div className="input-group">
                                        <input
                                          type="text"
                                          className="form-control"
                                          aria-describedby="basic-addon2"
                                          defaultValue={item.Cell3Data}
                                          onFocus={handleInputFocus}
                                          onBlur={(e) =>
                                            handleChange(item.Cell3uuid, e)
                                          }
                                        />
                                        <span
                                          className="input-group-text"
                                          id="basic-addon2"
                                          dangerouslySetInnerHTML={{
                                            __html: currencySymbol,
                                          }}
                                        ></span>
                                      </div>
                                    );
                                  } else if (
                                    item.Cell3isEditable &&
                                    item.Cell3EditStyle === "number"
                                  ) {
                                    return (
                                      <input
                                        type="text"
                                        className="form-control"
                                        aria-describedby="basic-addon2"
                                        defaultValue={item.Cell3Data}
                                        onFocus={handleInputFocus}
                                        onBlur={(e) =>
                                          handleChange(item.Cell3uuid, e)
                                        }
                                      />
                                    );
                                  } else {
                                    return item.Cell3Data;
                                  }
                                })()}
                              </td>
                              <td
                                className={`${ColumnSettings.HighlightCol === "4th"
                                  ? "highlighted"
                                  : ""
                                  } text-end`}
                              >
                                {(() => {
                                  if (
                                    item.Cell4isEditable &&
                                    item.Cell4EditStyle === "percentage"
                                  ) {
                                    return (
                                      <div className="input-group">
                                        <input
                                          type="text"
                                          className="form-control"
                                          aria-describedby="basic-addon2"
                                          defaultValue={item.Cell4Data}
                                          onFocus={handleInputFocus}
                                          onBlur={(e) =>
                                            handleChange(item.Cell4uuid, e)
                                          }
                                        />
                                        <span
                                          className="input-group-text"
                                          id="basic-addon2"
                                        >
                                          %
                                        </span>
                                      </div>
                                    );
                                  } else if (
                                    !item.Cell4isEditable &&
                                    item.Cell4EditStyle === "percentage"
                                  ) {
                                    return item.Cell4Data + "%";
                                  } else if (
                                    !item.Cell4isEditable &&
                                    item.Cell4EditStyle === "currency"
                                  ) {
                                    return (
                                      <>
                                        {CurrencyFormatter({
                                          amount: parseFloat(item.Cell4Data),
                                        })}
                                      </>
                                    );
                                  } else if (
                                    item.Cell4isEditable &&
                                    item.Cell4EditStyle === "currency"
                                  ) {
                                    return (
                                      <div className="input-group">
                                        <input
                                          type="text"
                                          className="form-control"
                                          aria-describedby="basic-addon2"
                                          defaultValue={item.Cell4Data}
                                          onFocus={handleInputFocus}
                                          onBlur={(e) =>
                                            handleChange(item.Cell4uuid, e)
                                          }
                                        />
                                        <span
                                          className="input-group-text"
                                          id="basic-addon2"
                                          dangerouslySetInnerHTML={{
                                            __html: currencySymbol,
                                          }}
                                        ></span>
                                      </div>
                                    );
                                  } else if (
                                    item.Cell4isEditable &&
                                    item.Cell4EditStyle === "number"
                                  ) {
                                    return (
                                      <input
                                        type="text"
                                        className="form-control"
                                        aria-describedby="basic-addon2"
                                        defaultValue={item.Cell4Data}
                                        onFocus={handleInputFocus}
                                        onBlur={(e) =>
                                          handleChange(item.Cell4uuid, e)
                                        }
                                      />
                                    );
                                  } else {
                                    return item.Cell4Data;
                                  }
                                })()}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                        {/* {Table.LastRow && <tfoot>
                                                    <tr>
                                                        <td className='total fs-16 fw-700' style={{ backgroundColor: '#333333', color: '#ffffff' }}>{Calculations.Cell1}</td>
                                                        <td style={{ backgroundColor: '#333333', color: '#ffffff' }}></td>
                                                        <td style={{ backgroundColor: '#333333', color: '#ffffff' }}></td>
                                                        <td className='fs-20 text-end fw-700' style={{ backgroundColor: '#333333', color: '#ffffff' }}>£{Calculations.Cell2}</td>
                                                    </tr>
                                                </tfoot>} */}
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      // Download Report
      DownloadReportBanner: {
        render: ({
          Heading,
          Description,
          Padding,
          logo,
          image,
          backgroundImage,
          hide,
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className="portrait-report-wrapper"
                style={{ opacity: inputOpacity }}
              >
                <div
                  className={`style3 dwn-report-section roi-banner-section position-relative ${Padding.bottom
                    } ${Padding.top} ${Padding.fullHeight && "full-height"}`}
                  style={{
                    backgroundImage: resolveMediaCssUrl(backgroundImage),
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                  }}
                >
                  <div className="container position-relative">
                    <div className="logo-wrap">
                      <Link to="">
                        <img src={resolveMediaUrl(logo)} alt="" />
                      </Link>
                    </div>
                    <div className="row align-items-center ">
                      <div className="col-lg-12">
                        <div className="banner-text">
                          <h1
                            className={`heading ${Heading.fontWeight} ${Heading.titleFont} mb-3`}
                          >
                            {Heading.title}
                          </h1>

                          <div className="text-part">
                            <div
                              className={Description.descriptionFont}
                              dangerouslySetInnerHTML={{
                                __html: Description.text,
                              }}
                            ></div>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-12">
                        <div className="img-wrapper">
                          <img src={resolveMediaUrl(image)} className="img-fluid" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },
      DownloadReportPage: {
        render: ({ Heading, Description, Padding, logo, hide }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className="portrait-report-wrapper"
                style={{ opacity: inputOpacity }}
              >
                <div
                  className={`dwn-report-section roi-reports-section position-relative ${Padding.bottom} ${Padding.top}`}
                >
                  <div className="container position-relative">
                    <div className="logo-wrap">
                      <Link to="">
                        <img src={resolveMediaUrl(logo)} alt="" />
                      </Link>
                    </div>
                    <div className="section-heading mb-3 mb-md-4">
                      <h2
                        className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}
                      >
                        {Heading.title}
                      </h2>
                      <p className={Description.Font}>{Description.text}</p>
                    </div>

                    <div className="stats-section">
                      <div className="row">
                        <div className="col-lg-12 mb-2">
                          <DropZone zone="card-wrapper" />
                        </div>

                        <div className="col-lg-12 mb-2">
                          <DropZone zone="total-wrapper" />
                        </div>

                        <div className="col-lg-12">
                          <DropZone zone="chart-wrapper" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      DownloadCardSection: {
        render: ({ items, hide, Text }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div className="row gx-2" style={{ opacity: inputOpacity }}>
                {items.map((item, i) => (
                  <div className="col-lg-4 col-md-4 mb-2" key={i}>
                    <div className="stat-wrap">
                      <div className="stat-heading">
                        <div className="icon">
                          <img src={resolveMediaUrl(item.icon)} alt="" />
                        </div>
                        <div
                          className={`text ${Text.titleFont} ${Text.fontWeight}`}
                        >
                          {item.Title}
                        </div>
                      </div>
                      <div className="stat-content-wrapper d-flex flex-column">
                        <div className="d-flex flex-column flex-grow-1">
                          <div className="value-section value-section-1 d-flex align-items-center">
                            <div
                              className={`title ${Text.ValueTitleFont} ${Text.ValueTitleWeight}`}
                            >
                              {item.ValueTitle1}
                            </div>
                            <div
                              className={`flex-grow-1 value ${Text.ValueFont} ${Text.ValueWeight}`}
                            >
                              {item.Value1}
                            </div>
                          </div>
                          <div className="value-section value-section-2 d-flex align-items-center">
                            <div
                              className={`title ${Text.ValueTitleFont} ${Text.ValueTitleWeight}`}
                            >
                              {item.ValueTitle2}
                            </div>
                            <div
                              className={`flex-grow-1 value ${Text.ValueFont} ${Text.ValueWeight}`}
                            >
                              {item.Value2}
                            </div>
                          </div>
                        </div>
                        <div className="action">
                          <a href="" className="fs-16 fw-700">
                            {item.ActionText}{" "}
                            <span className="icon">
                              <svg
                                width={20}
                                height={20}
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <circle cx={10} cy={10} r={10} fill="#E60000" />
                                <path
                                  d="M8.18213 14.5453L12.7276 9.99983L8.18213 5.45438"
                                  stroke="white"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          );
        },
      },

      DownloadResultCard: {
        render: ({ Card1, Card2, hide }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className="total-wrapper row gx-0 flex-row"
                style={{ opacity: inputOpacity }}
              >
                <div className="total-inner bg-1 col-6">
                  <h5 className="fs-16 fw-700 text-center">{Card1.title}</h5>
                  <p className="fs-48 fw-300 text-center">
                    {formatRoiCurrencyDescription(Card1.description)}
                  </p>
                </div>
                <div className="total-inner bg-2 col-6">
                  <h5 className="fs-16 fw-700 text-center">{Card2.title}</h5>
                  <p className="fs-48 fw-300 text-center">
                    {formatRoiCurrencyDescription(Card2.description)}
                  </p>
                </div>
              </div>
            </>
          );
        },
      },

      DownloadChartCard: {
        render: ({ Chart1, Chart2, Heading, hide }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div className="stat-wrap" style={{ opacity: inputOpacity }}>
                <div className="stat-heading">
                  <div className="icon">
                    <img src={resolveMediaUrl(Heading.icon)} alt="" />
                  </div>
                  <div
                    className={`text ${Heading.fontWeight} ${Heading.titleFont}`}
                  >
                    {Heading.title}
                  </div>
                </div>

                <div className="stat-content-wrapper">
                  <div className="tab-content" id="myTabContent">
                    <div className="row">
                      <div className="col-sm-6">
                        {Chart1.chooseChart === "pie" ? (
                          <ReactEcharts
                            style={chartStyle}
                            option={OneYearChartOptions}
                          />
                        ) : (
                          <ReactEcharts
                            style={chartStyle}
                            option={ThreeYearChartOptions}
                          />
                        )}
                      </div>
                      <div className="col-sm-6">
                        {Chart2.chooseChart === "bar" ? (
                          <ReactEcharts
                            style={chartStyle}
                            option={ThreeYearChartOptions}
                          />
                        ) : (
                          <ReactEcharts
                            style={chartStyle}
                            option={OneYearChartOptions}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      DownloadReportSection: {
        render: ({ Heading, Description, Padding, items, logo, hide }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className="portrait-report-wrapper"
                style={{ opacity: inputOpacity }}
              >
                <div
                  className={`dwn-report-section roi-reports-section position-relative ${Padding.bottom} ${Padding.top}`}
                >
                  <div className="container position-relative">
                    <div className="logo-wrap">
                      <Link to="">
                        <img src={resolveMediaUrl(logo)} alt="" />
                      </Link>
                    </div>
                    <div className="section-heading mb-3 mb-md-4">
                      <h2
                        className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}
                      >
                        {Heading.title}
                      </h2>
                      <p className={Description.Font}>{Description.text}</p>
                    </div>
                    <div className="report-accordion-wrapper">
                      <div className="form-wrapper">
                        <div className="tab-content" id="myTabContent">
                          {items.map((item, i) => (
                            <div
                              key={i}
                              className={
                                i === 0
                                  ? "tab-pane fade show active"
                                  : "tab-pane fade"
                              }
                              id={`tab-${i}-pane`}
                              role="tabpanel"
                              aria-labelledby={`tab-${i}`}
                              tabIndex={0}
                            >
                              <div className="form-inner">
                                <DropZone
                                  zone={`wizard-form-wrapper-${i}`}
                                  disallow={["SinglePage", "WizardForm"]}
                                />
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      DownloadReportTable: {
        render: ({
          Heading,
          Table,
          Headings,
          ColumnSettings,
          items,
          Calculations,
          Test,
          hide,
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div className="accordion-item" style={{ opacity: inputOpacity }}>
                <h2 className="fs-14 fw-700 accordion-button">
                  {Heading.title}
                </h2>
                <div className="accordion-body">
                  <div className="table-wrapper">
                    <div className="table-responsive">
                      <table className="table">
                        {Table.FirstRow && (
                          <thead>
                            <tr>
                              <th
                                scope="col"
                                style={{
                                  width: `${ColumnSettings.FirstColSpan}'px'`,
                                }}
                                className={`${ColumnSettings.HighlightCol === "1st"
                                  ? "highlighted"
                                  : ""
                                  }`}
                              >
                                {Headings.Cell1}
                              </th>
                              <th
                                scope="col"
                                style={{
                                  width: `${ColumnSettings.SecondColSpan}px`,
                                }}
                                className={`${ColumnSettings.HighlightCol === "2nd"
                                  ? "highlighted"
                                  : ""
                                  } text-end`}
                              >
                                {Headings.Cell2}
                              </th>
                              <th
                                scope="col"
                                style={{
                                  width: `${ColumnSettings.ThirdColSpan}px`,
                                }}
                                className={`${ColumnSettings.HighlightCol === "3rd"
                                  ? "highlighted"
                                  : ""
                                  } text-end`}
                              >
                                {Headings.Cell3}
                              </th>
                              <th
                                scope="col"
                                style={{
                                  width: `${ColumnSettings.FourthColSpan}px`,
                                }}
                                className={`${ColumnSettings.HighlightCol === "4th"
                                  ? "highlighted"
                                  : ""
                                  } text-end`}
                              >
                                {Headings.Cell4}
                              </th>
                            </tr>
                          </thead>
                        )}

                        <tbody>
                          {items.map((item, i) => {
                            return (
                              <tr key={i}>
                                <td
                                  className={`${ColumnSettings.HighlightCol === "1st"
                                    ? "highlighted"
                                    : ""
                                    }`}
                                >
                                  {item.Cell1isEditable ? (
                                    <input
                                      type="text"
                                      className="form-control first-column"
                                      defaultValue={item.Cell1Data}
                                      onFocus={handleInputFocus}
                                      onBlur={(e) =>
                                        handleChange(item.Cell1uuid, e)
                                      }
                                    />
                                  ) : (
                                    item.Cell1Data
                                  )}
                                </td>

                                <td
                                  className={`${ColumnSettings.HighlightCol === "2nd"
                                    ? "highlighted"
                                    : ""
                                    } text-end`}
                                >
                                  {(() => {
                                    if (
                                      item.Cell2isEditable &&
                                      item.Cell2EditStyle === "percentage"
                                    ) {
                                      return (
                                        <div className="input-group">
                                          <input
                                            type="text"
                                            className="form-control"
                                            aria-describedby="basic-addon2"
                                            defaultValue={item.Cell2Data}
                                            onFocus={handleInputFocus}
                                            onBlur={(e) =>
                                              handleChange(item.Cell2uuid, e)
                                            }
                                          />
                                          <span
                                            className="input-group-text"
                                            id="basic-addon2"
                                          >
                                            %
                                          </span>
                                        </div>
                                      );
                                    } else if (
                                      !item.Cell2isEditable &&
                                      item.Cell2EditStyle === "percentage"
                                    ) {
                                      return item.Cell2Data + "%";
                                    } else if (
                                      !item.Cell2isEditable &&
                                      item.Cell2EditStyle === "currency"
                                    ) {
                                      return (
                                        <>
                                          {CurrencyFormatter({
                                            amount: parseFloat(item.Cell2Data),
                                          })}
                                        </>
                                      );
                                    } else if (
                                      item.Cell2isEditable &&
                                      item.Cell2EditStyle === "currency"
                                    ) {
                                      return (
                                        <div className="input-group">
                                          <input
                                            type="text"
                                            className="form-control"
                                            aria-describedby="basic-addon2"
                                            defaultValue={item.Cell2Data}
                                            onFocus={handleInputFocus}
                                            onBlur={(e) =>
                                              handleChange(item.Cell2uuid, e)
                                            }
                                          />
                                          <span
                                            className="input-group-text"
                                            id="basic-addon2"
                                            dangerouslySetInnerHTML={{
                                              __html: currencySymbol,
                                            }}
                                          ></span>
                                        </div>
                                      );
                                    } else if (
                                      item.Cell2isEditable &&
                                      item.Cell2EditStyle === "number"
                                    ) {
                                      return (
                                        <input
                                          type="text"
                                          className="form-control"
                                          aria-describedby="basic-addon2"
                                          defaultValue={item.Cell2Data}
                                          onFocus={handleInputFocus}
                                          onBlur={(e) =>
                                            handleChange(item.Cell2uuid, e)
                                          }
                                        />
                                      );
                                    } else {
                                      return item.Cell2Data;
                                    }
                                  })()}
                                </td>
                                <td
                                  className={`${ColumnSettings.HighlightCol === "3rd"
                                    ? "highlighted"
                                    : ""
                                    } text-end`}
                                >
                                  {(() => {
                                    if (
                                      item.Cell3isEditable &&
                                      item.Cell3EditStyle === "percentage"
                                    ) {
                                      return (
                                        <div className="input-group">
                                          <input
                                            type="text"
                                            className="form-control"
                                            aria-describedby="basic-addon2"
                                            defaultValue={item.Cell3Data}
                                            onFocus={handleInputFocus}
                                            onBlur={(e) =>
                                              handleChange(item.Cell3uuid, e)
                                            }
                                          />
                                          <span
                                            className="input-group-text"
                                            id="basic-addon2"
                                          >
                                            %
                                          </span>
                                        </div>
                                      );
                                    } else if (
                                      !item.Cell3isEditable &&
                                      item.Cell3EditStyle === "percentage"
                                    ) {
                                      return item.Cell3Data + "%";
                                    } else if (
                                      !item.Cell3isEditable &&
                                      item.Cell3EditStyle === "currency"
                                    ) {
                                      return (
                                        <>
                                          {CurrencyFormatter({
                                            amount: parseFloat(item.Cell3Data),
                                          })}
                                        </>
                                      );
                                    } else if (
                                      item.Cell3isEditable &&
                                      item.Cell3EditStyle === "currency"
                                    ) {
                                      return (
                                        <div className="input-group">
                                          <input
                                            type="text"
                                            className="form-control"
                                            aria-describedby="basic-addon2"
                                            defaultValue={item.Cell3Data}
                                            onBlur={(e) =>
                                              handleChange(item.Cell3uuid, e)
                                            }
                                          />
                                          <span
                                            className="input-group-text"
                                            id="basic-addon2"
                                            dangerouslySetInnerHTML={{
                                              __html: currencySymbol,
                                            }}
                                          ></span>
                                        </div>
                                      );
                                    } else if (
                                      item.Cell3isEditable &&
                                      item.Cell3EditStyle === "number"
                                    ) {
                                      return (
                                        <input
                                          type="text"
                                          className="form-control"
                                          aria-describedby="basic-addon2"
                                          defaultValue={item.Cell3Data}
                                          onBlur={(e) =>
                                            handleChange(item.Cell3uuid, e)
                                          }
                                        />
                                      );
                                    } else {
                                      return item.Cell3Data;
                                    }
                                  })()}
                                </td>
                                <td
                                  className={`${ColumnSettings.HighlightCol === "4th"
                                    ? "highlighted"
                                    : ""
                                    } text-end`}
                                >
                                  {(() => {
                                    if (
                                      item.Cell4isEditable &&
                                      item.Cell4EditStyle === "percentage"
                                    ) {
                                      return (
                                        <div className="input-group">
                                          <input
                                            type="text"
                                            className="form-control"
                                            aria-describedby="basic-addon2"
                                            defaultValue={item.Cell4Data}
                                            onBlur={(e) =>
                                              handleChange(item.Cell4uuid, e)
                                            }
                                          />
                                          <span
                                            className="input-group-text"
                                            id="basic-addon2"
                                          >
                                            %
                                          </span>
                                        </div>
                                      );
                                    } else if (
                                      !item.Cell4isEditable &&
                                      item.Cell4EditStyle === "percentage"
                                    ) {
                                      return item.Cell4Data + "%";
                                    } else if (
                                      !item.Cell4isEditable &&
                                      item.Cell4EditStyle === "currency"
                                    ) {
                                      return (
                                        <>
                                          {CurrencyFormatter({
                                            amount: parseFloat(item.Cell4Data),
                                          })}
                                        </>
                                      );
                                    } else if (
                                      item.Cell4isEditable &&
                                      item.Cell4EditStyle === "currency"
                                    ) {
                                      return (
                                        <div className="input-group">
                                          <input
                                            type="text"
                                            className="form-control"
                                            aria-describedby="basic-addon2"
                                            defaultValue={item.Cell4Data}
                                            onBlur={(e) =>
                                              handleChange(item.Cell4uuid, e)
                                            }
                                          />
                                          <span
                                            className="input-group-text"
                                            id="basic-addon2"
                                            dangerouslySetInnerHTML={{
                                              __html: currencySymbol,
                                            }}
                                          ></span>
                                        </div>
                                      );
                                    } else if (
                                      item.Cell4isEditable &&
                                      item.Cell4EditStyle === "number"
                                    ) {
                                      return (
                                        <input
                                          type="text"
                                          className="form-control"
                                          aria-describedby="basic-addon2"
                                          defaultValue={item.Cell4Data}
                                          onBlur={(e) =>
                                            handleChange(item.Cell4uuid, e)
                                          }
                                        />
                                      );
                                    } else {
                                      return item.Cell4Data;
                                    }
                                  })()}
                                </td>
                              </tr>
                            );
                            // }
                          })}
                        </tbody>
                        {/* {Table.LastRow && <tfoot>
                                                    <tr>
                                                        <td className='total fs-16 fw-700' style={{ backgroundColor: '#333333', color: '#ffffff' }}>{items[items.length-1].Cell1}</td>
                                                        <td className='fs-20 text-end fw-700' style={{ backgroundColor: '#333333', color: '#ffffff' }}>£{items[items.length-1].Cell2}</td>
                                                        <td className='fs-20 text-end fw-700' style={{ backgroundColor: '#333333', color: '#ffffff' }}>£{items[items.length-1].Cell2}</td>
                                                        <td className='fs-20 text-end fw-700' style={{ backgroundColor: '#333333', color: '#ffffff' }}>£{items[items.length-1].Cell2}</td>
                                                    </tr>
                                                </tfoot>} */}
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      DownloadReportCardsSection: {
        render: ({
          Heading,
          Description,
          Padding,
          logo,
          Lists,
          Settings,
          hide,
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className="portrait-report-wrapper"
                style={{ opacity: inputOpacity }}
              >
                <div
                  className={`dwn-report-section roi-reports-section position-relative ${Padding.bottom} ${Padding.top}`}
                >
                  <div className="container position-relative">
                    <div className="logo-wrap">
                      <Link to="">
                        <img src={resolveMediaUrl(logo)} alt="" />
                      </Link>
                    </div>
                    <div className="section-heading mb-3 mb-md-4">
                      <h2
                        className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}
                      >
                        {Heading.title}
                      </h2>
                      <p className={Description.Font}>{Description.text}</p>
                    </div>
                    <div className="report-posts-wrapper">
                      <div
                        className="list-box-1 d-grid gap-4"
                        style={{
                          gridTemplateColumns: `repeat(${Settings.ItemsPerRow}, 1fr)`,
                        }}
                      >
                        {Lists.map((list, i) => (
                          <div
                            className={`list-box-inner ${Settings.IconPosition === "left" ? "d-flex" : ""
                              }`}
                            key={i}
                          >
                            {Settings.ShowIcon ? (
                              <div className="icon-wrap">
                                <img src={resolveMediaUrl(list.Image)} alt="" />
                              </div>
                            ) : (
                              ""
                            )}

                            <div className={`text-wrap flex-grow-1`}>
                              <h4
                                className={`${Settings.TitleFont} ${Settings.TitleFontWeight} mb-3`}
                                style={{ color: Settings.TitleColor }}
                              >
                                {list.Title}
                              </h4>
                              <p
                                className={`${Settings.DescriptionFont} ${Settings.DescriptionFontWeight} mb-0`}
                              >
                                {list.Description}
                              </p>
                              {Settings.ShowButton ? (
                                <div className="button-wrap pt-3">
                                  <a
                                    className="link d-inline-flex text-primary fw-700 fs-14 align-items-center"
                                    href={list.ButtonLink}
                                  >
                                    <span>{list.ButtonText}</span>{" "}
                                    <Svg name="button-arrow" />
                                  </a>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      DownloadReportThankYou: {
        render: ({ logo, Description, hide }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className="portrait-report-wrapper"
                style={{ opacity: inputOpacity }}
              >
                <div className="report-build-wrapper report-thankyou">
                  <div className="logo-wrap">
                    <img src={resolveMediaUrl(logo)} alt="" />
                  </div>
                  <div className="desclaimer">
                    <p className={Description.Font}>{Description.text}</p>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      // Landing Page components

      TransparentSection: {
        render: ({ Padding, Style }) => {
          return (
            <>
              <div
                className={`landing-page-cpmponent ${Style.CustomClass} component-section ${Padding.bottom
                  } ${Padding.top} ${Padding.fullHeight && "full-height"}`}
                style={{
                  backgroundImage: resolveMediaCssUrl(Style.Background),
                  backgroundColor: `${Style.BackgroundColor}`,
                  backgroundPosition: "center",
                  backgroundSize: "cover",
                }}
              >
                {/* <div className='overlay'></div> */}
                <div className={`${Style.Width} position-relative`}>
                  <DropZone zone="section" />
                </div>
              </div>
            </>
          );
        },
      },

      GradientSection: {
        render: ({ Padding, Style }) => {
          return (
            <>
              <div
                className={`component-section gradient-bg ${Padding.bottom} ${Padding.top
                  } ${Padding.fullHeight && "full-height"}`}
              >
                {/* <div className='overlay'></div> */}
                <div className={`${Style.Width} position-relative`}>
                  <DropZone zone="section" />
                </div>
              </div>
            </>
          );
        },
      },

      Columns: {
        render: ({
          columns,
          distribution,
          vertical,
          gap,
          Padding,
          Style,
          Border,
        }) => {
          return (
            <div
              className={`d-grid section-column ${vertical}`}
              style={{
                backgroundImage: resolveMediaCssUrl(Style?.Background),
                backgroundColor: `${Style?.BackgroundColor}`,
                backgroundPosition: "center",
                backgroundSize: "cover",
                padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,

                borderStyle: Border?.BorderStyle,
                borderColor: Border?.BorderColor,
                borderWidth: `${Border?.BorderWidth?.top}px ${Border?.BorderWidth?.right}px ${Border?.BorderWidth?.bottom}px ${Border?.BorderWidth?.left}px`,
                borderRadius: `${Border?.BorderRadius}px`,

                gridTemplateColumns:
                  distribution === "manual"
                    ? "repeat(12, 1fr)"
                    : `repeat(${columns.length}, 1fr)`,
                gridColumnGap: `${gap}px`,
              }}
            >
              {columns.map(({ span, backgroundColor }, idx) => (
                <div
                  key={idx}
                  className="w-100"
                  style={{
                    display: "flex",
                    backgroundColor: backgroundColor,
                    flexDirection: "column",
                    gridColumn:
                      span && distribution === "manual"
                        ? `span ${Math.max(Math.min(span, 12), 1)}`
                        : "",
                  }}
                >
                  <DropZone
                    zone={`column-${idx}`}
                  // disallow={["Section"]}
                  />
                </div>
              ))}
            </div>
          );
        },
      },

      Wrapper: {
        render: ({ Padding, Style, Border, customClass, hide, uuid }) => {
          if (hide == true || hide == 'true') {
            return null;
          }
          return (
            <>
              <div
                className={`component-wrapper ${customClass}`}
                style={{
                  backgroundImage: resolveMediaCssUrl(Style.Background),
                  backgroundColor: `${Style.BackgroundColor}`,
                  backgroundPosition: "center",
                  backgroundSize: "cover",
                  padding: `${Padding.top}px ${Padding.right}px ${Padding.bottom}px ${Padding.left}px`,

                  borderStyle: Border.BorderStyle,
                  borderColor: Border.BorderColor,
                  borderWidth: `${Border?.BorderWidth?.top}px ${Border?.BorderWidth?.right}px ${Border?.BorderWidth?.bottom}px ${Border?.BorderWidth?.left}px`,
                  borderRadius: `${Border.BorderRadius}px`,
                }}
              >
                {/* <div className='overlay'></div> */}
                <div className={`position-relative`}>
                  <DropZone zone="wrapper" />
                </div>
              </div>
            </>
          );
        },
      },

      Spacing: {
        render: ({ Height }) => {
          return <div style={{ height: `${Height}` }}></div>;
        },
      },

      Heading: {
        render: ({ Text, Padding }) => {
          return (
            <>
              {(() => {
                if (Text.tag === "h1") {
                  return (
                    <h1
                      className={`section-title m-0 size-h1 ${Text.fontWeight} ${Text.titleFont}`}
                      style={{
                        color: `${Text.Color}`,
                        textAlign: Text.Align,
                        padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,
                      }}
                    >
                      <div
                        dangerouslySetInnerHTML={{ __html: Text.title }}
                      ></div>
                    </h1>
                  );
                } else if (Text.tag === "h2") {
                  return (
                    <h2
                      className={`section-title m-0 size-h2 ${Text.fontWeight} ${Text.titleFont}`}
                      style={{
                        color: `${Text.Color}`,
                        textAlign: Text.Align,
                        padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,
                      }}
                    >
                      <div
                        dangerouslySetInnerHTML={{ __html: Text.title }}
                      ></div>
                    </h2>
                  );
                } else if (Text.tag === "h3") {
                  return (
                    <h3
                      className={`section-title m-0 size-h3 ${Text.fontWeight} ${Text.titleFont}`}
                      style={{
                        color: `${Text.Color}`,
                        textAlign: Text.Align,
                        padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,
                      }}
                    >
                      <div
                        dangerouslySetInnerHTML={{ __html: Text.title }}
                      ></div>
                    </h3>
                  );
                } else if (Text.tag === "h4") {
                  return (
                    <h4
                      className={`section-title m-0 size-h4 ${Text.fontWeight} ${Text.titleFont}`}
                      style={{
                        color: `${Text.Color}`,
                        textAlign: Text.Align,
                        padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,
                      }}
                    >
                      <div
                        dangerouslySetInnerHTML={{ __html: Text.title }}
                      ></div>
                    </h4>
                  );
                } else if (Text.tag === "h5") {
                  return (
                    <h5
                      className={`section-title m-0 size-h5 ${Text.fontWeight} ${Text.titleFont}`}
                      style={{
                        color: `${Text.Color}`,
                        textAlign: Text.Align,
                        padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,
                      }}
                    >
                      <div
                        dangerouslySetInnerHTML={{ __html: Text.title }}
                      ></div>
                    </h5>
                  );
                } else if (Text.tag === "h6") {
                  return (
                    <h6
                      className={`section-title m-0 size-h6 ${Text.fontWeight} ${Text.titleFont}`}
                      style={{
                        color: `${Text.Color}`,
                        textAlign: Text.Align,
                        padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,
                      }}
                    >
                      <div
                        dangerouslySetInnerHTML={{ __html: Text.title }}
                      ></div>
                    </h6>
                  );
                }
              })()}
            </>
          );
        },
      },

      Text: {
        render: ({ Text }) => {
          // Parse the text for dynamic spans
          const parsedContent = parseDynamicText(Text.text);

          return (
            <>
              <div
                style={{
                  color: `${Text.Color}`,
                  textAlign: Text.Align,
                }}
                className={`section-text m-0 ${Text.FontWeight} ${Text.FontSize}`}
              >
                {parsedContent}
              </div>
            </>
          );
        },
      },

      Image: {
        render: ({ Image, AspectRatio, fullWidth }) => {
          return (
            <>
              <div className="image-wrapper">
                <img
                  src={resolveMediaUrl(Image)}
                  alt=""
                  className={`img-fluid object-cover ${fullWidth && `w-100`} `}
                  style={{ aspectRatio: `${AspectRatio}` }}
                />
              </div>
            </>
          );
        },
      },

      RedCards: {
        render: ({ Lists, Settings }) => {
          return (
            <>
              <div className="roi-cards-section card-layout-1">
                <div className="cards-wrapper">
                  <div className="row justify-content-center">
                    {Lists.map((list, i) => (
                      <div className="col-lg-4 col-md-6 mb-3" key={i}>
                        <input
                          className="form-check-input d-none"
                          type="radio"
                          name={Settings.Card.UniqueID}
                          id={`${Settings.Card.UniqueID}-${i}`}
                        />
                        <label
                          className="card-outer"
                          htmlFor={`${Settings.Card.UniqueID}-${i}`}
                          style={{
                            borderStyle: Settings.Border.BorderStyle,
                            borderColor: Settings.Border.BorderColor,
                            borderWidth: `${Settings.Border.BorderWidth}px`,
                            borderRadius: `${Settings.Border.BorderRadius}px`,
                            backgroundColor: Settings.Card.BackgroundColor,
                            paddingTop: `${Settings.Card.Padding.top}px`,
                            paddingRight: `${Settings.Card.Padding.right}px`,
                            paddingBottom: `${Settings.Card.Padding.bottom}px`,
                            paddingLeft: `${Settings.Card.Padding.left}px`,
                            textAlign: Settings.Text.Align,
                          }}
                        >
                          <div className="card-inner">
                            <div className="text-wrapper">
                              <h4
                                className={`${Settings.Text.TitleFont} ${Settings.Text.TitleFontWeight}`}
                                style={{ color: Settings.Text.TitleColor }}
                              >
                                {list.Title}
                              </h4>
                              <p
                                className={`${Settings.Text.DescriptionFont} ${Settings.Text.DescriptionFontWeight} mb-0`}
                                style={{
                                  color: Settings.Text.DescriptionColor,
                                }}
                              >
                                {list.Description}
                              </p>
                            </div>
                            <div className="button-wrapper">
                              <button className="btn btn-action">
                                <Svg name="roi-card-button" />
                              </button>
                            </div>
                          </div>
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      WhiteCards: {
        render: ({ Lists, Settings }) => {
          return (
            <>
              <div className="roi-cards-section card-layout-2">
                <div className="cards-wrapper">
                  <div className="row justify-content-center">
                    {Lists.map((list, i) => (
                      <div className="col-lg-4 col-md-6 mb-3" key={i}>
                        <input
                          className="form-check-input d-none"
                          type="radio"
                          name={Settings.Card.UniqueID}
                          id={`${Settings.Card.UniqueID}-${i}`}
                        />
                        <label
                          className="card-outer"
                          htmlFor={`${Settings.Card.UniqueID}-${i}`}
                          style={{
                            borderStyle: Settings.Border.BorderStyle,
                            borderColor: Settings.Border.BorderColor,
                            borderWidth: `${Settings.Border.BorderWidth}px`,
                            borderRadius: `${Settings.Border.BorderRadius}px`,
                            backgroundColor: Settings.Card.BackgroundColor,
                            paddingTop: `${Settings.Card.Padding.top}px`,
                            paddingRight: `${Settings.Card.Padding.right}px`,
                            paddingBottom: `${Settings.Card.Padding.bottom}px`,
                            paddingLeft: `${Settings.Card.Padding.left}px`,
                            textAlign: Settings.Text.Align,
                          }}
                        >
                          <div className="card-inner">
                            {list.Image ? (
                              <div class="icon-wrapper">
                                <img
                                  src={resolveMediaUrl(list.Image)}
                                  alt=""
                                  height={Settings.Card.IconSize}
                                  width={Settings.Card.IconSize}
                                />
                              </div>
                            ) : (
                              ""
                            )}
                            <div className="text-wrapper">
                              <h4
                                className={`${Settings.Text.TitleFont} ${Settings.Text.TitleFontWeight}`}
                                style={{ color: Settings.Text.TitleColor }}
                              >
                                {list.Title}
                              </h4>
                              <p
                                className={`${Settings.Text.DescriptionFont} ${Settings.Text.DescriptionFontWeight} mb-0`}
                                style={{
                                  color: Settings.Text.DescriptionColor,
                                }}
                              >
                                {list.Description}
                              </p>
                            </div>
                            <div className="button-wrapper">
                              <button className="btn btn-action">
                                <Svg name="roi-card-button" />
                              </button>
                            </div>
                          </div>
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      PieChart: {
        render: ({ chartOption }) => (
          <>
            <div className="echart-wrapper">
              <ReactEcharts
                style={{
                  height: "200px",
                  width: "100%",
                }}
                option={chartOption}
              />
            </div>
          </>
        ),
      },

      eCharts: {
        render: ({ Chart, hide }) => {
          const inputOpacity = hide ? 0.5 : 1;

          // Special styling for roiId c51d1af0-0099-11ef-8e49-4bdeaebfbca1
          const isSpecialRoi = roiId === 'c51d1af0-0099-11ef-8e49-4bdeaebfbca1';

          const PieChartStyle = {
            height: isSpecialRoi ? "280px" : "330px",
            width: "100%",
          };

          const BarChartStyle = {
            height: "206px",
            width: "100%",
          };

          return (
            <>
              <div className="echart-wrap" style={{ opacity: inputOpacity }}>
                {(() => {
                  if (Chart.chooseChart === "pie") {
                    return (
                      <ReactEcharts
                        style={PieChartStyle}
                        option={pieEChart(Chart.items, Chart.title, Chart.value)}
                      />
                    );
                  } else if (Chart.chooseChart === "bar") {
                    return (
                      <ReactEcharts
                        style={BarChartStyle}
                        option={barEChart(Chart.items, Chart.title, Chart.value)}
                      />
                    );
                  }
                  return null;
                })()}
              </div>
            </>
          );
        },
      },

      ToggleSwitch: {
        render: ({ items, ID, hide, Margin, Style }) => {
          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-form-group ${Style?.customMargin ? "" : "mb-3"
                  } position-relative d-flex align-items-center ${Style?.Alignment
                  }`}
                style={{
                  opacity: inputOpacity,
                  margin: `${Margin?.top}px ${Margin?.right}px ${Margin?.bottom}px ${Margin?.left}px`,
                }}
              >
                <div
                  className={`roi-toggle-switch d-flex align-items-center`}
                  style={{
                    borderStyle: "solid",
                    borderColor: "#B6B7B8",
                    borderWidth: `1px 1px 1px 1px`,
                    borderRadius: `4px`,
                  }}
                >
                  {items.map((item, i) => (
                    <div className="form-check" key={i}>
                      <input
                        className="form-check-input"
                        name={ID}
                        type="radio"
                        defaultValue
                        id={`${ID}-${i}`}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`${ID}-${i}`}
                      >
                        {item.Option}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            </>
          );
        },
      },

      Collapsible: {
        render: ({ ID }) => {
          // Calculate opacity based on hide value
          // const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className="collapse-header collapsed"
                data-bs-toggle="collapse"
                href={`#${ID}`}
                role="button"
                aria-expanded="false"
                aria-controls={`${ID}`}
              >
                <DropZone zone={`collapse-header`} />
                <div className="drop-icon">
                  <Svg name="collapsible-icon" />
                </div>
              </div>

              <div className="collapse-body collapse" id={`${ID}`}>
                <DropZone zone={`collapse-body`} />
              </div>
            </>
          );
        },
      },

      Collapsible2: {
        render: function FrontendCollapsible({ itemId, headerText }) {
          // Props:
          // - itemId: The unique ID for this collapsible.
          // - headerText: The custom header text from admin, if provided.
          // - zones: Object containing content from DropZones (e.g., zones.content).

          const collapseRef = React.useRef(null);
          const buttonRef = React.useRef(null);

          // Function to determine the initial button text
          const getInitialButtonText = () => {
            if (headerText) {
              // If a specific header text is provided, always use it
              return headerText;
            }
            // Otherwise, default to "Show Details" as it starts collapsed on frontend
            return "Show Details";
          };

          const [currentButtonText, setCurrentButtonText] = React.useState(
            getInitialButtonText()
          );

          React.useEffect(() => {
            const collapsibleElement = collapseRef.current;
            const triggerButton = buttonRef.current;

            if (!collapsibleElement || !triggerButton) {
              return; // Exit if refs are not yet set
            }

            const updateTextBasedOnState = () => {
              if (headerText) {
                // If a specific headerText is provided, always use that
                setCurrentButtonText(headerText);
                return;
              }
              // Check if the collapsible element has the 'show' class (is open)
              if (collapsibleElement.classList.contains("show")) {
                setCurrentButtonText("Hide Details");
              } else {
                setCurrentButtonText("Show Details");
              }
            };

            // Bootstrap event listeners to update text after animations complete
            const handleShown = () => updateTextBasedOnState();
            const handleHidden = () => updateTextBasedOnState();

            collapsibleElement.addEventListener(
              "shown.bs.collapse",
              handleShown
            );
            collapsibleElement.addEventListener(
              "hidden.bs.collapse",
              handleHidden
            );

            // Initial text update in case the component mounts in an unexpected state
            // or if 'show' class was somehow added initially by other means.
            updateTextBasedOnState();

            // Cleanup: remove event listeners when the component unmounts or dependencies change
            return () => {
              collapsibleElement.removeEventListener(
                "shown.bs.collapse",
                handleShown
              );
              collapsibleElement.removeEventListener(
                "hidden.bs.collapse",
                handleHidden
              );
            };
          }, [itemId, headerText]); // Dependencies for the effect

          const collapseId = `collapse-${itemId}`; // Unique ID for the Bootstrap content div
          const headingId = `heading-${itemId}`; // Unique ID for the Bootstrap header

          // Frontend default: start collapsed. Bootstrap JS handles adding/removing 'show'.
          const collapseClasses = ["accordion-collapse", "collapse"];
          const initialAriaExpanded = "false";
          const initialButtonClassName = "accordion-button collapsed";

          return (
            <div className="accordion-item details-accordion">
              <h2 className="accordion-header" id={headingId}>
                <button
                  ref={buttonRef}
                  className={initialButtonClassName}
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#${collapseId}`}
                  aria-expanded={initialAriaExpanded}
                  aria-controls={collapseId}
                >
                  {currentButtonText}
                </button>
              </h2>
              <div
                ref={collapseRef}
                id={collapseId}
                className={collapseClasses.join(" ")}
                aria-labelledby={headingId}
              // If you implement accordion groups via a 'parentId' prop from admin:
              // data-bs-parent={props.parentId ? `#${props.parentId.replace(/^#/, '')}` : undefined}
              >
                <div className="accordion-body">
                  <DropZone zone="content" />
                </div>
              </div>
            </div>
          );
        },
      },

      IconUploader: {
        render: ({
          iconFile,
          iconFallbackUrl,
          iconWidth,
          iconHeight,
          puck,
        }) => {
          // Helper to prepare src for img tag (handles raw SVG and data URLs)
          const getDisplaySrc = (imgValue) => {
            if (
              typeof imgValue === "string" &&
              imgValue.trim().startsWith("<svg")
            ) {
              return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(
                imgValue
              )}`;
            }
            return imgValue; // Assumes it's already a data URL or external URL
          };

          const primarySrc = getDisplaySrc(iconFile);
          const fallbackSrc = getDisplaySrc(iconFallbackUrl); // Fallback could also be raw SVG

          const imgSrc = primarySrc || fallbackSrc;
          const displayWidth = iconWidth || 24;
          const displayHeight = iconHeight || 24;

          return (
            <div>
              {imgSrc ? (
                <img
                  src={imgSrc}
                  alt="Icon"
                  style={{
                    width: `${displayWidth}px`,
                    height: `${displayHeight}px`,
                    maxWidth: "100%",
                    maxHeight: "100%",
                    objectFit: "contain",
                    verticalAlign: "middle",
                  }}
                />
              ) : (
                puck &&
                puck.isEditing && (
                  <span style={{ fontSize: "10px", color: "#aaa" }}>
                    No Icon
                  </span>
                )
              )}
            </div>
          );
        },
      },

      ResultsPageHeader: {
        render: ({
          logo,
          hide,
          recalculateButton,
          contactUsButton,
          downloadButton,
          showRecalculateButton: legacyShowRec,
          showDownloadButton: legacyShowDown,
          contactUsButtonLink: legacyContactLink,
          recalculateButtonTitle: legacyRecTitle,
          contactUsButtonTitle: legacyContactTitle,
          downloadButtonTitle: legacyDownTitle,
        }) => {
          const inputOpacity = hide ? 0.5 : 1;

          const r = recalculateButton && typeof recalculateButton === "object" ? recalculateButton : null;
          const c = contactUsButton && typeof contactUsButton === "object" ? contactUsButton : null;
          const d = downloadButton && typeof downloadButton === "object" ? downloadButton : null;

          const showRecalculateButton =
            r && typeof r.show === "boolean"
              ? r.show
              : legacyShowRec != null
                ? legacyShowRec
                : true;
          const recText = r && r.title != null ? r.title : legacyRecTitle != null ? legacyRecTitle : "Recalculate";

          const contactUsButtonLink = c && c.link != null ? c.link : legacyContactLink;
          const contactText = c && c.title != null ? c.title : legacyContactTitle != null ? legacyContactTitle : "Contact Us";
          const showContactUsByToggle = !c || c.show !== false;
          const contactTextTrim = String(contactText != null ? contactText : "").trim();
          const contactLinkTrim = String(contactUsButtonLink != null ? contactUsButtonLink : "").trim();
          const showContactButton = showContactUsByToggle && contactTextTrim.length > 0 && contactLinkTrim.length > 0;

          const showDownloadButton =
            d && typeof d.show === "boolean"
              ? d.show
              : legacyShowDown != null
                ? legacyShowDown
                : true;
          const downloadText = d && d.title != null ? d.title : legacyDownTitle != null ? legacyDownTitle : "Download Report";

          const handleRecalculateClick = (event) => {
            // Find the icon element within the clicked button
            // This is a bit more direct DOM traversal
            const button = event.currentTarget;
            const iconDiv = button.querySelector(".icon"); // Assumes .icon is the direct child or descendant

            if (iconDiv) {
              // Check if animation is already running to prevent re-triggering too fast
              if (iconDiv.classList.contains("recalculate-icon-rotate")) {
                return;
              }

              iconDiv.classList.add("recalculate-icon-rotate");

              // Remove the class after animation completes
              setTimeout(() => {
                iconDiv.classList.remove("recalculate-icon-rotate");
              }, 500); // Must match your CSS animation duration (0.5s = 500ms)
            }

          };

          return (
            <div
              className={`roi-header-main`}
              style={{ opacity: inputOpacity }}
            >
              <div className="container">
                <div className="header-wrapper">
                  <a
                    href="#"
                    className="logo"
                    data-bs-toggle="modal"
                    data-bs-target="#logoPrompt"
                  >
                    {logo ? (
                      <img src={resolveMediaUrl(logo)} alt="" />
                    ) : (
                      <img src={logo_fallback} alt="" />
                    )}
                  </a>
                  <div className="flex-grow-1">
                    {(showDownloadButton || showRecalculateButton || showContactButton) && ( // Use && for cleaner conditional rendering
                      <div className="d-flex currency-language">
                        {showRecalculateButton && (
                          <button
                            type="button"
                            title={recText || "Recalculate"}
                            aria-label={recText || "Recalculate"}
                            className="d-inline-flex align-items-center btn roi-btn-outline-primary gap-3 px-3"
                            onClick={handleRecalculateClick}
                            data-bs-toggle="modal"
                            data-bs-target="#logoPrompt"
                          >
                            {recText && <span>{recText}</span>}
                            <div className="icon">
                              {/* This div will get the animation class */}
                              <Svg name="roi-recalculate-icon" />
                            </div>

                          </button>
                        )}

                        {showContactButton && (
                          <a target="_blank" rel="noreferrer" href={contactLinkTrim} className="d-inline-flex align-items-center btn roi-btn-outline-primary gap-3">
                            {contactTextTrim}
                          </a>
                        )}
                        {showDownloadButton && (

                          <button
                            type="button"
                            className={`d-inline-flex align-items-center btn roi-btn-primary gap-3 page-header-download-button`}
                            onClick={jumpToReport}
                            disabled={isLoadingdownload} // Disable button while loading
                            aria-label={isLoadingdownload ? "Downloading" : downloadText}
                          >
                            {isLoadingdownload ? (
                              <>
                                <span
                                  className="spinner-border spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                              </>
                            ) : (
                              <>
                                {downloadText}
                                <div className="icon">
                                  <Svg name="roi-download-icon" />
                                </div>
                              </>
                            )}

                          </button>

                        )}

                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          );
        },
      },
      Separator: {

        render: ({ color, height, margin }) => {
          return (
            <div className="separator" style={{ backgroundColor: color, height: `${height}px`, margin: `${margin?.top}px ${margin?.right}px ${margin?.bottom}px ${margin?.left}px` }}>

            </div>
          )
        },
      },
      DoubleBarChart: {
        render: ({ Title, SubTitle, SeriesAName, SeriesBName, Data, hide, LegendColor, LabelColor, TitleColor, SubTitleColor, TooltipTextColor, XAxisLabelColor, YAxisLabelColor }) => {
          const inputOpacity = hide ? 0.5 : 1;
          const safeData = Array.isArray(Data) ? Data : [];
          const categories = safeData.map((d) => (d && d.Label != null ? d.Label : ""));

          // Resolve numeric from variables if present, else fallback to provided value
          const getSlug = (label) =>
            (label || "")
              .toString()
              .trim()
              .replace(/\s+/g, "_")
              .replace(/[^a-zA-Z0-9_]/g, "")
              .toLowerCase();

          const resolveNumeric = (keys, fallback) => {
            for (const k of keys) {
              const v = roiActionArr_global.current?.[k]?.value;
              if (v !== undefined && v !== null && v !== "" && !isNaN(Number(v))) {
                return Number(v);
              }
            }
            return Number(fallback ?? 0);
          };

          const aData = safeData.map((d, idx) => {
            const labelText = (d && typeof d.Label === "string" && d.Label.trim()) ? d.Label.trim() : `Bar ${idx + 1}`;
            const slug = getSlug(labelText);
            const candidates = [
              `${slug}_first_bar_value`,
              d && d.SeriesAValueUuid,
              d && d.AUuid,
            ].filter(Boolean);
            return resolveNumeric(candidates, d && d.A);
          });

          const bData = safeData.map((d, idx) => {
            const labelText = (d && typeof d.Label === "string" && d.Label.trim()) ? d.Label.trim() : `Bar ${idx + 1}`;
            const slug = getSlug(labelText);
            const candidates = [
              `${slug}_second_bar_value`,
              slug,
              d && d.SeriesBValueUuid,
              d && d.BUuid,
            ].filter(Boolean);
            return resolveNumeric(candidates, d && d.B);
          });
          const seriesANameSafe = SeriesAName || "Series A";
          const seriesBNameSafe = SeriesBName || "Series B";

          const seriesNumericMax = Math.max(
            1,
            ...aData.map((x) =>
              Number.isFinite(Number(x)) ? Math.abs(Number(x)) : 0
            ),
            ...bData.map((x) =>
              Number.isFinite(Number(x)) ? Math.abs(Number(x)) : 0
            )
          );

          const formatYAxisLabel = (val) => {
            const num = Number(val);
            if (!Number.isFinite(num)) return "";
            const sym = "\u00A3";
            if (seriesNumericMax < 12000) {
              return sym + Math.round(num).toLocaleString(ROI_NUMBER_LOCALE);
            }
            const abs = Math.abs(num);
            if (abs >= 1_000_000) {
              const m = num / 1_000_000;
              return (
                sym +
                m.toLocaleString(ROI_NUMBER_LOCALE, {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: abs >= 10_000_000 ? 0 : 1,
                }) +
                "M"
              );
            }
            if (abs >= 1000) {
              const k = num / 1000;
              return (
                sym +
                k.toLocaleString(ROI_NUMBER_LOCALE, {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: seriesNumericMax < 500_000 ? 1 : 0,
                }) +
                "K"
              );
            }
            return sym + Math.round(num).toLocaleString(ROI_NUMBER_LOCALE);
          };

          const option = {
            backgroundColor: "transparent",
            title: { show: false },
            tooltip: {
              show: false,
              trigger: "axis",
              axisPointer: { type: "shadow" },
              backgroundColor: "#FFFFFF",
              borderColor: "rgba(0,0,0,0.1)",
              textStyle: { color: TooltipTextColor || "#000000" },
              formatter: (params) => {
                if (!Array.isArray(params) || params.length === 0) return "";
                const safeParams = params.filter(Boolean);
                if (safeParams.length === 0) return "";
                const fmtGbp = (n) => {
                  const num = Number(n);
                  if (!Number.isFinite(num)) return "";
                  return `\u00A3${Math.round(num).toLocaleString(ROI_NUMBER_LOCALE)}`;
                };
                // Figma spec: for a 2-series chart (DIY Build vs Partner Cost),
                // Series A renders its absolute £ value ("Current: £X"), and
                // Series B renders as a relative savings "(Y% lower)" against
                // Series A instead of the raw £ value. Falls back to absolute
                // £ when only one series is present or A <= 0.
                // Header rewrite: "Year N" -> "N Year Total Cost of Ownership"
                // so the tooltip matches the figma card title; the X-axis
                // keeps the short "Year N" label for legibility.
                const rawAxis = safeParams[0] && safeParams[0].axisValue != null ? String(safeParams[0].axisValue) : "";
                const yearMatch = rawAxis.match(/^Year\s+(\d+)$/i);
                const headerText = yearMatch ? `${yearMatch[1]} Year Total Cost of Ownership` : rawAxis;
                const lines = [headerText];
                const aVal = Number(safeParams[0] && safeParams[0].value);
                const isTwoSeries = safeParams.length >= 2 && Number.isFinite(aVal) && aVal > 0;
                safeParams.forEach((p, idx) => {
                  const val = Number(p && p.value);
                  const marker = (p && p.marker) ? p.marker : "";
                  const sName = (p && p.seriesName) ? p.seriesName : "";
                  let label;
                  if (isTwoSeries && idx === 1 && Number.isFinite(val)) {
                    const pctLower = Math.max(0, Math.round(((aVal - val) / aVal) * 100));
                    label = `${pctLower}% lower`;
                  } else {
                    label = Number.isFinite(val) ? fmtGbp(val) : (p && p.value != null ? p.value : "");
                  }
                  lines.push(`${marker} ${sName}: ${label}`);
                });
                return lines.join("<br/>");
              },
            },
            legend: { show: false },
            grid: { left: "2%", right: "2%", top: 16, bottom: 5, containLabel: true },
            xAxis: [
              {
                type: "category",
                data: categories,
                axisLine: { lineStyle: { color: "#B6B7B8" } },
                axisTick: { show: false },
                axisLabel: { color: XAxisLabelColor || "#000000", fontSize: 12 },
              },
            ],
            yAxis: [
              {
                type: "value",
                min: 0,
                splitNumber: seriesNumericMax < 12000 ? 6 : 8,
                axisLine: { show: true, lineStyle: { color: "#B6B7B8" } },
                axisTick: { show: false },
                axisLabel: { color: YAxisLabelColor || "#000000", fontSize: 12, formatter: formatYAxisLabel },
                splitLine: { show: false },
              },
            ],
            series: [
              {
                name: seriesANameSafe,
                type: "bar",
                barWidth: 52,
                barGap: "20%",
                itemStyle: {
                  borderRadius: [6, 6, 0, 0],
                  color: "#25282B",
                },
                emphasis: { itemStyle: { shadowBlur: 10, shadowColor: "rgba(37,40,43,0.55)", color: "#363a3e" } },
                label: { show: false },
                data: aData,
              },
              {
                name: seriesBNameSafe,
                type: "bar",
                barWidth: 52,
                itemStyle: {
                  borderRadius: [6, 6, 0, 0],
                  color: "#E60000",
                },
                emphasis: { itemStyle: { shadowBlur: 10, shadowColor: "rgba(230,0,0,0.45)", color: "#ff1a1a" } },
                label: { show: false },
                data: bData,
              },
            ],
          };

          return (
            <>
              <div style={{ opacity: inputOpacity }}>
                <div className="dbc-header">
                  <div className="dbc-header__text">
                    <div className="dbc-header__title" style={{ color: TitleColor || "#25282B" }}>
                      {Title}
                    </div>
                    <div className="dbc-header__subtitle" style={{ color: SubTitleColor || "#494C4E" }}>
                      {SubTitle}
                    </div>
                  </div>
                  <div className="dbc-header__legends">
                    <div className="dbc-header__legend-item">
                      <span className="dbc-header__legend-dot dbc-header__legend-dot--a" />
                      <span className="dbc-header__legend-label" style={{ color: LegendColor || "#494C4E" }}>{seriesANameSafe}</span>
                    </div>
                    <div className="dbc-header__legend-item">
                      <span className="dbc-header__legend-dot dbc-header__legend-dot--b" />
                      <span className="dbc-header__legend-label" style={{ color: LegendColor || "#494C4E" }}>{seriesBNameSafe}</span>
                    </div>
                  </div>
                </div>
                <div className="echart-wrapper">
                  <ReactEcharts
                    style={{ height: "215px", width: "100%" }}
                    option={option}
                    notMerge
                    lazyUpdate
                  />
                </div>
              </div>
            </>
          );
        },
      },

    },
  };

  //currency change
  const currencyChange = async (e) => {
    let currency_selected = e.target.value;
    let current_currency = "USD";
    let current_symbol = "$";
    let exchange_rate = 1;
    let calculated_arr_global = [];
    let updatedRoiActionArr = JSON.parse(JSON.stringify(roiActionArr_global.current));

    const response = await fetch(`${apiUrl}/roi-currency/list`);
    const result = await response.json();
    const res = result.data;

    Object.keys(res).map((key) => {
      if (res[key].currency_name == currency_selected) {
        current_currency = res[key].currency_name;
        exchange_rate = res[key].exchange_rate;
        current_symbol = res[key].symbol;
      }
    });
    // let currency_rate = currencyRates[currency_selected];
    let changedCurrency__ = changedCurrency ? changedCurrency : defaultCurrency;
    if (
      (changedCurrency__ == "USD" && changedCurrency__ != current_currency) ||
      (defaultCurrency == "USD" &&
        changedCurrency__ == "" &&
        current_currency != "USD")
    ) {
      await Object.keys(roiActionArr_global.current).map((key) => {
        if (
          roiActionArr_global.current[key].value != 0 &&
          key != "" &&
          typeof roiActionArr_global.current[key].value == "number" &&
          roiActionArr_global.current[key].currency == "1"
        ) {
          updatedRoiActionArr = {
            ...updatedRoiActionArr,
            [key]: {
              ...updatedRoiActionArr[key],
              value: parseFloat(updatedRoiActionArr[key].value * exchange_rate),
            },
          };
          // setRoiActionArr(updatedRoiActionArr);
          roiActionArr_global.current = updatedRoiActionArr;
          calculated_arr_global.push({
            variable: key,
            value: parseFloat(roiActionArr_global.current[key].value * exchange_rate).toFixed(
              2
            ),
          });
        } else if (
          roiActionArr_global.current[key].value != 0 &&
          typeof roiActionArr_global.current[key].value == "string" &&
          key != "" &&
          !isNaN(roiActionArr_global.current[key].value) &&
          roiActionArr_global.current[key].value !== "" &&
          roiActionArr_global.current[key].currency == "1"
        ) {
          updatedRoiActionArr = {
            ...updatedRoiActionArr,
            [key]: {
              ...updatedRoiActionArr[key],
              value: parseFloat(
                parseFloat(updatedRoiActionArr[key].value) * exchange_rate
              ),
            },
          };
          // setRoiActionArr(updatedRoiActionArr);
          roiActionArr_global.current = updatedRoiActionArr;
          calculated_arr_global.push({
            variable: key,
            value: parseFloat(
              parseFloat(roiActionArr_global.current[key].value) * exchange_rate
            ).toFixed(2),
          });
        }
      });
    }

    if (
      changedCurrency__ != "USD" &&
      changedCurrency__ != current_currency &&
      changedCurrency__ != ""
    ) {
      await Object.keys(roiActionArr_global.current).map((key) => {
        if (
          roiActionArr_global.current[key].value != 0 &&
          key != "" &&
          typeof roiActionArr_global.current[key].value == "number" &&
          roiActionArr_global.current[key].currency == "1"
        ) {
          updatedRoiActionArr = {
            ...updatedRoiActionArr,
            [key]: {
              ...updatedRoiActionArr[key],
              value:
                (updatedRoiActionArr[key].value / exchangeRate) * exchange_rate,
            },
          };
          // setRoiActionArr(updatedRoiActionArr);
          roiActionArr_global.current = updatedRoiActionArr;
          calculated_arr_global.push({
            variable: key,
            value: parseFloat(
              parseFloat(roiActionArr_global.current[key].value / exchangeRate) * exchange_rate
            ).toFixed(2),
          });
        } else if (
          roiActionArr_global.current[key].value != 0 &&
          typeof roiActionArr_global.current[key].value == "string" &&
          key != "" &&
          !isNaN(roiActionArr_global.current[key].value) &&
          roiActionArr_global.current[key].value !== "" &&
          roiActionArr_global.current[key].currency == "1"
        ) {
          updatedRoiActionArr = {
            ...updatedRoiActionArr,
            [key]: {
              ...updatedRoiActionArr[key],
              value: parseFloat(
                (parseFloat(updatedRoiActionArr[key].value) / exchangeRate) *
                exchange_rate
              ),
            },
          };
          // setRoiActionArr(updatedRoiActionArr);
          roiActionArr_global.current = updatedRoiActionArr;
          calculated_arr_global.push({
            variable: key,
            value: parseFloat(
              (parseFloat(roiActionArr_global.current[key].value) / exchangeRate) *
              exchange_rate
            ).toFixed(2),
          });
        }
      });
    }
    setChangedCurrency(current_currency);
    setCurrencySymbol(current_symbol);
    setExchangeRate(exchange_rate);

    //now create global array and pass it to update all uuid
    await updateValueForRenderAllPages(calculated_arr_global);
  };

  //redirect to home page
  const homeRedirect = () => {
    window.location.reload();
  };

  const [handleModalOpen, setHandleModalOpen] = useState(false);
  const changeModal = () => {
    setHandleModalOpen(true);
  };

  const sanitizeReportFileNamePart = (value, fallback = "") => {
    const cleaned = String(value || "")
      .trim()
      .replace(/[<>:"/\\|?*\u0000-\u001F]/g, "")
      .replace(/\s+/g, "_")
      .replace(/_+/g, "_")
      .replace(/^_|_$/g, "");
    return cleaned || fallback;
  };

  const captureUserDetailsReportSnapshot = () => {
    const { name, organisation } = readUserDetailsFormValuesFromDom();
    if (name || organisation) {
      userDetailsReportSnapshotRef.current = { name, organisation };
    }
  };

  const buildReportDownloadFileName = () => {
    let { name: displayName, organisation } = readUserDetailsFormValuesFromDom();

    if (!displayName && !organisation) {
      const snapshot = userDetailsReportSnapshotRef.current;
      displayName = snapshot?.name || "";
      organisation = snapshot?.organisation || "";
    } else {
      userDetailsReportSnapshotRef.current = { name: displayName, organisation };
    }

    // window.alert(
    //   `Report filename values:\nName: ${displayName || "(empty)"}\nOrganisation: ${organisation || "(empty)"}`
    // );

    const safeName = sanitizeReportFileNamePart(displayName, "User");
    const safeOrganisation = sanitizeReportFileNamePart(organisation, "Organisation");

    return `${safeName}_${safeOrganisation}_Device_Solution_Guide_Report`;
  };

  /** Shared by Download card, header, and puck actions (JumpToReport). Optional arg for button flow (form_assign_arr). */
  const jumpToReport = useCallback(async (_form_assign_arr) => {
    setIsLoadingdownload(true);
    try {
      const reportFileName = buildReportDownloadFileName();

      const submissionId = roiId;
      const currentDateTime = new Date().toISOString().slice(0, 19).replace("T", " ");

      const masterData = {
        roi_submitted_master_data_id: submissionId,
        roi_id: roiId,
        add_date_time: currentDateTime,
      };

      await axios.post(`${apiUrl}/roi-submit-data/createMaster`, masterData, {
        headers: { "Content-Type": "application/json" },
      });

      let data = JSON.stringify({
        roi_submitted_master_data_id: submissionId,
        structure: JSON.stringify(roiActionArr_global.current),
        currency_symbol: JSON.stringify({
          currencySymbol: currencySymbol,
          currency: currency,
        }),
        add_date_time: currentDateTime,
      });

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${apiUrl}/roi-submit-data/create`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      const response = await axios.request(config);

      const reportSubmissionId =
        response.data?.roi_submitted_data_id || submissionId;

      const generateUrl = `/roi/${roiId}/report/${reportSubmissionId}`;

      data = JSON.stringify({
        url: `${frntUrl}${generateUrl}`,
        reportname: reportFileName,
      });

      config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${apiUrl}/roi-pages/reportPageDownload`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
        responseType: "blob",
      };

      const pdfResponse = await axios.request(config);

      const url = window.URL.createObjectURL(new Blob([pdfResponse.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${reportFileName}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error in jumpToReport:", error);
    } finally {
      setIsLoadingdownload(false);
    }
  }, [roiId, currencySymbol, currency, apiUrl, frntUrl]);

  // Recursive function to get values by ID
  function getFormValuesById(container) {
    const result = {};

    function traverse(node) {
      if (node instanceof HTMLInputElement) {
        if (node.id) {
          if (node.type === 'checkbox') {
            result[node.id] = node.checked;
          } else if (node.type === 'radio') {
            if (node.checked) {
              result[node.id] = node.value;
            }
          } else {
            result[node.id] = node.value;
          }
        }
      } else if (node instanceof HTMLTextAreaElement) {
        if (node.id) {
          result[node.id] = node.value;
        }
      } else if (node instanceof HTMLSelectElement) {
        if (node.id) {
          if (node.multiple) {
            const selected = Array.from(node.selectedOptions).map(opt => opt.value);
            result[node.id] = selected;
          } else {
            result[node.id] = node.value;
          }
        }
      } else {
        Array.from(node.children).forEach(child => traverse(child));
      }
    }

    traverse(container);
    return result;
  }


  //for button or link
  const onButtonClick = async (uuid, place, cardLabel, clearSiblingUuids = []) => {
    //extracting form values from the page
    //condition added because handleChange is not working on button click
    const formValues = getFormValuesById(document.body);
    let form_assign_arr = {};

    //updating the roiActionArr with the form values
    //this is done because handleChange is not working on button click
    // Loop through form values and update roiActionArr
    let roiActionArr__ = JSON.parse(JSON.stringify(roiActionArr_global.current));
    Object.keys(formValues).forEach(async (elementId) => {
      if (
        elementId !== "" &&
        elementId !== undefined &&
        elementId !== null &&
        formValues[elementId] !== "" &&
        formValues[elementId] !== undefined &&
        formValues[elementId] !== null
      ) {
        // Only update if value has changed
        if (roiActionArr__[elementId] && roiActionArr__[elementId].value !== formValues[elementId]) {
          roiActionArr__ = {
            ...roiActionArr__,
            [elementId]: {
              ...roiActionArr__[elementId],
              value: formValues[elementId],
            },
          };
          //updating the calculated_arr_global with the new value
          form_assign_arr[elementId] = {
            'uuid': elementId,
            'value': formValues[elementId]
          };

        }

      }
    });

    // Clear sibling card values so only the selected card's label shows on the Review page
    clearSiblingUuids.forEach(siblingUuid => {
      if (siblingUuid && roiActionArr__[siblingUuid]) {
        roiActionArr__ = {
          ...roiActionArr__,
          [siblingUuid]: { ...roiActionArr__[siblingUuid], value: "" },
        };
        form_assign_arr[siblingUuid] = { uuid: siblingUuid, value: "" };
      }
    });

    // Strip HTML tags from card title so the review page shows plain text (no <br/> literals)
    const cleanLabel = cardLabel
      ? cardLabel.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim()
      : null;

    //for updating button is clicked
    const buttonValue = cleanLabel || 1;
    roiActionArr__ = {
      ...roiActionArr__,
      [uuid]: {
        ...roiActionArr__[uuid],
        value: buttonValue,
      },
    };

    console.log("buttonValue", buttonValue);
    form_assign_arr[uuid] = {
      'uuid': uuid,
      'value': buttonValue
    };

    // Update the state with the new object
    roiActionArr_global.current = roiActionArr__;
    captureUserDetailsReportSnapshot();

    if (roiActionArr_global.current[uuid].actions === "JumpToPage") {
      // console.log("JumpToPage UUID:", uuid);
      // console.log("JumpToPage action_id (buttonValue):", roiActionArr_global.current[uuid].action_id);
      // console.log("Which page id is jumping:", roiActionArr_global.current[uuid].action_id);
      // console.log("Full roiActionArr_global entry for this UUID:", roiActionArr_global.current[uuid]);
      // console.log("Expected UUID (98d19260-96e9-4915-8b9a-9d5196fa4b79):", uuid === "98d19260-96e9-4915-8b9a-9d5196fa4b79");
      jumpToPage(roiActionArr_global.current[uuid].action_id, form_assign_arr);
    } else if (roiActionArr_global.current[uuid].actions === "JumpToUrl") {
      // condition for jump to url
      let link = roiActionArr_global.current[uuid].link;
      window.open(link, "_blank");
    } else if (roiActionArr_global.current[uuid].actions === "OpenPopup") {
      //condition for jump to page
      openPopup(roiActionArr_global.current[uuid].action_id, form_assign_arr);
    } else if (roiActionArr_global.current[uuid].actions === "JumpToReport") {
      //condition for jump to page
      jumpToReport(form_assign_arr);
    }
  };

  // const jumpToReport = async () => {
  //   try {
  //   } catch (error) {
  //     console.error("Error with GET request:", error);
  //   }
  // };

  const jumpToPage =
    async (id, assign_arr) => {
      try {
        // console.log("id", id);
        let checkRequired = true;
        //logic to check if any field is in required check on full page on any button click
        const elements_by_page_id_current = elements_by_page_id.current[currentPageId.current] || [];
        const elements = Object.keys(roiActionArr_global.current);
        let error_messages = {};

        // Clear existing errors for all fields on current page when Next button is clicked
        const clearErrorMessages = {};
        for (let index = 0; index < elements.length; index++) {
          const element = elements[index];
          if (roiActionArr_global.current[element].roi_page_id == currentPageId.current) {
            clearErrorMessages[element] = {
              'uuid': element,
              'errorMessage': ""
            };
          }
        }

        // IMPORTANT: Process business logic first to get updated values
        // Then process conditional errors based on the updated values
        let process_arr = await processLogic();

        // Merge cleared error messages first
        error_messages = mergeUpdatesByUUID(error_messages, clearErrorMessages);

        let error_messages_conditional = await processConditionalError(elements_by_page_id_current);
        if (Object.keys(error_messages_conditional).length > 0) {
          for (const key of Object.keys(error_messages_conditional)) {
            if (error_messages_conditional[key].errorMessage == "") {
              delete error_messages_conditional[key];
            }
          }
          if (Object.keys(error_messages_conditional).length > 0) {
            error_messages = mergeUpdatesByUUID(error_messages, error_messages_conditional);
            checkRequired = false;
          }

        }


        for (let index = 0; index < elements.length; index++) {
          const element = elements[index];
          if (
            roiActionArr_global.current[element].roi_page_id != undefined &&
            roiActionArr_global.current[element].required == true &&
            roiActionArr_global.current[element].value == "" &&
            roiActionArr_global.current[element].roi_page_id == currentPageId.current &&
            // Checkbox groups (type "Checkbox") are validated via their items (type
            // "Checkbox Option") — skip the parent here to avoid false failures when
            // at least one item IS checked.
            roiActionArr_global.current[element].type !== "Checkbox"
          ) {
            let errorMessage = "Please enter a valid value";
            checkRequired = false;
            error_messages[element] = {
              'uuid': element,
              'errorMessage': errorMessage
            };

            // Also update the global state with the error message
            roiActionArr_global.current[element] = {
              ...roiActionArr_global.current[element],
              errorMessage: errorMessage
            };
          }
          if (
            roiActionArr_global.current[element].roi_page_id != undefined &&
            roiActionArr_global.current[element].required == true &&
            (roiActionArr_global.current[element].value == "" || roiActionArr_global.current[element].value == "0") &&
            roiActionArr_global.current[element].type == "Checkbox Option" &&
            roiActionArr_global.current[element].roi_page_id == currentPageId.current
          ) {
            let errorMessage = "To continue, you must agree to the terms and privacy policy.";
            checkRequired = false;
            error_messages[roiActionArr_global.current[element].checkbox_id] = {
              // pageId: currentPageId.current,
              'uuid': roiActionArr_global.current[element].checkbox_id,
              'errorMessage': errorMessage
            };

            // Also update the global state with the error message
            roiActionArr_global.current[element] = {
              ...roiActionArr_global.current[element],
              errorMessage: errorMessage
            };
          }
          if (
            roiActionArr_global.current[element].roi_page_id != undefined &&
            roiActionArr_global.current[element].required == true &&
            roiActionArr_global.current[element].value == 0 &&
            roiActionArr_global.current[element].type == "Radio" &&
            roiActionArr_global.current[element].roi_page_id == currentPageId.current
          ) {
            // console.log("element", element);
            let errorMessage = "Please select at least one option";
            checkRequired = false;
            error_messages[element] = {
              'uuid': element,
              'errorMessage': errorMessage
            };

            // Also update the global state with the error message
            roiActionArr_global.current[element] = {
              ...roiActionArr_global.current[element],
              errorMessage: errorMessage
            };
          }

          if (elements.length - 1 == index && !checkRequired) {
            renderChanges(assign_arr, error_messages, process_arr);
          }
          if (elements.length - 1 == index && checkRequired) {
            currentPageId.current = id;
            scrollAfterRender.current = true;
            renderChanges(assign_arr, error_messages, process_arr);
          }

        }

      } catch (error) {
        console.error("Error with GET request:", error);
      }
    };

  const openPopup = async (id) => {
    try {
      //setRenderModalData(JSON.parse(roipages[id]));

      setCurrentPopupPageId(id);
      setPopupStatus(true);
    } catch (error) {
      console.error("Error with GET request:", error);
    }
  };

  const refreshParentPage = async () => {
    setCurrentPopupPageId("");
    setPopupStatus(false);
  };


  const evaluateConditionError = (condition) => {
    let value = condition["value"] ?? "";
    const operator = condition["operator"] ?? "";
    const value_type = condition["value_type"] ?? "";
    if (value_type == "dynamic") {
      value = roiActionArr_global.current[value]?.value;
    }
    const variable = condition["variable"] ?? "";

    let return__ = false;
    if (roiActionArr_global.current[variable]?.value != undefined) {
      switch (operator) {
        case "==":
          if (roiActionArr_global.current[variable]?.value != undefined &&
            roiActionArr_global.current[variable]?.value != null &&
            roiActionArr_global.current[variable]?.value != ""
          ) {
            return__ = eval(parseFloat(roiActionArr_global.current[variable]?.value) == value);
          }
          break;
        case "!=":
          if (roiActionArr_global.current[variable]?.value != undefined &&
            roiActionArr_global.current[variable]?.value != null &&
            roiActionArr_global.current[variable]?.value != ""
          ) {
            return__ = eval(parseFloat(roiActionArr_global.current[variable]?.value) != value);
          }
          break;
        case ">":
          if (roiActionArr_global.current[variable]?.value != undefined &&
            roiActionArr_global.current[variable]?.value != null &&
            roiActionArr_global.current[variable]?.value != ""
          ) {
            return__ = eval(parseFloat(roiActionArr_global.current[variable]?.value) > value);
          }
          break;
        case "<":
          if (roiActionArr_global.current[variable]?.value != undefined &&
            roiActionArr_global.current[variable]?.value != null &&
            roiActionArr_global.current[variable]?.value != ""
          ) {
            return__ = eval(parseFloat(roiActionArr_global.current[variable]?.value) < value);
          }
          break;
        case ">=":
          if (roiActionArr_global.current[variable]?.value != undefined &&
            roiActionArr_global.current[variable]?.value != null &&
            roiActionArr_global.current[variable]?.value != ""
          ) {
            return__ = eval(parseFloat(roiActionArr_global.current[variable]?.value) >= value);
          }
          break;
        case "<=":
          if (roiActionArr_global.current[variable]?.value != undefined &&
            roiActionArr_global.current[variable]?.value != null &&
            roiActionArr_global.current[variable]?.value != ""
          ) {
            return__ = eval(parseFloat(roiActionArr_global.current[variable]?.value) <= value);
          }
          break;
        case "is empty":
          return__ = isEmpty(roiActionArr_global.current[variable].value);
          break;
        case "is not empty":
          if (roiActionArr_global.current[variable]?.value != undefined &&
            roiActionArr_global.current[variable]?.value != null &&
            roiActionArr_global.current[variable]?.value != ""
          ) {
            return__ = !isEmpty(roiActionArr_global.current[variable]?.value);
          }
          break;
        case "is":
          if (roiActionArr_global.current[variable]?.value != undefined &&
            roiActionArr_global.current[variable]?.value != null &&
            roiActionArr_global.current[variable]?.value != ""
          ) {
            return__ = eval(roiActionArr_global.current[variable]?.value === value);
          }
          break;
        case "is not":
          if (roiActionArr_global.current[variable]?.value != undefined &&
            roiActionArr_global.current[variable]?.value != null &&
            roiActionArr_global.current[variable]?.value != ""
          ) {
            return__ = eval(roiActionArr_global.current[variable]?.value !== value);
          }
          break;
        case "contains":
          if (roiActionArr_global.current[variable]?.value != undefined &&
            roiActionArr_global.current[variable]?.value != null &&
            roiActionArr_global.current[variable]?.value != ""
          ) {
            return__ = roiActionArr_global.current[variable]?.value.includes(value);
          }
          break;
        case "does not contain":
          if (roiActionArr_global.current[variable]?.value != undefined &&
            roiActionArr_global.current[variable]?.value != null &&
            roiActionArr_global.current[variable]?.value != ""
          ) {
            return__ = !roiActionArr_global.current[variable]?.value.includes(value);
          }
          break;
        case "starts with":
          if (roiActionArr_global.current[variable]?.value != undefined &&
            roiActionArr_global.current[variable]?.value != null &&
            roiActionArr_global.current[variable]?.value != ""
          ) {
            return__ = roiActionArr_global.current[variable]?.value.startsWith(value);
          }
          break;
        case "does not start with":
          if (roiActionArr_global.current[variable]?.value != undefined &&
            roiActionArr_global.current[variable]?.value != null &&
            roiActionArr_global.current[variable]?.value != ""
          ) {
            return__ = !roiActionArr_global.current[variable]?.value.startsWith(value);
          }
          break;
        case "ends with":
          if (roiActionArr_global.current[variable]?.value != undefined &&
            roiActionArr_global.current[variable]?.value != null &&
            roiActionArr_global.current[variable]?.value != ""
          ) {
            return__ = roiActionArr_global.current[variable]?.value.endsWith(value);
          }
          break;
        case "does not end with":
          if (roiActionArr_global.current[variable]?.value != undefined &&
            roiActionArr_global.current[variable]?.value != null &&
            roiActionArr_global.current[variable]?.value != ""
          ) {
            return__ = !roiActionArr_global.current[variable]?.value.endsWith(value);
          }
          break;
        default:
          return__ = false;
      }
    }
    return return__;
  };

  const evaluateCondition = (condition) => {
    // Validate input condition
    if (!condition || typeof condition !== 'object') {
      console.warn('evaluateCondition: Invalid condition object:', condition);
      return false;
    }

    let value = condition["value"] ?? "";
    const operator = condition["operator"] ?? "";
    const value_type = condition["value_type"] ?? "";
    const variable_data_type = condition["variable_data_type"] ?? "text";

    if (value_type == "dynamic") {
      value = roiActionArr_global.current[value]?.value;
    }
    const variable = condition["variable"] ?? "";

    let return__ = false;
    if (roiActionArr_global.current[variable]?.value != undefined) {
      // Get the variable value and convert based on data type
      let variableValue = roiActionArr_global.current[variable]?.value;
      let compareValue = value;

      // Convert values based on variable_data_type
      if (variable_data_type === "number") {
        variableValue = parseFloat(variableValue) || 0;
        compareValue = parseFloat(compareValue) || 0;
      }

      console.log(`  %c[Condition] ${variable}: "${variableValue}" ${operator} "${compareValue}" [${variable_data_type}]`, "color: #9E9E9E");

      switch (operator) {
        case "==":
          if (variable_data_type === "number") {
            return__ = variableValue === compareValue;
          } else {
            return__ = variableValue == compareValue;
          }
          break;
        case "!=":
          if (variable_data_type === "number") {
            return__ = variableValue !== compareValue;
          } else {
            return__ = variableValue != compareValue;
          }
          break;
        case ">":
          if (variable_data_type === "number") {
            return__ = variableValue > compareValue;
          } else {
            return__ = variableValue > compareValue;
          }
          break;
        case "<":
          if (variable_data_type === "number") {
            return__ = variableValue < compareValue;
          } else {
            return__ = variableValue < compareValue;
          }
          break;
        case ">=":
          if (variable_data_type === "number") {
            return__ = variableValue >= compareValue;
          } else {
            return__ = variableValue >= compareValue;
          }
          break;
        case "<=":
          if (variable_data_type === "number") {
            return__ = variableValue <= compareValue;
          } else {
            return__ = variableValue <= compareValue;
          }
          break;
        case "is empty":
          return__ = isEmpty(variableValue);
          break;
        case "is not empty":
          return__ = !isEmpty(variableValue);
          break;
        case "is":
          return__ = variableValue === compareValue;
          break;
        case "is not":
          return__ = variableValue !== compareValue;
          break;
        case "contains":
          return__ = String(variableValue).includes(String(compareValue));
          break;
        case "does not contain":
          return__ = !String(variableValue).includes(String(compareValue));
          break;
        case "starts with":
          return__ = String(variableValue).startsWith(String(compareValue));
          break;
        case "does not start with":
          return__ = !String(variableValue).startsWith(String(compareValue));
          break;
        case "ends with":
          return__ = String(variableValue).endsWith(String(compareValue));
          break;
        case "does not end with":
          return__ = !String(variableValue).endsWith(String(compareValue));
          break;
        default:
          return__ = false;
      }

      // console.log(`Condition result: ${return__}`);
    }
    return return__;
  };

  const isEmpty = (value) => {
    return (
      value === null || // check for null
      value === undefined || // check for undefined
      value === "" || // check for empty string
      (Array.isArray(value) && value.length === 0) || // check for empty array
      (typeof value === "object" &&
        value !== null &&
        Object.keys(value).length === 0) // check for empty object
    );
  };

  //function to return error messages for conditional logics getting true for show_error action
  // This function handles both showing and clearing error messages based on conditional logic
  // 
  // EXECUTION ORDER: This function MUST be called AFTER processLogic() to ensure
  // it evaluates conditions based on the most up-to-date values from business logic.
  // 
  // IMPORTANT: Page re-rendering is considered by:
  // 1. Using for...of loops instead of async forEach to ensure proper execution order
  // 2. Preserving error states during re-renders via renderChanges function
  // 3. Synchronizing error states between global state and error_messages collection
  // 4. Only clearing errors when necessary to prevent unnecessary state updates
  const processConditionalError = async (page_elements) => {
    let error_messages = {};
    let logics = allCondtionalLogicData.current;

    // Safety check: ensure page_elements is defined and is an array
    if (!page_elements || !Array.isArray(page_elements)) {
      console.warn('processConditionalError: page_elements is undefined or not an array:', page_elements);
      return error_messages;
    }

    // Use for...of loops instead of forEach with async to ensure proper execution order
    for (const element of Object.keys(logics)) {
      for (const element1 of Object.keys(logics[element])) {
        const { when, when_and_or_operator, then } = logics[element][element1];

        let conditionResult = when_and_or_operator === "AND" ? true : false;

        for (const condition of when) {
          const result = evaluateConditionError(condition);
          if (when_and_or_operator === "AND") {
            conditionResult = conditionResult && result;
          } else {
            conditionResult = conditionResult || result;
          }
        }

        if (conditionResult) {
          for (const action of then) {
            const {
              action: type,
              value,
              variable,
              variable_data_type,
              operator: action_type,
              value_type,
              value_variable_selected_option
            } = action;
            if (page_elements.includes(variable)) {
              switch (type) {
                case "show_error":
                  let val_error = roiActionArr_global.current[value_variable_selected_option['value']]?.value;
                  let value__ = value.replace("#value#", val_error);

                  // Show error message when condition is true
                  roiActionArr_global.current[variable] = {
                    ...roiActionArr_global.current[variable],
                    errorMessage: value__,
                  };

                  error_messages[variable] = {
                    'uuid': variable,
                    'errorMessage': value__,
                  };

                  break;

                default:

              }
            }
          }
        }

        if (!conditionResult) {
          for (const action of then) {
            const {
              action: type,
              value,
              variable,
              variable_data_type,
              operator: action_type,
              value_type,
              value_variable_selected_option
            } = action;
            if (page_elements.includes(variable)) {
              switch (type) {
                case "show_error":
                  // Clear error message when condition is false
                  // Only clear if the element currently has an error message to prevent unnecessary updates
                  if (roiActionArr_global.current[variable]?.errorMessage) {
                    roiActionArr_global.current[variable] = {
                      ...roiActionArr_global.current[variable],
                      errorMessage: "",
                    };

                    error_messages[variable] = {
                      'uuid': variable,
                      'errorMessage': "",
                    };
                  }
                  break;

                default:

              }
            }
          }
        }
      }
    }

    // Ensure error states are properly synchronized between global state and error_messages
    // This prevents loss of error states during re-renders
    Object.keys(error_messages).forEach(uuid => {
      if (error_messages[uuid].errorMessage && !roiActionArr_global.current[uuid]?.errorMessage) {
        // If error_messages has an error but global state doesn't, sync it
        roiActionArr_global.current[uuid] = {
          ...roiActionArr_global.current[uuid],
          errorMessage: error_messages[uuid].errorMessage,
        };
      } else if (!error_messages[uuid].errorMessage && roiActionArr_global.current[uuid]?.errorMessage) {
        // If global state has an error but error_messages doesn't, sync it
        error_messages[uuid].errorMessage = roiActionArr_global.current[uuid].errorMessage;
      }
    });

    return error_messages;
  };

  function applyThenActions(thenArr, roiActionArr__, jumpToPage, rule, globalPrecisionBuffer = {}) {
    let calculated_arr = {};
    let updatedMap = { ...roiActionArr__ };
    // Precision buffer: stores full-precision floats for ALL calculated variables,
    // seeded from the global buffer so cross-rule precision is preserved.
    // This prevents toFixed(0) rounding from compounding across sequential arithmetic
    // steps within a rule AND across dependent rules (e.g. TOTAL_CUR reading HW_ANNUAL).
    const precisionBuffer = { ...globalPrecisionBuffer };

    for (const action of Object.keys(thenArr)) {
      const {
        action: type,
        value,
        variable,
        variable_data_type,
        operator: action_type,
        value_type,
        value_variable_selected_option,
      } = thenArr[action];

      const currentVal = updatedMap[variable]?.value;
      const currency = updatedMap[variable]?.currency;
      const hidden = updatedMap[variable]?.hide;

      if (!updatedMap[variable]) {
        console.warn(`Warning: Variable ${variable} not found in roiActionArr for action type ${type}`);
        continue;
      }

      // ----------------- CALCULATE ACTION -----------------
      if (type === "calculate") {
        const isNumber = variable_data_type === "number";

        // Get raw operand value (static or dynamic).
        // For dynamic sources, prefer the precision buffer so that a value calculated
        // earlier in THIS rule is read at full precision rather than as a rounded string.
        let rawOperand;
        if (value_type === "static") {
          rawOperand = value;
        } else {
          rawOperand = precisionBuffer[value] !== undefined
            ? String(precisionBuffer[value])
            : updatedMap?.[value]?.value;
        }

        // For assign: auto-detect if operand is numeric or string, handle each properly
        if (action_type === "assign") {
          // Skip if source is empty/undefined/null - preserve current value
          if (rawOperand === undefined || rawOperand === null || rawOperand === '') {
            console.log(`  %c[Calculate SKIP] ${variable}: source is empty (${rawOperand}), keeping current value "${currentVal}"`, "color: #FF9800");
            continue;
          }

          const numericCheck = parseFloat(rawOperand);
          const operandIsNumeric = !isNaN(numericCheck) && isFinite(rawOperand);

          let resultStr;
          if (operandIsNumeric) {
            // Keep full precision in buffer; only round the stored string value
            precisionBuffer[variable] = numericCheck;
            resultStr = numericCheck.toFixed(acceptDecimals ? 2 : 0);
          } else {
            delete precisionBuffer[variable];
            resultStr = String(rawOperand);
          }

          const allowUpdate = resultStr !== currentVal && currentVal !== undefined;
          if (allowUpdate) {
            console.log(`  %c[Calculate] ${variable}: ${currentVal} → ${resultStr} (assign, ${operandIsNumeric ? 'number' : 'string'}) [${variable_data_type}]`, "color: #E91E63");
          }
          if (allowUpdate && updatedMap[variable]) {
            updatedMap = {
              ...updatedMap,
              [variable]: { ...updatedMap[variable], value: resultStr },
            };
            calculated_arr[variable] = { ...calculated_arr[variable], value: resultStr };
          }

        } else {
          // For arithmetic operations: use precision buffer as base to avoid
          // reading back a previously-rounded intermediate string value.
          let base = precisionBuffer[variable] !== undefined
            ? precisionBuffer[variable]
            : (parseFloat(currentVal || "0") || 0);
          let operand = parseFloat(rawOperand || "0") || 0;

          let result;
          switch (action_type) {
            case "add":
              result = base + operand;
              break;
            case "subtract":
              result = base - operand;
              break;
            case "multiply":
              result = base * operand;
              break;
            case "divide":
              result = operand !== 0 ? base / operand : base;
              break;
            default:
              continue;
          }

          // Store full precision in buffer; write rounded string to updatedMap
          precisionBuffer[variable] = result;
          const resultStr = isNaN(result) ? "0" : parseFloat(result).toFixed(acceptDecimals ? 2 : 0);

          const allowUpdate = resultStr !== currentVal && currentVal !== undefined;
          if (allowUpdate) {
            console.log(`  %c[Calculate] ${variable}: ${currentVal} → ${resultStr} (${action_type} ${operand}) [${variable_data_type}]`, "color: #E91E63");
          }
          if (allowUpdate && updatedMap[variable]) {
            updatedMap = {
              ...updatedMap,
              [variable]: { ...updatedMap[variable], value: resultStr },
            };
            calculated_arr[variable] = { ...calculated_arr[variable], value: resultStr };
          }
        }
      }

      // ----------------- SHOW BLOCKS -----------------
      if (type === "show_blocks") {
        if (hidden !== "false" && updatedMap[variable]) {
          console.log(`  %c[ShowBlock] ${variable}: hidden → visible`, "color: #4CAF50");
          updatedMap = {
            ...updatedMap,
            [variable]: {
              ...updatedMap[variable],
              hide: "false",
            },
          };
          calculated_arr[variable] = {
            ...calculated_arr[variable],
            hide: "false"
          };
        }
      }

      // ----------------- HIDE BLOCKS -----------------
      if (type === "hide_blocks") {
        if (hidden !== "true" && updatedMap[variable]) {
          console.log(`  %c[HideBlock] ${variable}: visible → hidden`, "color: #FF5722");
          updatedMap = {
            ...updatedMap,
            [variable]: {
              ...updatedMap[variable],
              hide: "true",
            },
          };
          calculated_arr[variable] = {
            ...calculated_arr[variable],
            hide: "true"
          };
        }
      }

      // ----------------- JUMP TO PAGE -----------------
      if (type === "jump_to_page" && typeof jumpToPage === "function") {
        console.log(`  %c[JumpToPage] → ${value}`, "color: #2196F3");
        jumpToPage(value);
      }

      // (Skip "show_error", "disable_item", etc. by request)
    }

    return {
      updatedRoiActionArr: updatedMap,
      calculated_arr: calculated_arr,
      precisionBuffer: precisionBuffer,
    };
  }


  const processLogic = async (jumpToPage) => {
    let logics = allCondtionalLogicData.current;
    console.group("%c[ProcessLogic] START", "color: #2196F3; font-weight: bold");
    console.log("Total rules:", Object.keys(logics).length);
    let roiActionArr__ = JSON.parse(JSON.stringify(roiActionArr_global.current));

    let hasChanges = true;
    let calculated_arr_global = {};
    // Global precision buffer persists across all rules in this processLogic call,
    // so that dependent rules (e.g. TOTAL_CUR reading HW_ANNUAL) use full-precision
    // floats rather than already-rounded string values.
    let globalPrecisionBuffer = {};
    let count = 0;
    while (hasChanges) {
      hasChanges = false;

      for (const rule of Object.keys(logics)) {
        try {
          // Validate rule structure
          if (!logics[rule] || !Array.isArray(logics[rule]) || logics[rule].length === 0) {
            console.warn(`Rule ${rule}: Invalid rule structure:`, logics[rule]);
            continue;
          }

          const { when, when_and_or_operator, then } = logics[rule][0];

          // Validate that conditions exist and are properly structured
          if (!when || typeof when !== 'object') {
            console.warn(`Rule ${rule}: Invalid 'when' conditions structure:`, when);
            continue;
          }

          let conditionResult = when_and_or_operator === "AND" ? true : false;

          for (const condition of Object.keys(when)) {
            const result = evaluateCondition(when[condition], rule);

            if (when_and_or_operator === "AND") {
              conditionResult = conditionResult && result;
            } else {
              conditionResult = conditionResult || result;
            }
          }

          if (conditionResult) {
            console.group(`%c[Rule MATCHED] ${rule}`, "color: #4CAF50; font-weight: bold");
            console.log("Operator:", when_and_or_operator, "| Conditions:", when);
            console.log("Actions:", then);
            try {
              // Validate that 'then' actions exist and are properly structured
              if (!then || typeof then !== 'object') {
                console.warn(`Rule ${rule}: Invalid 'then' actions structure:`, then);
                console.groupEnd();
                continue;
              }

              const { updatedRoiActionArr, calculated_arr: localChanges, precisionBuffer: updatedBuffer } = applyThenActions(then, roiActionArr__, jumpToPage, rule, globalPrecisionBuffer);
              // Merge this rule's precision results back into the global buffer
              Object.assign(globalPrecisionBuffer, updatedBuffer);

              for (const key of Object.keys(localChanges)) {
                // Safety check: ensure both objects exist and have the expected structure
                if (roiActionArr__[key] && localChanges[key] &&
                  localChanges[key].value !== undefined &&
                  roiActionArr__[key].value !== undefined &&
                  localChanges[key].value == roiActionArr__[key].value) {
                  delete localChanges[key];
                }
              }

              if (Object.keys(localChanges).length > 0) {
                console.log("%cChanges applied:", "color: #FF9800", localChanges);
                roiActionArr__ = updatedRoiActionArr;
                calculated_arr_global = { ...calculated_arr_global, ...localChanges };
                hasChanges = true;
              } else {
                console.log("No effective changes (values unchanged)");
              }
            } catch (error) {
              console.error(`Error processing actions for rule ${rule}:`, error);
            }
            console.groupEnd();
          }
        } catch (error) {
          console.error(`Error processing rule ${rule}:`, error);
        }
      }
      count++;
      if (count > 10) {
        console.warn("Maximum iterations (10) reached, stopping logic processing");
        hasChanges = false;
      }
    }

    console.log(`Iterations: ${count} | Total changes:`, calculated_arr_global);
    console.groupEnd();

    // Update the global array with calculated values
    roiActionArr_global.current = roiActionArr__;

    return calculated_arr_global;
  };


  function debounce(func, delay) {
    let timer;
    return function (...args) {
      const context = this; // Capture context if needed (useful for non-arrow functions)
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(context, args);
      }, delay);
    };
  }


  //need to change
  const updateValueByUuid =
    async (pageUuid, elementUuid, newValue) => {
      // Function to traverse and update the page data
      let level = 0;
      const traverseAndUpdate = async (data) => {
        if (Array.isArray(data)) {
          const results = await Promise.all(
            data.map((item) => traverseAndUpdate(item))
          );
          return results;
        } else if (data !== null && typeof data === "object") {
          const newObj = {};
          for (const key of Object.keys(data)) {
            if (data.hasOwnProperty("Cell1Data")) {
              // Check if the object has the key 'Cell1Data' for table data
              const value = data[key];
              let check_digit = 0;
              if (value == elementUuid) {
                const regex = /(\d+)/;
                const digit = key.match(regex);
                newObj["Cell" + digit[0] + "Data"] = newValue;
                newObj["Cell" + digit[0] + "uuid"] = value;
                check_digit = digit[0];
              } else if (value != elementUuid) {
                if (check_digit != 0 && key == "Cell" + check_digit + "Data") {
                } else {
                  newObj[key] = value;
                }
              }
            } else {

              const value = data[key];
              if (key === "uuid" && value === elementUuid && data.hasOwnProperty("value")) {
                newObj[key] = value; // keep uuid the same
                newObj["value"] = newValue; // update the value
                newObj["errorMessage"] = "";
                if (data.hasOwnProperty("errorMessage")) {
                  roiActionArr_global.current[elementUuid]["errorMessage"] = "";
                }
              } else if ((key !== "errorMessage" && key !== "value" && data["uuid"] == elementUuid) || data["uuid"] != elementUuid) {
                level++;
                if (typeof value === "object") {
                  newObj[key] = await traverseAndUpdate(value);
                } else {
                  // FIX: Only update value for the item with matching UUID
                  // This ensures each checkbox option is checked/unchecked independently
                  if (key === "Option" && data["uuid"] === elementUuid) {
                    newObj["value"] = newValue;
                  }
                  newObj[key] = value;
                }
              } else if (key === "value" && newObj["value"] === undefined) {
                newObj["value"] = data[key];
              }
            }
          }
          return newObj;
        } else {
          return data;
        }
      };

      // Only update the specific page
      if (roipages.current.hasOwnProperty(pageUuid)) {
        let pagedata = JSON.parse(JSON.stringify(roipages.current));
        const updatedPage = await traverseAndUpdate(
          JSON.parse(pagedata[pageUuid])
        );
        roipages.current = {
          ...roipages.current,
          [pageUuid]: JSON.stringify(updatedPage), // Update only the specific page
        }
        renderChanges(1);
      }
    };

  //need to change
  const updateValueForRenderAllPages =

    async (calculated_arr_global) => {

      if (calculated_arr_global.length > 0) {
        // Function to traverse and update the page data
        let level = 0;
        const traverseAndUpdate = async (
          data,
          calculated_arr_global,
          pageUuid
        ) => {
          if (Array.isArray(data)) {
            const results = await Promise.all(
              data.map((item) =>
                traverseAndUpdate(item, calculated_arr_global, pageUuid)
              )
            );
            return results;
          } else if (data !== null && typeof data === "object") {

            const newObj = {};
            for (const key of Object.keys(data)) {

              if (data.hasOwnProperty("Cell1Data")) {
                // Check if the object has the key 'Cell1Data' for table data
                const value = data[key];
                let check__ = false;
                let check_digit = 0;
                // await Object.keys(calculated_arr_global).forEach(
                //   async (element) => {
                //     if (value == calculated_arr_global[element].variable) {
                //       const regex = /(\d+)/;
                //       const digit = key.match(regex);
                //       newObj["Cell" + digit[0] + "Data"] =
                //         calculated_arr_global[element].value;
                //       newObj["Cell" + digit[0] + "uuid"] = value;
                //       check_digit = digit[0];
                //       check__ = true;
                //     }
                //   }
                // );

                for (const element of Object.keys(calculated_arr_global)) {
                  if (value == calculated_arr_global[element].variable) {
                    const regex = /(\d+)/;
                    const digit = key.match(regex);
                    newObj["Cell" + digit[0] + "Data"] =
                      calculated_arr_global[element].value;
                    newObj["Cell" + digit[0] + "uuid"] = value;
                    check_digit = digit[0];
                    check__ = true;
                  }
                }

                if (check__ == false) {
                  // if (value != element.variable) {
                  if (check_digit != 0 && key == "Cell" + check_digit + "Data") {
                  } else {
                    newObj[key] = value;
                  }
                  // }
                }
              } else if (data.hasOwnProperty("Value1")) {
                // Check if the object has the key 'Cell1Data' for table data
                const value = data[key];
                let check__ = false;
                let check_digit = 0;
                // await Object.keys(calculated_arr_global).forEach(
                //   async (element) => {
                //     if (value == calculated_arr_global[element].variable) {
                //       const regex = /(\d+)/;
                //       const digit = key.match(regex);
                //       newObj["Value" + digit[0]] =
                //         calculated_arr_global[element].value;
                //       newObj["Value" + digit[0] + "uuid"] = value;
                //       check_digit = digit[0];
                //       check__ = true;
                //     }
                //   }
                // );

                for (const element of Object.keys(calculated_arr_global)) {
                  if (value == calculated_arr_global[element].variable) {
                    const regex = /(\d+)/;
                    const digit = key.match(regex);
                    newObj["Value" + digit[0]] =
                      calculated_arr_global[element].value;
                    newObj["Value" + digit[0] + "uuid"] = value;
                    check_digit = digit[0];
                    check__ = true;
                  }
                }

                if (check__ == false) {
                  // if (value != element.variable) {
                  if (check_digit != 0 && key == "Value" + check_digit) {
                  } else {
                    newObj[key] = value;
                  }
                  // }
                }
              } else {

                const value = data[key];
                let check__ = false;
                // await Object.keys(calculated_arr_global).forEach(
                //   async (element) => {
                //     if (
                //       key === "uuid" &&
                //       value === calculated_arr_global[element].variable &&
                //       data.hasOwnProperty("value")
                //     ) {
                //       newObj[key] = value; // keep uuid the same
                //       newObj["value"] = calculated_arr_global[element].value; // update the value
                //       check__ = true;
                //     }
                //   }
                // );

                for (const element of Object.keys(calculated_arr_global)) {
                  if (
                    key === "uuid" &&
                    value === calculated_arr_global[element].variable
                  ) {

                    if (data.hasOwnProperty("value")) {
                      newObj[key] = value; // keep uuid the same
                      newObj["value"] = calculated_arr_global[element].value; // update the value
                    }

                    // Fix: Check if hide property exists in calculated_arr_global, regardless of its value
                    if (data.hasOwnProperty('hide') && calculated_arr_global[element].hasOwnProperty('hide')) {
                      newObj[key] = value; // keep uuid the same
                      newObj["hide"] = calculated_arr_global[element]["hide"];
                    }
                    if (data.hasOwnProperty('errorMessage') && calculated_arr_global[element].hasOwnProperty('errorMessage')) {
                      newObj[key] = value; // keep uuid the same
                      newObj["errorMessage"] = calculated_arr_global[element]["errorMessage"];
                    }
                    check__ = true;
                  }
                }
                if (check__ == false) {
                  if (key !== "value" && key !== "hide" && key !== "errorMessage") { // Prevent overwriting hide property
                    if (typeof value === "object") {
                      newObj[key] = await traverseAndUpdate(
                        value,
                        calculated_arr_global,
                        pageUuid
                      );
                    } else {
                      newObj[key] = value;
                    }
                  } else if (key === "value" && newObj["value"] === undefined) {

                    newObj["value"] = data[key];

                  } else if (key === "hide" && !newObj.hasOwnProperty("hide")) {
                    // Only set hide from original data if it wasn't already set from calculated_arr_global
                    newObj["hide"] = data[key];
                  } else if (key === "errorMessage" && !newObj.hasOwnProperty("errorMessage")) {
                    // Only set errorMessage from original data if it wasn't already set from calculated_arr_global
                    newObj["errorMessage"] = data[key];
                  }
                }


              }
            }


            return newObj;
          } else {
            return data;
          }
        };

        // Only update the specific page
        let roipages__ = JSON.parse(JSON.stringify(roipages.current));
        // Object.keys(roipages__).forEach(async (pageUuid, index) => {
        //   let pagedata = JSON.parse(JSON.stringify(roipages__));

        //   let updatedPage = await traverseAndUpdate(
        //     JSON.parse(pagedata[pageUuid]),
        //     calculated_arr_global,
        //     pageUuid
        //   );

        //   roipages__[pageUuid] = JSON.stringify(updatedPage);
        //   if (index == Object.keys(roipages__).length - 1) {
        //     setRoipages(roipages__);

        //   }
        // });

        const pageUuids = Object.keys(roipages__);
        for (const pageUuid of pageUuids) {
          let pagedata = JSON.parse(JSON.stringify(roipages__));
          let updatedPage = await traverseAndUpdate(
            JSON.parse(pagedata[pageUuid]),
            calculated_arr_global,
            pageUuid
          );
          roipages__[pageUuid] = JSON.stringify(updatedPage);
        }
        roipages.current = roipages__;
        renderChanges(1);
      }

    };

  // Helper function to check if a field is likely numeric
  const isFieldNumeric = (uuid) => {
    const field = roiActionArr_global.current[uuid];
    if (!field) return false;

    // Check if the field has a numeric type indicator
    if (field.type === "number" || field.variable_data_type === "number") {
      return true;
    }

    // Check if current value is numeric
    if (field.value && !isNaN(parseFloat(field.value)) && isFinite(field.value)) {
      return true;
    }

    return false;
  };

  // Helper function to prevent negative values in numeric fields
  const preventNegativeInput = (uuid, key) => {
    if (key === '-' && isFieldNumeric(uuid)) {
      return false; // Prevent minus key
    }
    return true; // Allow other keys
  };

  // Helper function to prevent scroll and arrow key changes in numeric fields
  const preventScrollAndArrowKeys = (e) => {
    // Prevent arrow keys from changing the value
    if (e.type === 'keydown') {
      if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
        e.preventDefault();
        return false;
      }
    }

    return true;
  };

  // Helper function specifically for preventing mouse wheel scroll
  const preventWheelScroll = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    return false;
  };

  // Enhanced wheel event handler with passive: false
  const handleWheelEvent = (e) => {
    e.preventDefault();
    e.stopPropagation();
    return false;
  };

  // More aggressive wheel prevention
  const handleWheelPrevention = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    return false;
  };

  //for inputs type text
  const handleChange =
    async (uuid, e, required = false) => {
      const val = roiNormalizeCommaNumericInput(e.target.value);
      console.log('handleChange called with uuid:', uuid, 'value:', val);
      console.log('Current roiActionArr_global.current:', roiActionArr_global.current);

      // Check for negative values in numeric inputs
      // Only apply this validation if the field appears to be numeric
      // Use the helper function for consistency
      const isLikelyNumeric = () => {
        // First check using the helper function
        if (isFieldNumeric(uuid)) {
          return true;
        }

        // Additional check: if the new value without minus would be numeric
        const newValueWithoutMinus = roiParseNumericInputString(val).replace(/^-/, '');
        if (newValueWithoutMinus && !isNaN(parseFloat(newValueWithoutMinus)) && isFinite(newValueWithoutMinus)) {
          return true;
        }

        return false;
      };

      if (val.startsWith('-') && isLikelyNumeric()) {
        // Prevent negative values for numeric fields - set error message and return early
        let errorMessage = "Negative values are not allowed for this field";
        let error_messages = {};
        error_messages[uuid] = {
          'uuid': uuid,
          'errorMessage': errorMessage
        };

        // Update global state with error
        const updatedRoiActionArr = {
          ...roiActionArr_global.current,
          [uuid]: {
            ...roiActionArr_global.current[uuid],
            value: val, // Keep the negative value for display but show error
            errorMessage: errorMessage
          },
        };
        roiActionArr_global.current = updatedRoiActionArr;

        // Debug: Print current state
        console.log('roiActionArr_global.current:', roiActionArr_global.current);
        console.log('Current input value:', val);
        console.log('Is negative value?', val.startsWith('-'));

        let assign_arr = {}
        assign_arr[uuid] = {
          'uuid': uuid,
          'value': val
        };

        // Render changes with error message
        renderChanges(assign_arr, error_messages, {});
        return; // Exit early to prevent further processing
      }

      // Clear negative value error if it was previously set and user has removed the minus sign
      if (roiActionArr_global.current[uuid]?.errorMessage === "Negative values are not allowed for this field" &&
        !val.startsWith('-')) {
        // Clear the error message since user has removed the negative sign
        const updatedRoiActionArr = {
          ...roiActionArr_global.current,
          [uuid]: {
            ...roiActionArr_global.current[uuid],
            errorMessage: ""
          },
        };
        roiActionArr_global.current = updatedRoiActionArr;
      }

      if (val == "" && required == true) {
        // toast.error('Please enter a valid value');
        let errorMessage = "Please enter a valid value";
        let error_messages = {};
        error_messages[uuid] = {
          // pageId: currentPageId.current,
          'uuid': uuid,
          'errorMessage': errorMessage
        };


        const updatedRoiActionArr = {
          ...roiActionArr_global.current,
          [uuid]: {
            ...roiActionArr_global.current[uuid],
            value: "",
          },
        };
        // setRoiActionArr(updatedRoiActionArr);
        roiActionArr_global.current = updatedRoiActionArr;

        let assign_arr = {}
        assign_arr[uuid] = {
          'uuid': uuid,
          'value': ""
        };

        let process_arr = await processLogic();


        renderChanges(assign_arr, error_messages, process_arr);
      } else {
        if (
          uuid !== "" &&
          uuid !== undefined &&
          uuid !== null &&
          e !== "" &&
          e !== undefined &&
          e !== null
        ) {

          if (roiActionArr_global.current[uuid].value == val) {
            return;
          }

          const updatedRoiActionArr = {
            ...roiActionArr_global.current,
            [uuid]: {
              ...roiActionArr_global.current[uuid],
              value: val,
              errorMessage: "", // Clear any existing error message
            },
          };

          // setRoiActionArr(updatedRoiActionArr);
          roiActionArr_global.current = updatedRoiActionArr;

          let assign_arr = {};
          assign_arr[uuid] = {
            'uuid': uuid,
            'value': val
          };

          // console.log("=== TRIGGERING CONDITIONAL LOGIC AFTER INPUT CHANGE ===");
          // console.log("Input UUID:", uuid);
          // console.log("New value:", val);

          // IMPORTANT: Process business logic first to get updated values
          // Then process conditional errors based on the updated values
          let process_arr = await processLogic();

          const elements_by_page_id_current = elements_by_page_id.current[currentPageId.current] || [];
          let error_messages = {};

          error_messages[uuid] = {
            'uuid': uuid,
            'errorMessage': ""
          };

          let error_messages_conditional = await processConditionalError(elements_by_page_id_current);
          if (Object.keys(error_messages_conditional).length > 0) {
            error_messages = mergeUpdatesByUUID(error_messages, error_messages_conditional);
          }

          if (popupStatus == false) {
            renderChanges(assign_arr, error_messages, process_arr);
          }
          if (popupStatus == true) {
            renderChanges(assign_arr, error_messages, process_arr);
          }
        }
      }
    }

  //for checkbox
  const onCheckBoxClick =
    async (uuid) => {
      // Guard: Skip if UUID is empty or undefined
      if (!uuid || uuid === '' || uuid === undefined || uuid === null) {
        console.warn('onCheckBoxClick called with invalid UUID:', uuid);
        return;
      }

      // Guard: Check if the UUID exists in roiActionArr
      if (!roiActionArr_global.current[uuid]) {
        console.warn('onCheckBoxClick: UUID not found in roiActionArr:', uuid);
        return;
      }

      let value = roiActionArr_global.current[uuid].value;
      if (value == "1") {
        const updatedRoiActionArr = {
          ...roiActionArr_global.current,
          [uuid]: {
            ...roiActionArr_global.current[uuid],
            value: "0",
          },
        };
        value = "0";
        // setRoiActionArr(updatedRoiActionArr);
        roiActionArr_global.current = updatedRoiActionArr;
        await updateValueByUuid(currentPageId.current, uuid, value);
      } else {
        const updatedRoiActionArr = {
          ...roiActionArr_global.current,
          [uuid]: {
            ...roiActionArr_global.current[uuid],
            value: "1",
          },
        };
        value = "1";
        // setRoiActionArr(updatedRoiActionArr);
        roiActionArr_global.current = updatedRoiActionArr;
        await updateValueByUuid(currentPageId.current, uuid, value);
      }

      // Clear error for the parent checkbox group if it exists
      let error_messages = {};
      error_messages[uuid] = {
        'uuid': uuid,
        'errorMessage': ""
      };

      // Find the parent checkbox group by looking for elements with checkbox_id matching current uuid
      const elements = Object.keys(roiActionArr_global.current);
      for (let index = 0; index < elements.length; index++) {
        const element = elements[index];
        if (roiActionArr_global.current[element].checkbox_id === uuid &&
          roiActionArr_global.current[element].roi_page_id === currentPageId.current) {
          error_messages[roiActionArr_global.current[element].checkbox_id] = {
            'uuid': roiActionArr_global.current[element].checkbox_id,
            'errorMessage': ""
          };
          break;
        }
      }

      // IMPORTANT: Process business logic first to get updated values
      // Then process conditional errors based on the updated values
      let process_arr = await processLogic();

      const elements_by_page_id_current = elements_by_page_id.current[currentPageId.current] || [];
      let error_messages_conditional = await processConditionalError(elements_by_page_id_current);
      if (Object.keys(error_messages_conditional).length > 0) {
        error_messages = mergeUpdatesByUUID(error_messages, error_messages_conditional);
      }

      // Render changes with cleared error messages
      let assign_arr = {};
      assign_arr[uuid] = {
        'uuid': uuid,
        'value': value
      };

      renderChanges(assign_arr, error_messages, process_arr);
    };


  //for radio
  const onRadioClick =
    async (uuid, value) => {
      // Guard: Skip if UUID is empty or undefined
      if (!uuid || uuid === '' || uuid === undefined || uuid === null) {
        console.warn('onRadioClick called with invalid UUID:', uuid);
        return;
      }

      // Guard: Check if the UUID exists in roiActionArr
      if (!roiActionArr_global.current[uuid]) {
        console.warn('onRadioClick: UUID not found in roiActionArr:', uuid);
        return;
      }

      // Allow any value including '' (deselect) — only skip truly unset calls.
      // Also clear errorMessage in global state so renderChanges doesn't re-inject it.
      const updatedRoiActionArr = {
        ...roiActionArr_global.current,
        [uuid]: {
          ...roiActionArr_global.current[uuid],
          value: value,
          errorMessage: "",
        },
      };

      let assign_arr = {};
      assign_arr[uuid] = {
        'uuid': uuid,
        'value': value
      };

      let error_messages = {};
      error_messages[uuid] = {
        'uuid': uuid,
        'errorMessage': ""
      };

      // Also clear error for the parent radio group if it exists
      // Find the parent radio group by looking for elements with type "Radio" and same roi_page_id
      const elements = Object.keys(roiActionArr_global.current);
      for (let index = 0; index < elements.length; index++) {
        const element = elements[index];
        if (roiActionArr_global.current[element].type === "Radio" &&
          roiActionArr_global.current[element].roi_page_id === currentPageId.current) {
          error_messages[element] = {
            'uuid': element,
            'errorMessage': ""
          };
          break; // Only one radio group per page
        }
      }

      roiActionArr_global.current = updatedRoiActionArr;

      // IMPORTANT: Process business logic first to get updated values
      // Then process conditional errors based on the updated values
      let process_arr = await processLogic();

      const elements_by_page_id_current = elements_by_page_id.current[currentPageId.current] || [];
      let error_messages_conditional = await processConditionalError(elements_by_page_id_current);
      if (Object.keys(error_messages_conditional).length > 0) {
        error_messages = mergeUpdatesByUUID(error_messages, error_messages_conditional);
      }

      renderChanges(assign_arr, error_messages, process_arr);
    };

  // For option selector
  const onOptionSelectorChange = async (uuid, value) => {
    // Guard: Skip if UUID is empty or undefined
    if (!uuid || uuid === '' || uuid === undefined || uuid === null) {
      console.warn('onOptionSelectorChange called with invalid UUID:', uuid);
      return;
    }

    // Guard: Check if the UUID exists in roiActionArr
    if (!roiActionArr_global.current[uuid]) {
      console.warn('onOptionSelectorChange: UUID not found in roiActionArr:', uuid);
      return;
    }

    const rawStr = String(value);
    const normalized = roiNormalizeCommaNumericInput(rawStr);
    const valueToStore =
      /^-?\d+(\.\d+)?$/.test(normalized) || normalized === '' ? normalized : rawStr;

    const updatedRoiActionArr = {
      ...roiActionArr_global.current,
      [uuid]: {
        ...roiActionArr_global.current[uuid],
        value: valueToStore,
        errorMessage: "",
      },
    };

    let assign_arr = {};
    assign_arr[uuid] = {
      'uuid': uuid,
      'value': valueToStore
    };

    let error_messages = {};
    error_messages[uuid] = {
      'uuid': uuid,
      'errorMessage': ""
    };

    roiActionArr_global.current = updatedRoiActionArr;

    // Process business logic
    let process_arr = await processLogic();

    const elements_by_page_id_current = elements_by_page_id.current[currentPageId.current] || [];
    let error_messages_conditional = await processConditionalError(elements_by_page_id_current);
    if (Object.keys(error_messages_conditional).length > 0) {
      error_messages = mergeUpdatesByUUID(error_messages, error_messages_conditional);
    }

    renderChanges(assign_arr, error_messages, process_arr);
  };

  // For range slider
  const onRangeChange = async (uuid, value) => {
    // Guard: Skip if UUID is empty or undefined
    if (!uuid || uuid === '' || uuid === undefined || uuid === null) {
      console.warn('onRangeChange called with invalid UUID:', uuid);
      return;
    }

    // Guard: Check if the UUID exists in roiActionArr
    if (!roiActionArr_global.current[uuid]) {
      console.warn('onRangeChange: UUID not found in roiActionArr:', uuid);
      return;
    }

    // Clamp to minimum of 1 — never store 0 or negative
    const num = parseInt(roiParseNumericInputString(String(value)), 10);
    const safeValue = !Number.isFinite(num) || num < 1 ? 1 : num;

    const updatedRoiActionArr = {
      ...roiActionArr_global.current,
      [uuid]: {
        ...roiActionArr_global.current[uuid],
        value: safeValue.toString(),
      },
    };

    let assign_arr = {};
    assign_arr[uuid] = {
      'uuid': uuid,
      'value': safeValue.toString()
    };

    let error_messages = {};
    error_messages[uuid] = {
      'uuid': uuid,
      'errorMessage': ""
    };

    roiActionArr_global.current = updatedRoiActionArr;

    // Process business logic
    let process_arr = await processLogic();

    const elements_by_page_id_current = elements_by_page_id.current[currentPageId.current] || [];
    let error_messages_conditional = await processConditionalError(elements_by_page_id_current);
    if (Object.keys(error_messages_conditional).length > 0) {
      error_messages = mergeUpdatesByUUID(error_messages, error_messages_conditional);
    }

    renderChanges(assign_arr, error_messages, process_arr);
  };

  // Handle input focus to clear default '0' values and store focus for tab index
  const handleInputFocus = (e) => {
    const input = e.target;
    const fid = input.id;
    // Only clear if the value is exactly '0' (default value)
    if (input.value === '0') {
      input.value = '';
    } else if (fid && roiActionArr_global.current[fid] && isFieldNumeric(fid)) {
      const stripped = roiParseNumericInputString(String(input.value));
      if (/^-?\d+(\.\d+)?$/.test(stripped)) {
        input.value = stripped;
      }
    }
    // Store the focused input ID for tab index management
    setFocusedInputId(input.id);
  };

  // Handle input blur and restore focus after rerender
  const handleInputBlur = async (uuid, e, required = false) => {
    const input = e.target;
    if (uuid && roiActionArr_global.current[uuid] && isFieldNumeric(uuid)) {
      const raw = String(input.value);
      const stripped = roiParseNumericInputString(raw);
      if (/^-?\d+(\.\d+)?$/.test(stripped) || stripped === '') {
        input.value =
          stripped === '' ? '' : formatRoiFieldDisplayValue(stripped);
      }
    }
    const canonical = roiNormalizeCommaNumericInput(String(input.value));
    const event = { target: { value: canonical } };
    // Defer state update to next tick so browser can move focus naturally
    setTimeout(() => {
      handleChange(uuid, event, required);
    }, 0);
  };

  const handleDropdownChange =
    async (uuid, e) => {
      const changedArr = {
        ...changedDropdown,
        [uuid]: e.target.value,
      };
      setChangedDropdown(changedArr);

      const updatedRoiActionArr = {
        ...roiActionArr_global.current,
        [uuid]: {
          ...roiActionArr_global.current[uuid],
          value: e.target.value,
        },
      };
      // setRoiActionArr(updatedRoiActionArr);
      roiActionArr_global.current = updatedRoiActionArr;
      await updateValueByUuid(currentPageId.current, uuid, e.target.value);
    };

  const updateByUuidSmart = (data, uuid, updates) => {
    // console.log("data", data, "uuid", uuid, "updates", updates);

    // Guard: Skip updates if UUID is empty or undefined to prevent mass updates
    if (!uuid || uuid === '' || uuid === undefined || uuid === null) {
      return data;
    }

    if (Array.isArray(data)) {
      return data.map((item) => updateByUuidSmart(item, uuid, updates));
    } else if (data && typeof data === "object") {
      // Handle component props.uuid
      if (data?.props?.uuid === uuid) {
        return {
          ...data,
          props: {
            ...data.props,
            ...updates,
          },
        };
      }
      // Handle item.uuid (checkbox/radio options)
      else if (data.uuid === uuid) {
        return {
          ...data,
          ...updates,
        };
      }
      // Handle ReportTable/DownloadReportTable cell UUIDs (Cell1uuid, Cell2uuid, etc.)
      else if (data.Cell1uuid === uuid || data.Cell2uuid === uuid || data.Cell3uuid === uuid || data.Cell4uuid === uuid) {
        const newObj = { ...data };
        // Find which cell matches and update its data
        for (let i = 1; i <= 4; i++) {
          if (data[`Cell${i}uuid`] === uuid && updates.value !== undefined) {
            newObj[`Cell${i}Data`] = updates.value;
            break;
          }
        }
        return newObj;
      }

      const newObj = {};
      for (const key in data) {
        newObj[key] = updateByUuidSmart(data[key], uuid, updates);
      }
      return newObj;
    }
    return data;
  }

  function applyUpdatesToAllPages(pages, updateArray) {
    const updatedPages = { ...pages };
    // console.log("pages", pages, "updateArray", updateArray);
    for (const uuid of Object.keys(updateArray)) {
      const updates = updateArray[uuid];
      // console.log("updates", updates);
      for (const pageId in updatedPages) {
        // console.log("pageId", pageId);
        const pageDataString = updatedPages[pageId];
        if (!pageDataString || pageDataString === "undefined" || typeof pageDataString !== 'string') {
          console.warn('Invalid page data in applyUpdatesToAllPages:', pageId, 'Data:', pageDataString);
          continue;
        }

        let pageData;
        try {
          pageData = JSON.parse(pageDataString);
        } catch (error) {
          console.error('Error parsing page data in applyUpdatesToAllPages:', error, 'PageId:', pageId, 'Data:', pageDataString);
          continue;
        }

        const updatedPage = updateByUuidSmart(pageData, uuid, updates);

        if (updatedPage !== pageData) {
          updatedPages[pageId] = JSON.stringify(updatedPage);
        }
      }
    }

    return updatedPages;
  }

  const initialRender = () => {
    if (currentPageId.current !== '' && currentPageId.current !== undefined && currentPageId.current !== null) {
      const pageDataString = roipages.current[currentPageId.current];
      if (pageDataString && pageDataString !== "undefined" && typeof pageDataString === 'string') {
        try {
          setRenderData(JSON.parse(pageDataString));
        } catch (error) {
          console.error('Error parsing page data in initialRender:', error, 'Data:', pageDataString);
          // Keep renderData as null instead of setting to empty object
          console.warn('Keeping renderData as null due to parsing error');
        }
      } else {
        console.warn('Invalid page data in initialRender:', currentPageId.current, 'Data:', pageDataString);
        // Keep renderData as null instead of setting to empty object
        console.warn('Keeping renderData as null due to invalid page data');
      }
    }
  }

  // Function to render changes and trigger page updates
  // IMPORTANT: This function handles page re-rendering by preserving error states
  // to prevent loss of conditional error messages during React re-renders
  // 
  // Enhanced Features:
  // 1. Error message syncing from roiActionArr_global for consistency
  // 2. Bidirectional synchronization between global and local error states
  // 3. Priority-based error message resolution to prevent conflicts
  // 4. Preservation of existing error states during re-renders
  const renderChanges = (updates = {}, error_messages = {}, process_arr = {}) => {
    // console.log("updates", updates, "logicUpdates", error_messages, "process_arr", process_arr);

    // ── STEP 1 ─────────────────────────────────────────────────────────────
    // Auto-calculated fields: if process_arr gives a field a valid (non-empty,
    // non-zero) value, wipe its stale error from global state NOW — before the
    // sync block reads global state — so the sync never re-injects it.
    const processArrWithClearedErrors = { ...process_arr };
    Object.keys(process_arr).forEach(calcUuid => {
      const calcValue = process_arr[calcUuid]?.value;
      const hasStaleError = roiActionArr_global.current[calcUuid]?.errorMessage;
      if (hasStaleError && calcValue !== undefined && calcValue !== "" && calcValue != 0) {
        processArrWithClearedErrors[calcUuid] = { ...process_arr[calcUuid], errorMessage: "" };
        roiActionArr_global.current[calcUuid] = {
          ...roiActionArr_global.current[calcUuid],
          errorMessage: ""
        };
      }
    });

    // ── STEP 2 ─────────────────────────────────────────────────────────────
    // Build enhanced error messages by syncing global ↔ local state.
    // Key rule: if a uuid appears in error_messages with "" it means the caller
    // *explicitly* cleared the error — respect that and do NOT re-inject the
    // stale global error.
    const enhancedErrorMessages = { ...error_messages };

    Object.keys(roiActionArr_global.current).forEach(uuid => {
      const globalError = roiActionArr_global.current[uuid]?.errorMessage;
      const hasLocalEntry = uuid in enhancedErrorMessages;
      const localError = hasLocalEntry ? enhancedErrorMessages[uuid]?.errorMessage : undefined;

      if (globalError && !hasLocalEntry) {
        // No explicit local handling — preserve the global error in local
        enhancedErrorMessages[uuid] = {
          ...enhancedErrorMessages[uuid],
          uuid: uuid,
          errorMessage: globalError
        };
      } else if (globalError && hasLocalEntry && !localError) {
        // Caller explicitly cleared the error — sync the clear back to global state
        roiActionArr_global.current[uuid] = {
          ...roiActionArr_global.current[uuid],
          errorMessage: ""
        };
      } else if (localError && !globalError) {
        // New error raised locally — sync it to global state
        roiActionArr_global.current[uuid] = {
          ...roiActionArr_global.current[uuid],
          errorMessage: localError
        };
      } else if (globalError && localError && globalError !== localError) {
        // Both have errors but they differ — keep the non-generic one
        const priorityError = globalError !== "Please enter a valid value" ? globalError : localError;
        enhancedErrorMessages[uuid] = {
          ...enhancedErrorMessages[uuid],
          uuid: uuid,
          errorMessage: priorityError
        };
        roiActionArr_global.current[uuid] = {
          ...roiActionArr_global.current[uuid],
          errorMessage: priorityError
        };
      }
    });

    // ── STEP 3 ─────────────────────────────────────────────────────────────
    // Preserve existing errors from global state for fields not explicitly
    // handled by the caller (skip uuids already in error_messages).
    const preservedErrorStates = {};
    Object.keys(roiActionArr_global.current).forEach(uuid => {
      if (roiActionArr_global.current[uuid]?.errorMessage && !(uuid in error_messages)) {
        preservedErrorStates[uuid] = {
          errorMessage: roiActionArr_global.current[uuid].errorMessage
        };
      }
    });

    // ── STEP 4 ─────────────────────────────────────────────────────────────
    // Merge updates with enhanced error messages and preserved error states
    const mergedUpdates = mergeUpdatesByUUID(updates, processArrWithClearedErrors, enhancedErrorMessages, preservedErrorStates);
    // console.log("mergedUpdates", mergedUpdates);
    const updatedPages = applyUpdatesToAllPages(roipages.current, mergedUpdates);
    roipages.current = updatedPages;
    // console.log("updatedPages", currentPageId.current);
    const currentPageData = updatedPages[currentPageId.current];
    if (currentPageData && currentPageData !== "undefined" && typeof currentPageData === 'string') {
      try {
        setRenderData(JSON.parse(currentPageData));
      } catch (error) {
        console.error('Error parsing page data:', error, 'Data:', currentPageData);
        // Keep current renderData instead of setting to empty object
        console.warn('Keeping current renderData due to parsing error');
      }
    } else {
      console.warn('Invalid page data for current page:', currentPageId.current, 'Data:', currentPageData);
      // Keep current renderData instead of setting to empty object
      console.warn('Keeping current renderData due to invalid page data');
    }

    // Update stacked bar charts after rendering changes
    if (window.updateStackedBarChart) {
      Object.keys(window.updateStackedBarChart).forEach(chartUuid => {
        try {
          window.updateStackedBarChart[chartUuid]();
        } catch (e) {
          // Chart not yet mounted, ignore
        }
      });
    }

    // Save scroll position before re-render so non-navigation renders can restore it
    if (!scrollAfterRender.current) {
      savedScrollY.current = window.scrollY;
    }

  };

  function mergeUpdatesByUUID(...updateObjects) {
    const merged = {};

    for (const updateObj of updateObjects) {
      for (const uuid in updateObj) {
        if (!merged[uuid]) merged[uuid] = {};
        merged[uuid] = {
          ...merged[uuid],
          ...updateObj[uuid], // merge inner keys like value, errorMessage, etc.
        };
      }
    }

    return merged;
  }

  useEffect(() => {

    if (
      currentPopupPageId !== "" &&
      roipages.current[currentPopupPageId] !== undefined &&
      popupStatus == true
    ) {
      setRenderModalData(JSON.parse(roipages.current[currentPopupPageId]));
    }

  }, [roipages.current, currentPageId, currentPopupPageId]);

  // After renderData updates: scroll to top on page navigation, restore position on value change
  useLayoutEffect(() => {
    if (!renderData) return;
    if (scrollAfterRender.current) {
      scrollAfterRender.current = false;
      window.scrollTo({ top: 0, behavior: "instant" });
    } else {
      window.scrollTo({ top: savedScrollY.current, behavior: "instant" });
    }
  }, [renderData]);

  // Restore focus after rerendering to maintain tab index functionality
  useEffect(() => {
    if (focusedInputId && renderData) {
      // Small delay to ensure DOM is fully rendered
      setTimeout(() => {
        const element = document.getElementById(focusedInputId);
        if (element) {
          element.focus();
        }
      }, 50);
    }
  }, [renderData, focusedInputId]);

  // Prevent wheel scroll on number inputs
  useEffect(() => {
    const handleWheelOnNumberInputs = (e) => {
      if (e.target.type === 'number') {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
      }
    };

    // Add multiple event listeners to catch all wheel events
    document.addEventListener('wheel', handleWheelOnNumberInputs, { passive: false, capture: true });
    document.addEventListener('mousewheel', handleWheelOnNumberInputs, { passive: false, capture: true });
    document.addEventListener('DOMMouseScroll', handleWheelOnNumberInputs, { passive: false, capture: true });

    return () => {
      document.removeEventListener('wheel', handleWheelOnNumberInputs, { capture: true });
      document.removeEventListener('mousewheel', handleWheelOnNumberInputs, { capture: true });
      document.removeEventListener('DOMMouseScroll', handleWheelOnNumberInputs, { capture: true });
    };
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${apiUrl}/roi/getRoiDetail/${roiId}`);
        const data = await response.json();
        const res = data.data;

        setAcceptDecimals(res.accept_decimals);
        setIsIdPresent(res.is_active);
        setLanguage(res.default_language);
        setDefaultCurrency(JSON.parse(res.primary_currency)[0]);

        // setChangedCurrency(JSON.parse(res.primary_currency)[0])
        setCurrency(JSON.parse(res.additional_currency));
        // getting first strucuture api call

        const response1 = await fetch(`${apiUrl}/roi-currency/list`);
        const result1 = await response1.json();
        const res1 = result1.data;

        Object.keys(res1).map((key) => {
          if (res1[key].currency_name == JSON.parse(res.primary_currency)[0]) {
            setCurrencySymbol(res1[key].symbol);
            setLocale("en-US");
            setExchangeRate(res1[key].exchange_rate);
          }
        });

        try {
          const responseStructure = await fetch(
            `${apiUrl}/roi-pages/detail/${roiId}`
          );
          const dataStructure = await responseStructure.json();
          // setCurrentPageId(dataStructure.result?.[0]?.roi_page_id);
          currentPageId.current = dataStructure.result?.[0]?.roi_page_id;

          let data = dataStructure.result;
          if (Array.isArray(data)) {
            data = data.map((page) => ({
              ...page,
              structure: rewriteRoiAssetUrls(page.structure, apiUrl),
            }));
          }

          const parsedRenderData = JSON.parse(data?.[0]?.structure);
          let roi_content = {};
          let roi_global_arr = {};
          for (let i = 0; i < data.length; i++) {
            roi_content[data[i].roi_page_id] = data[i].structure;
            let data__ = JSON.parse(data[i].structure)["content"];
            Object.keys(data__).forEach((element, index) => {
              if (
                data__[element]?.type == "InputTextField" ||
                data__[element]?.type == "InputNumberField" ||
                data__[element]?.type == "Button" ||
                data__[element]?.type == "Wrapper " ||
                data__[element]?.type == "Range" ||
                data__[element]?.type == "OptionSelector"
              ) {
                Object.keys(data__[element]?.props).forEach(
                  (element2, index2) => {
                    if (data__[element]?.props?.uuid != undefined) {
                      roi_global_arr[data__[element]?.props?.uuid] = {};
                      roi_global_arr[data__[element]?.props?.uuid]["count"] = 0;
                      roi_global_arr[data__[element]?.props?.uuid]["type"] = data__[element]?.type ?? "";
                      roi_global_arr[data__[element]?.props?.uuid]["actions"] = data__[element]?.props?.buttonAction ?? "";
                      roi_global_arr[data__[element]?.props?.uuid]["action_id"] = data__[element]?.props?.PageList ?? "";
                      roi_global_arr[data__[element]?.props?.uuid]["link"] = data__[element]?.props?.buttonLink ?? "";
                      roi_global_arr[data__[element]?.props?.uuid]["value"] = data__[element]?.props?.value ?? data__[element]?.props?.defaultValue ?? "";
                      roi_global_arr[data__[element]?.props?.uuid]["default_value"] = data__[element]?.props?.default_value ?? data__[element]?.props?.defaultValue ?? "";
                      roi_global_arr[data__[element]?.props?.uuid]["hide"] = data__[element]?.props?.hide ?? "false";
                      roi_global_arr[data__[element]?.props?.uuid]["errorMessage"] = data__[element]?.props?.errorMessage ?? "";
                      roi_global_arr[data__[element]?.props?.uuid]["roi_page_id"] = data[i].roi_page_id;
                      roi_global_arr[data__[element]?.props?.uuid]["required"] = data__[element]?.props?.required ?? false;
                    }
                  }
                );
              } else {
                Object.keys(data__[element]?.props).forEach(
                  (element2, index2) => {
                    if (data__[element]?.props[element2].uuid != undefined) {
                      if (
                        element2 !== "image" &&
                        element2 !== "logo" &&
                        element2 !== "items" &&
                        element2 !== "id" &&
                        element2 !== "Padding" &&
                        element2 !== "Style"
                      ) {
                        roi_global_arr[data__[element]?.props[element2].uuid] = {};
                        roi_global_arr[data__[element]?.props[element2].uuid]["count"] = 0;
                        roi_global_arr[data__[element]?.props[element2].uuid]["actions"] = data__[element]?.props[element2].buttonAction ?? "";
                        roi_global_arr[data__[element]?.props[element2].uuid]["action_id"] = data__[element]?.props[element2].PageList ?? "";
                        roi_global_arr[data__[element]?.props[element2].uuid]["link"] = data__[element]?.props[element2].buttonLink ?? "";
                        roi_global_arr[data__[element]?.props[element2].uuid]["value"] = data__[element]?.props?.[element2]?.value ?? "";
                        roi_global_arr[data__[element]?.props[element2].uuid]["default_value"] = data__[element]?.props[element2].default_value ?? "";
                        roi_global_arr[data__[element]?.props[element2].uuid]["hide"] = data__[element]?.props[element2].hide ?? "false";
                        roi_global_arr[data__[element]?.props[element2].uuid]["errorMessage"] = data__[element]?.props[element2].errorMessage ?? "";
                        roi_global_arr[data__[element]?.props[element2].uuid]["roi_page_id"] = data[i].roi_page_id;
                      }
                    }
                  }
                );
              }
            });

            let data_zones__ = JSON.parse(data[i].structure)["zones"];
            Object.keys(data_zones__).forEach((element, index) => {
              Object.keys(data_zones__[element]).forEach(
                (element__, index__) => {
                  let data_element__ = data_zones__[element][element__];
                  if (data_element__?.props.uuid != undefined) {
                    if (
                      data_element__?.type === "InputTextField" ||
                      data_element__?.type === "InputNumberField" ||
                      data_element__?.type === "Dropdown" ||
                      data_element__?.type === "Button" ||
                      data_element__?.type === "Wrapper" ||
                      data_element__?.type === "Range" ||
                      data_element__?.type === "OptionSelector"
                    ) {
                      roi_global_arr[data_element__?.props.uuid] = {};
                      roi_global_arr[data_element__?.props.uuid]["currency"] = data_element__?.props.prefix == "currency" || data_element__?.props.prefix == "Currency" || data_element__?.props.Prefix == "Currency" || data_element__?.props.Prefix == "currency" ? "1" : "0";
                      roi_global_arr[data_element__?.props.uuid]["count"] = 0;
                      roi_global_arr[data_element__?.props.uuid]["required"] = data_element__?.props.required ?? false;
                      roi_global_arr[data_element__?.props.uuid]["type"] = data_element__?.type ?? "";
                      roi_global_arr[data_element__?.props.uuid]["actions"] = data_element__?.props.buttonAction ?? "";
                      roi_global_arr[data_element__?.props.uuid]["action_id"] = data_element__?.props.buttonValue ?? "";
                      roi_global_arr[data_element__?.props.uuid]["link"] = data_element__?.props.buttonLink ?? "";
                      roi_global_arr[data_element__?.props.uuid]["value"] = data_element__?.props?.value ?? data_element__?.props?.defaultValue ?? "";
                      roi_global_arr[data_element__?.props.uuid]["default_value"] = data_element__?.props.default_value ?? data_element__?.props?.defaultValue ?? "";
                      roi_global_arr[data_element__?.props.uuid]["roi_page_id"] = data[i].roi_page_id;
                      roi_global_arr[data_element__?.props.uuid]["hide"] = data_element__?.props.hide ?? "false";
                      roi_global_arr[data_element__?.props.uuid]["errorMessage"] = data_element__?.props.errorMessage ?? "";
                    }

                    if (data_element__?.type === "Checkbox") {
                      roi_global_arr[data_element__?.props?.uuid] = {};
                      roi_global_arr[data_element__?.props?.uuid]["count"] = 0;
                      roi_global_arr[data_element__?.props?.uuid]["required"] = data_element__?.props?.required ?? false;
                      roi_global_arr[data_element__?.props?.uuid]["type"] = "Checkbox";
                      roi_global_arr[data_element__?.props?.uuid]["actions"] = data_element__?.props?.buttonAction ?? "";
                      roi_global_arr[data_element__?.props?.uuid]["action_id"] = data_element__?.props?.buttonValue ?? "";
                      roi_global_arr[data_element__?.props?.uuid]["link"] = data_element__?.props?.buttonLink ?? "";
                      roi_global_arr[data_element__?.props?.uuid]["value"] = data_element__?.props?.value ?? "";
                      roi_global_arr[data_element__?.props?.uuid]["default_value"] = data_element__?.props?.default_value ?? "";
                      roi_global_arr[data_element__?.props?.uuid]["hide"] = data_element__?.props?.hide ?? "false";
                      roi_global_arr[data_element__?.props?.uuid]["errorMessage"] = data_element__?.props?.errorMessage ?? "";
                      roi_global_arr[data_element__?.props?.uuid]["roi_page_id"] = data[i].roi_page_id;

                      Object.keys(data_element__?.props?.items).forEach(
                        (element, index) => {
                          // Generate UUID if missing for checkbox item
                          let itemUuid = data_element__?.props?.items[element]?.uuid;
                          if (!itemUuid || itemUuid === '' || itemUuid === undefined) {
                            itemUuid = uuidv4();
                            // Update the item with the new UUID
                            if (data_element__?.props?.items[element]) {
                              data_element__.props.items[element].uuid = itemUuid;
                            }
                          }

                          if (itemUuid) {
                            roi_global_arr[itemUuid] = {};
                            roi_global_arr[itemUuid]["currency"] =
                              data_element__?.props?.items[element]?.prefix ==
                                "currency" ||
                                data_element__?.props?.items[element]?.prefix ==
                                "Currency" ||
                                data_element__?.props?.items[element]?.Prefix ==
                                "currency" ||
                                data_element__?.props?.items[element]?.Prefix ==
                                "Currency"
                                ? "1"
                                : "0";
                            roi_global_arr[itemUuid]["count"] = 0;
                            roi_global_arr[itemUuid]["required"] = data_element__?.props?.required ?? false;
                            roi_global_arr[itemUuid]["type"] = "Checkbox Option";
                            roi_global_arr[itemUuid]["actions"] = data_element__?.props?.items[element]?.buttonAction ?? "";
                            roi_global_arr[itemUuid]["action_id"] = data_element__?.props?.items[element]?.buttonValue ?? "";
                            roi_global_arr[itemUuid]["link"] = data_element__?.props?.items[element]?.buttonLink ?? "";
                            roi_global_arr[itemUuid]["value"] = data_element__?.props?.items[element]?.value ?? "";
                            roi_global_arr[itemUuid]["default_value"] = data_element__?.props?.items[element]?.default_value ?? "";
                            roi_global_arr[itemUuid]["hide"] = data_element__?.props?.items[element]?.hide ?? "false";
                            roi_global_arr[itemUuid]["errorMessage"] = data_element__?.props?.items[element]?.errorMessage ?? "";
                            roi_global_arr[itemUuid]["roi_page_id"] = data[i].roi_page_id;
                            roi_global_arr[itemUuid]["checkbox_id"] = data_element__?.props?.uuid;
                          }
                        }
                      );
                    }

                    if (data_element__?.type === "Radio") {
                      // Object.keys(data_element__?.props?.items).forEach(
                      //(element, index) => {
                      if (data_element__?.props?.uuid != undefined) {
                        // Get the default value from items based on defaultCheckedIndex.
                        // defaultCheckedIndex of -1 (or unset) means no option is pre-selected.
                        const radioItems = data_element__?.props?.items || [];
                        const _dci2 = data_element__?.props?.defaultCheckedIndex;
                        const defaultCheckedIdx = (_dci2 !== undefined && _dci2 !== null && _dci2 !== "" && parseInt(_dci2) >= 0)
                          ? parseInt(_dci2)
                          : -1;
                        const defaultItem = defaultCheckedIdx >= 0 ? radioItems[defaultCheckedIdx] : null;
                        // Get item value - use item.value if defined, otherwise use RadioOption as fallback
                        let radioDefaultValue = "";
                        if (defaultItem) {
                          if (defaultItem.value !== undefined && defaultItem.value !== null && defaultItem.value !== '') {
                            radioDefaultValue = defaultItem.value;
                          } else {
                            radioDefaultValue = defaultItem.RadioOption || `option${defaultCheckedIdx}`;
                          }
                        }

                        roi_global_arr[data_element__?.props?.uuid] = {};
                        roi_global_arr[data_element__?.props?.uuid]["currency"] =
                          data_element__?.props?.prefix ==
                            "currency" ||
                            data_element__?.props?.prefix ==
                            "Currency" ||
                            data_element__?.props?.Prefix ==
                            "currency" ||
                            data_element__?.props?.Prefix ==
                            "Currency"
                            ? "1"
                            : "0";
                        roi_global_arr[data_element__?.props?.uuid]["count"] = 0;
                        roi_global_arr[data_element__?.props?.uuid]["required"] = data_element__?.props?.required ?? false;
                        roi_global_arr[data_element__?.props?.uuid]["actions"] = data_element__?.props?.buttonAction ?? "";
                        roi_global_arr[data_element__?.props?.uuid]["action_id"] = data_element__?.props?.buttonValue ?? "";
                        roi_global_arr[data_element__?.props?.uuid]["link"] = data_element__?.props?.buttonLink ?? "";
                        roi_global_arr[data_element__?.props?.uuid]["value"] = radioDefaultValue;
                        roi_global_arr[data_element__?.props?.uuid]["default_value"] = data_element__?.props?.default_value ?? radioDefaultValue;
                        roi_global_arr[data_element__?.props?.uuid]["type"] = "Radio";
                        roi_global_arr[data_element__?.props?.uuid]["hide"] = data_element__?.props?.hide ?? "false";
                        roi_global_arr[data_element__?.props?.uuid]["errorMessage"] = data_element__?.props?.errorMessage ?? "";
                        roi_global_arr[data_element__?.props?.uuid]["roi_page_id"] = data[i].roi_page_id;
                      }
                      //}
                      //);
                    }

                    // StackedBarChart - Register all segment UUIDs for calculation logic
                    if (data_element__?.type === "StackedBarChart") {
                      const segments = ['Segment1', 'Segment2', 'Segment3'];
                      const barTypes = ['bar1', 'bar2'];
                      const chartTitle = data_element__?.props?.ChartTitle?.title ?? "Stacked Bar Chart";

                      segments.forEach((segmentKey, segIdx) => {
                        const segment = data_element__?.props?.[segmentKey];
                        if (segment) {
                          barTypes.forEach((barType) => {
                            const uuidKey = `${barType}Uuid`;
                            const valueKey = `${barType}Value`;
                            const segmentUuid = segment[uuidKey];

                            if (segmentUuid) {
                              const labelPrefix = barType === 'bar1'
                                ? (data_element__?.props?.Bar1?.label || 'Bar 1')
                                : (data_element__?.props?.Bar2?.label || 'Bar 2');

                              roi_global_arr[segmentUuid] = {};
                              roi_global_arr[segmentUuid]["currency"] = "1";
                              roi_global_arr[segmentUuid]["count"] = 0;
                              roi_global_arr[segmentUuid]["required"] = false;
                              roi_global_arr[segmentUuid]["type"] = "StackedBarChart";
                              roi_global_arr[segmentUuid]["actions"] = "";
                              roi_global_arr[segmentUuid]["action_id"] = "";
                              roi_global_arr[segmentUuid]["link"] = "";
                              roi_global_arr[segmentUuid]["value"] = parseFloat(segment[valueKey]) || 0;
                              roi_global_arr[segmentUuid]["default_value"] = parseFloat(segment[valueKey]) || 0;
                              roi_global_arr[segmentUuid]["roi_page_id"] = data[i].roi_page_id;
                              roi_global_arr[segmentUuid]["hide"] = data_element__?.props?.hide ?? "false";
                              roi_global_arr[segmentUuid]["errorMessage"] = "";
                              roi_global_arr[segmentUuid]["text"] = `${chartTitle} - ${labelPrefix} - ${segment.name || `Segment ${segIdx + 1}`}`;
                            }
                          });
                        }
                      });

                      // Register savings text UUID if exists
                      const savingsTextUuid = data_element__?.props?.SavingsBadge?.textUuid;
                      if (savingsTextUuid) {
                        roi_global_arr[savingsTextUuid] = {};
                        roi_global_arr[savingsTextUuid]["currency"] = "0";
                        roi_global_arr[savingsTextUuid]["count"] = 0;
                        roi_global_arr[savingsTextUuid]["required"] = false;
                        roi_global_arr[savingsTextUuid]["type"] = "StackedBarChartText";
                        roi_global_arr[savingsTextUuid]["actions"] = "";
                        roi_global_arr[savingsTextUuid]["action_id"] = "";
                        roi_global_arr[savingsTextUuid]["link"] = "";
                        roi_global_arr[savingsTextUuid]["value"] = data_element__?.props?.SavingsBadge?.text || "";
                        roi_global_arr[savingsTextUuid]["default_value"] = data_element__?.props?.SavingsBadge?.text || "";
                        roi_global_arr[savingsTextUuid]["roi_page_id"] = data[i].roi_page_id;
                        roi_global_arr[savingsTextUuid]["hide"] = "false";
                        roi_global_arr[savingsTextUuid]["errorMessage"] = "";
                        roi_global_arr[savingsTextUuid]["text"] = `${chartTitle} - Savings Badge Text`;
                      }

                      // Register Y-axis max UUID if exists
                      const yAxisMaxUuid = data_element__?.props?.ChartSettings?.yAxisMaxUuid;
                      if (yAxisMaxUuid) {
                        roi_global_arr[yAxisMaxUuid] = {};
                        roi_global_arr[yAxisMaxUuid]["currency"] = "0";
                        roi_global_arr[yAxisMaxUuid]["count"] = 0;
                        roi_global_arr[yAxisMaxUuid]["required"] = false;
                        roi_global_arr[yAxisMaxUuid]["type"] = "StackedBarChartSetting";
                        roi_global_arr[yAxisMaxUuid]["actions"] = "";
                        roi_global_arr[yAxisMaxUuid]["action_id"] = "";
                        roi_global_arr[yAxisMaxUuid]["link"] = "";
                        roi_global_arr[yAxisMaxUuid]["value"] = parseFloat(data_element__?.props?.ChartSettings?.yAxisMax) || 250000;
                        roi_global_arr[yAxisMaxUuid]["default_value"] = parseFloat(data_element__?.props?.ChartSettings?.yAxisMax) || 250000;
                        roi_global_arr[yAxisMaxUuid]["roi_page_id"] = data[i].roi_page_id;
                        roi_global_arr[yAxisMaxUuid]["hide"] = "false";
                        roi_global_arr[yAxisMaxUuid]["errorMessage"] = "";
                        roi_global_arr[yAxisMaxUuid]["text"] = `${chartTitle} - Y-Axis Max`;
                      }
                    }
                  }
                  if (
                    data_element__?.props?.uuid == undefined &&
                    data_element__?.props?.items != undefined
                  ) {
                    Object.keys(data_element__?.props?.items).forEach(
                      (element, index) => {
                        if (
                          data_element__?.props?.items[element]?.uuid !=
                          undefined
                        ) {
                          //this will also work in case of button in card section

                          roi_global_arr[data_element__?.props?.items[element]?.uuid] = {};
                          roi_global_arr[data_element__?.props?.items[element]?.uuid]["currency"] = data_element__?.props?.items[element]?.prefix == "currency" || data_element__?.props?.items[element]?.prefix == "Currency" ? "1" : "0";
                          roi_global_arr[data_element__?.props?.items[element]?.uuid]["count"] = 0;
                          roi_global_arr[data_element__?.props?.items[element]?.uuid]["actions"] = data_element__?.props?.items[element]?.buttonAction ?? "";
                          roi_global_arr[data_element__?.props?.items[element]?.uuid]["action_id"] = data_element__?.props?.items[element]?.buttonValue ?? "";
                          roi_global_arr[data_element__?.props?.items[element]?.uuid]["link"] = data_element__?.props?.items[element]?.buttonLink ?? "";
                          roi_global_arr[data_element__?.props?.items[element]?.uuid]["value"] = data_element__?.props?.items[element]?.value ?? "";
                          roi_global_arr[data_element__?.props?.items[element]?.uuid]["default_value"] = data_element__?.props?.items[element]?.default_value ?? "";
                          roi_global_arr[data_element__?.props?.items[element]?.uuid]["hide"] = data_element__?.props?.items[element]?.hide ?? "false";
                          roi_global_arr[data_element__?.props?.items[element]?.uuid]["errorMessage"] = data_element__?.props?.items[element]?.errorMessage ?? "";
                          roi_global_arr[data_element__?.props?.items[element]?.uuid]["roi_page_id"] = data[i].roi_page_id;
                        }

                        if (
                          data_element__?.props?.items[element]?.uuid ==
                          undefined &&
                          (data_element__?.type === "DownloadReportTable" ||
                            data_element__?.type === "ReportTable")
                        ) {
                          Object.keys(
                            data_element__?.props?.items[element]
                          ).forEach((element_, index_) => {
                            let cols_count =
                              data_element__?.props?.Table.Columns;
                            // Use 'col' instead of 'i' to avoid variable shadowing with outer page loop
                            for (let col = 1; col <= cols_count; col++) {
                              if (
                                data_element__?.props?.items[element]?.["Cell" + col + "uuid"] != undefined
                              ) {
                                const cellUuid = data_element__?.props?.items[element]?.["Cell" + col + "uuid"];
                                roi_global_arr[cellUuid] = {};
                                roi_global_arr[cellUuid]["currency"] = data_element__?.props?.items[element]?.["Cell" + col + "EditStyle"] == "Currency" || data_element__?.props?.items[element]?.["Cell" + col + "EditStyle"] == "currency" ? "1" : "0";
                                roi_global_arr[cellUuid]["count"] = 0;
                                roi_global_arr[cellUuid]["type"] = "ReportTableCell";
                                roi_global_arr[cellUuid]["actions"] = data_element__?.props?.items[element]?.["Cell" + col + "Action"] ?? "";
                                roi_global_arr[cellUuid]["action_id"] = data_element__?.props?.items[element]?.["Cell" + col + "ActionId"] ?? "";
                                roi_global_arr[cellUuid]["link"] = "";
                                roi_global_arr[cellUuid]["value"] = data_element__?.props?.items[element]?.["Cell" + col + "Data"] ?? "";
                                roi_global_arr[cellUuid]["default_value"] = data_element__?.props?.items[element]?.["Cell" + col + "Data"] ?? "";
                                roi_global_arr[cellUuid]["hide"] = data_element__?.props?.items[element]?.["Cell" + col + "Hide"] ?? "false";
                                roi_global_arr[cellUuid]["errorMessage"] = data_element__?.props?.items[element]?.["Cell" + col + "Error"] ?? "";
                                roi_global_arr[cellUuid]["roi_page_id"] = data[i].roi_page_id;  // Now correctly uses outer loop 'i'
                              }
                            }
                          });
                        }

                        if (
                          data_element__?.props?.items[element]?.Value1 !=
                          undefined &&
                          data_element__?.type === "CardSection"
                        ) {
                          Object.keys(
                            data_element__?.props?.items[element]
                          ).forEach((element_, index_) => {
                            for (let i = 1; i <= 4; i++) {
                              if (
                                data_element__?.props?.items[element]?.["Value" + i + "uuid"] != undefined
                              ) {
                                roi_global_arr[data_element__?.props?.items[element]?.["Value" + i + "uuid"]] = {};
                                roi_global_arr[data_element__?.props?.items[element]?.["Value" + i + "uuid"]]["currency"] = "1";
                                roi_global_arr[data_element__?.props?.items[element]?.["Value" + i + "uuid"]]["count"] = 0;
                                roi_global_arr[data_element__?.props?.items[element]?.["Value" + i + "uuid"]]["actions"] = "";
                                roi_global_arr[data_element__?.props?.items[element]?.["Value" + i + "uuid"]]["action_id"] = "";
                                roi_global_arr[data_element__?.props?.items[element]?.["Value" + i + "uuid"]]["link"] = "";
                                roi_global_arr[data_element__?.props?.items[element]?.["Value" + i + "uuid"]]["value"] = data_element__?.props?.items[element]?.["Value" + i] ?? "";
                                roi_global_arr[data_element__?.props?.items[element]?.["Value" + i + "uuid"]]["default_value"] = "";
                                roi_global_arr[data_element__?.props?.items[element]?.["Value" + i + "uuid"]]["hide"] = data_element__?.props?.items[element]?.["Value" + i + "Hide"] ?? "false";
                                roi_global_arr[data_element__?.props?.items[element]?.["Value" + i + "uuid"]]["errorMessage"] = data_element__?.props?.items[element]?.["Value" + i + "Error"] ?? "";
                                roi_global_arr[data_element__?.props?.items[element]?.["Value" + i + "uuid"]]["roi_page_id"] = data[i].roi_page_id;
                              }
                            }
                          });
                        }
                      }
                    );
                  }

                  if (
                    data_element__?.props?.uuid == undefined &&
                    data_element__?.props?.items == undefined
                  ) {
                    if (data_element__?.type === "ResultCard") {
                      Object.keys(data_element__?.props).forEach(
                        (element, index) => {
                          if (
                            data_element__?.props?.[element]?.uuid != undefined
                          ) {
                            roi_global_arr[data_element__?.props?.[element]?.uuid] = {};
                            roi_global_arr[data_element__?.props?.[element]?.uuid]["currency"] = "1";
                            roi_global_arr[data_element__?.props?.[element]?.uuid]["count"] = 0;
                            roi_global_arr[data_element__?.props?.[element]?.uuid]["actions"] = data_element__?.props?.[element]?.buttonAction ?? "";
                            roi_global_arr[data_element__?.props?.[element]?.uuid]["action_id"] = data_element__?.props?.[element]?.buttonValue ?? "";
                            roi_global_arr[data_element__?.props?.[element]?.uuid]["link"] = data_element__?.props?.[element]?.buttonLink ?? "";
                            roi_global_arr[data_element__?.props?.[element]?.uuid]["value"] = data_element__?.props?.[element]?.value ?? "";
                            roi_global_arr[data_element__?.props?.[element]?.uuid]["default_value"] = data_element__?.props?.[element]?.default_value ?? "";
                            roi_global_arr[data_element__?.props?.[element]?.uuid]["hide"] = data_element__?.props?.[element]?.hide ?? "false";
                            roi_global_arr[data_element__?.props?.[element]?.uuid]["errorMessage"] = data_element__?.props?.[element]?.errorMessage ?? "";
                            roi_global_arr[data_element__?.props?.[element]?.uuid]["roi_page_id"] = data[i].roi_page_id;
                          }
                        }
                      );
                    }
                  }

                  if (data_element__?.type === "ChartCard" || data_element__?.type === "eCharts") {
                    let props = data_element__?.props;
                    Object.keys(props).forEach((element, index) => {
                      if (
                        props[element]?.uuid != undefined &&
                        (props[element]?.chooseChart == "pie" ||
                          props[element]?.chooseChart == "bar")
                      ) {
                        for (
                          let i = 0;
                          i < props[element]?.items?.length;
                          i++
                        ) {
                          roi_global_arr[props[element]?.items[i].uuid] = {};
                          roi_global_arr[props[element]?.items[i].uuid]["currency"] = "1";
                          roi_global_arr[props[element]?.items[i].uuid]["count"] = 0;
                          roi_global_arr[props[element]?.items[i].uuid]["actions"] = props[element]?.items[i].buttonAction ?? "";
                          roi_global_arr[props[element]?.items[i].uuid]["action_id"] = props[element]?.items[i].buttonValue ?? "";
                          roi_global_arr[props[element]?.items[i].uuid]["link"] = props[element]?.items[i].buttonLink ?? "";
                          roi_global_arr[props[element]?.items[i].uuid]["value"] = props[element]?.items[i].Data ?? "";
                          roi_global_arr[props[element]?.items[i].uuid]["default_value"] = props[element]?.items[i].default_value ?? "";
                          roi_global_arr[props[element]?.items[i].uuid]["hide"] = props[element]?.items[i].hide ?? "false";
                          roi_global_arr[props[element]?.items[i].uuid]["errorMessage"] = props[element]?.items[i].errorMessage ?? "";
                          roi_global_arr[props[element]?.items[i].uuid]["roi_page_id"] = data[i].roi_page_id;
                        }
                      }
                    });
                  }
                }
              );
            });
          }
          // console.log("=== DEBUG: roi_content (pages) ===");
          // console.log("Available page IDs:", Object.keys(roi_content));
          // console.log("Looking for page 5264b830-8237-11f0-ae7e-ed4b67a3e229:", roi_content["5264b830-8237-11f0-ae7e-ed4b67a3e229"]);
          roipages.current = roi_content;


          const responseCustomVariables = await fetch(
            `${apiUrl}/roi-custom-variables/list/${roiId}`
          );
          const dataCustomVariables = await responseCustomVariables.json();
          if (dataCustomVariables.result == "success") {
            let customVariablesArray = dataCustomVariables.data;
            for (let i = 0; i < customVariablesArray.length; i++) {
              roi_global_arr[customVariablesArray[i].roi_custom_variable_id] =
                {};
              roi_global_arr[customVariablesArray[i].roi_custom_variable_id]["currency"] = customVariablesArray[i].roi_custom_variable_type == "currency" ? "1" : "0";
              roi_global_arr[customVariablesArray[i].roi_custom_variable_id]["count"] = 0;
              roi_global_arr[customVariablesArray[i].roi_custom_variable_id]["actions"] = "";
              roi_global_arr[customVariablesArray[i].roi_custom_variable_id]["action_id"] = "";
              roi_global_arr[customVariablesArray[i].roi_custom_variable_id]["link"] = "";
              roi_global_arr[customVariablesArray[i].roi_custom_variable_id]["value"] = customVariablesArray[i].roi_custom_variable_value;
              roi_global_arr[customVariablesArray[i].roi_custom_variable_id]["default_value"] = "";
              roi_global_arr[customVariablesArray[i].roi_custom_variable_id]["hide"] = "false";
              roi_global_arr[customVariablesArray[i].roi_custom_variable_id]["errorMessage"] = "";
            }
          }

          // setRoiActionArr(roi_global_arr);
          // console.log("=== DEBUG: roi_global_arr before setting to roiActionArr_global ===");
          // console.log("Looking for UUID 5264b830-8237-11f0-ae7e-ed4b67a3e229:", roi_global_arr["5264b830-8237-11f0-ae7e-ed4b67a3e229"]);
          // console.log("All UUIDs in roi_global_arr:", Object.keys(roi_global_arr));
          roiActionArr_global.current = roi_global_arr;


          Object.keys(roi_global_arr).forEach((element, index) => {
            if (elements_by_page_id.current[roi_global_arr[element]["roi_page_id"]] === undefined) {
              elements_by_page_id.current[roi_global_arr[element]["roi_page_id"]] = [];
            }
            elements_by_page_id.current[roi_global_arr[element]["roi_page_id"]].push(element);
          });

          initialRender();
          setRenderData(parsedRenderData);
        } catch (error) {
          console.error(error);
        }

        // getting all condtional logic api call
        try {
          const conditionalLogics_response = await fetch(
            `${apiUrl}/roi-calculated-fields/list/${roiId}`
          );
          const json_conditionalLogics_response =
            await conditionalLogics_response.json();

          if (json_conditionalLogics_response.result == "success") {
            let data = json_conditionalLogics_response.data;

            const roiCalculationLogic = {};
            let count = 0;
            Object.keys(data).forEach((element, index) => {
              if (
                data[element].roi_calculation_logic != undefined &&
                data[element].roi_calculation_logic != null
              ) {
                const data__ = JSON.parse(data[element].roi_calculation_logic);

                if (data__["when"].length == 1) {
                  data__["when_and_or_operator"] = "";
                }

                if (
                  (data__["when"].length > 1 &&
                    data__["when_and_or_operator"] == undefined) ||
                  data__["when_and_or_operator"] == null
                ) {
                  data__["when_and_or_operator"] = "AND";
                }

                if (roiCalculationLogic[data[element].roi_calculated_field_id] === undefined) {
                  roiCalculationLogic[data[element].roi_calculated_field_id] = [];
                }

                data__["logic_name"] = data[element].roi_logic_name;

                roiCalculationLogic[data[element].roi_calculated_field_id].push(
                  data__
                );
                // count++;
                // }
              }
            });
            // setAllConditionalLogicData(roiCalculationLogic);
            allCondtionalLogicData.current = roiCalculationLogic;
          }
        } catch (error) {
          console.error(error);
        }

        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setIsLoading(false);
      }
    };
    fetchData();
  }, [apiUrl, roiId]);

  // Debounce function with useCallback
  // const debouncedOnChange = useMemo(
  //   () => debounce(handleChange, 1000),
  //   [handleChange]
  // );


  if (isLoading) {
    return (
      <div style={{
        position: "fixed",
        inset: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#fff",
        zIndex: 9999,
        gap: "20px",
      }}>
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"
          style={{ animation: "roi-spin 0.9s linear infinite" }}>
          <circle cx="24" cy="24" r="20" stroke="#f0f0f0" strokeWidth="4" />
          <path d="M24 4 A20 20 0 0 1 44 24" stroke="#E60000" strokeWidth="4" strokeLinecap="round" />
        </svg>
        <style>{`@keyframes roi-spin { to { transform: rotate(360deg); } }`}</style>
        <span style={{ color: "#666", fontSize: "15px", fontWeight: 500, letterSpacing: "0.3px" }}>
          Loading…
        </span>
      </div>
    );
  }

  const renderDataBlock = () => {
    return (
      <>
        <div style={{ minHeight: "100vh" }}>
          <Render config={config} data={renderData} />
        </div>

        <div
          className="modal fade logo-prompt"
          id="logoPrompt"
          tabIndex={-1}
          aria-labelledby="logoPromptLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <div className="heading">
                  <h3>Return to home page?</h3>
                  <p>You will have to complete the steps again.</p>
                </div>

                <div className="modal-buttons d-flex justify-content-end">
                  <button
                    type="button"
                    className="btn btn-bordered color-cancel"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary ms-3"
                    onClick={homeRedirect}
                  >
                    Confirm
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  const renderModalDataBlock = () => {
    return (
      <Render config={config} data={renderModalData} />
    );
  };

  // Helper function to parse HTML and replace dynamic spans
  const parseDynamicText = (htmlString) => {
    if (!htmlString || typeof htmlString !== 'string') {
      return htmlString;
    }

    try {
      // console.log('Parsing dynamic text:', htmlString);

      // Create a temporary DOM element to parse the HTML
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = htmlString;

      // Function to recursively process nodes and replace dynamic spans
      // Note: Multiple spans can use the same UUID to show the same value
      // React keys are made unique by appending random values
      const processNode = (node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          if (node.tagName.toLowerCase() === 'span' && node.getAttribute('uuid')) {
            const uuid = node.getAttribute('uuid');
            const style = node.getAttribute('style') || '';
            const className = node.getAttribute('class') || '';

            // Debug: Print the entire roiActionArr_global.current object
            // console.log('=== DEBUG: roiActionArr_global.current ===');
            // console.log('Full object:', roiActionArr_global.current);
            // console.log('Current UUID being processed:', uuid);
            // console.log('Value for this UUID:', roiActionArr_global.current[uuid]);
            // console.log('Value property:', roiActionArr_global.current[uuid]?.value);
            // console.log('==========================================');

            // Parse styles safely
            const parsedStyles = parseInlineStyles(style);

            // Ensure we have a valid style object
            const finalStyles = parsedStyles && typeof parsedStyles === 'object' ? parsedStyles : {};

            // Create a dynamic span component
            // Generate unique key for React while keeping the same UUID for value lookup
            const uniqueKey = `${uuid}-${Math.random()}`;

            return (
              <span
                key={uniqueKey}
                style={finalStyles}
                className={`dynamic-inline-span ${className || ''}`}
              >
                {formatRoiFieldDisplayValue(roiActionArr_global.current[uuid]?.value)}
              </span>
            );
          } else {
            // Process child nodes recursively
            const children = Array.from(node.childNodes).map((child, childIndex) =>
              processNode(child)
            );

            // Create a new element with the same tag and attributes
            const attributes = Array.from(node.attributes).reduce((attrs, attr) => {
              if (attr.name !== 'uuid') { // Don't pass uuid attribute
                if (attr.name === 'style') {
                  // Parse style attribute for all elements
                  const parsedStyles = parseInlineStyles(attr.value);
                  // console.log('Parsed styles for', node.tagName, ':', parsedStyles);
                  if (parsedStyles && typeof parsedStyles === 'object') {
                    attrs.style = parsedStyles;
                  }
                } else if (attr.name === 'class') {
                  // Convert class to className for React
                  attrs.className = attr.value;
                } else {
                  attrs[attr.name] = attr.value;
                }
              }
              return attrs;
            }, {});

            // console.log('Creating element with attributes:', attributes);

            const newElement = React.createElement(
              node.tagName.toLowerCase(),
              {
                key: `node-${Math.random()}`, // Use unique key instead of undefined index
                ...attributes
              },
              ...children
            );

            return newElement;
          }
        } else if (node.nodeType === Node.TEXT_NODE) {
          return node.textContent;
        }

        return null;
      };

      // Process all child nodes
      const processedChildren = Array.from(tempDiv.childNodes).map((child, index) =>
        processNode(child)
      );

      return processedChildren;
    } catch (error) {
      console.error('Error parsing dynamic text:', error);
      return htmlString; // Fallback to original text if parsing fails
    }
  };

  // Helper function to parse inline styles
  const parseInlineStyles = (styleString) => {
    if (!styleString || typeof styleString !== 'string') return {};

    try {
      // console.log('Parsing style string:', styleString);
      const styles = {};
      const stylePairs = styleString.split(';').filter(pair => pair.trim());

      stylePairs.forEach(pair => {
        const colonIndex = pair.indexOf(':');
        if (colonIndex > 0) {
          const property = pair.substring(0, colonIndex).trim();
          const value = pair.substring(colonIndex + 1).trim();

          if (property && value) {
            // Convert CSS property names to camelCase
            const camelProperty = property.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
            // Only add valid CSS properties
            if (camelProperty && value) {
              styles[camelProperty] = value;
              // console.log('Added style:', camelProperty, '=', value);
            }
          }
        }
      });

      // console.log('Final parsed styles:', styles);
      return styles;
    } catch (error) {
      console.error('Error parsing inline styles:', error);
      return {}; // Return empty object on error
    }
  };

  return (
    <>
      <ToastContainer />
      {renderData !== null && allCondtionalLogicData.current !== null ? (
        renderDataBlock()
      ) : (
        <div>Loading...</div>
      )}

      <div
        className="modal fade modal-report"
        id="reportModal"
        tabIndex={-1}
        aria-labelledby="reportModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content">
            {renderModalData !== null && allCondtionalLogicData.current !== null ? (
              renderModalDataBlock()
            ) : (
              <div>Loading...</div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ROIPage;
